/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// function quickviewSliders(){
//   // for quickview also
//   if(document.body.classList.contains("product-quickview") && document.body.clientWidth >= 768){
//     console.log("quickviewSliders>>>>>>>>>>>>>");
//     $('.icons.Grid.flickity-enabled').flickity('destroy');
//     // setTimeout(() => {
//     var flkty1 = $('.customise-popup:not(.hide) .tab-pane.active .icons.Grid, .customise-popup:not(.hide) .thread-color').flickity({
//         wrapAround: false,
//         pageDots: false,
//         groupCells: '3',
//         adaptiveHeight: false,
//         // initialIndex: 0,
//         contain: true,
//         cellAlign: "left",
//         prevNextButtons: true,
//         imagesLoaded: true,
//         autoPlay: false,
//         draggable: '>2'
//     });
//     // },2500);
//   }
// }

var attributeObjnew = {};
var customObjnewDefault = {};


function manageCustomize(){
  console.log("manageCustomize>>>>>>>>>>>>>>",);
 window.customiseUpdate = [];
 var attributeObj = [];
 var getUrlParameter = function getUrlParameter(sParam) {
 var sPageURL = window.location.search.substring(1),
     sURLVariables = sPageURL.split('&'),
     sParameterName,
     i;

 for (i = 0; i < sURLVariables.length; i++) {
   sParameterName = sURLVariables[i].split('=');

   if (sParameterName[0] === sParam) {
     return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
   }
 }
 return false;
};


localStorage.setItem("pdpurl", location.pathname);
 window.addEventListener("load", function(){
   var viewCustom = getUrlParameter('customisable');
   if(viewCustom){
     $('.customize-shirt').click();
     if (window.productInfo.product_vendor == "Korra") {
       document.querySelector('.get-pair').click();
     }
   }
 });


 // var designAttrs = atr ? atr['designAttributes'] : [];
var designAttrs = typeof atr != "undefined" ? atr['designAttributes'] : [];
$.each(designAttrs, function(index, value) {
// console.log("designAttrs",designAttrs[index].attributeName);
 
 var i = 0;
   var isLastElement = index == designAttrs.length -1;
   
     if(designAttrs[index].attributeName == 'Fabric Care'){
     $('.bscCare').html(designAttrs[index].values);
   }
   //if(designAttrs[index].values.length > 0){
   
  //  console.log(designAttrs[index].attributeName,"designAttrs[index].attributeName");
   
     if(designAttrs[index].attributeName == 'Collar Style'){
        var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Collar Style","values": [imgattr[0]]});
        attributeObj[0] = {"attributeName": "Collar Style","values": [imgattr[0]]};
      }
     
     if(designAttrs[index].attributeName == 'Collar Stiffness'){
          var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Collar Stiffness","values": [imgattr[i]]});
       attributeObj[1] = {"attributeName": "Collar Stiffness","values": [imgattr[i]]};
      //  console.log('nr1',attributeObj[1]);
      }
     
     if(designAttrs[index].attributeName == 'Collar Top Button'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Collar Top Button","values": [imgattr[i]]});
       attributeObj[2] = {"attributeName": "Collar Top Button","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Pocket'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Pocket","values": [imgattr[i]]});
       attributeObj[10] = {"attributeName": "Pocket","values": [imgattr[i]]}; 
      }
     if(designAttrs[index].attributeName == 'Placket'){
        var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Placket","values": [imgattr[i]]});
       attributeObj[11] = {"attributeName": "Placket","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Buttons'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Buttons","values": [imgattr[i]]});
       attributeObj[15] = {"attributeName": "Buttons","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Button Thread Color'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Button Thread Color","values": [imgattr[i]]});
       attributeObj[16] = {"attributeName": "Button Thread Color","values": [imgattr[i]]}; 
     }

     if(designAttrs[index].attributeName == 'Sleeves'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Sleeves","values": [imgattr[i]]});
       attributeObj[17] = {"attributeName": "Sleeves","values": [imgattr[i]]}; 
     }
     
     if(designAttrs[index].attributeName == 'Cuff Style'){
       var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Cuff Style","values": [imgattr[i]]});
       attributeObj[18] = {"attributeName": "Cuff Style","values": [imgattr[i]]};
      }
     
     if(designAttrs[index].attributeName == 'Cuff Stiffness'){
       var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Cuff Stiffness","values": [imgattr[i]]});
       attributeObj[19] = {"attributeName": "Cuff Stiffness","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Back'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Back","values": [imgattr[i]]});
       attributeObj[22] = {"attributeName": "Back","values": [imgattr[i]]};
     }
     
     if(designAttrs[index].attributeName == 'Bottom Cut'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Bottom Cut","values": [imgattr[i]]});
       attributeObj[23] = {"attributeName": "Bottom Cut","values": [imgattr[i]]};
     }
       if(designAttrs[index].attributeName == 'Shirt Length'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Bottom Cut","values": [imgattr[i]]});
       attributeObj[29] = {"attributeName": "Shirt Length","values": [imgattr[i]]};
       }
      if(designAttrs[index].attributeName == 'Placket Stay'){
        var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Placket Stay","values": [imgattr[i]]});
       attributeObj[30] = {"attributeName": "Placket Stay","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Stitching Thread Color'){
       var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Stitching Thread Color","values": [imgattr[i]]});
       attributeObj[31] = {"attributeName": "Stitching Thread Color","values": [imgattr[i]]};
     }
     /*-- Constrast Tabs --*/
     if(designAttrs[index].attributeName == 'Collar Contrast'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Collar Contrast","values": [imgattr[i]]});  
       attributeObj[3] = {"attributeName": "Collar Contrast","values": [imgattr[i]]};
     }
   if(designAttrs[index].attributeName == 'Collar Contrast Material'){
       if(designAttrs[index].values.length > 0){
         var collarattr = designAttrs[index].values;
         collarContrastDefault = collarattr[0];
         //attributeObj.push({"attributeName": "Collar Contrast Material","values": [collarContrastDefault]});
         attributeObj[4] = {"attributeName": "Collar Contrast Material","values": [collarContrastDefault]};
       } else {
         collarContrastDefault = '';
         //attributeObj.push({"attributeName": "Collar Contrast Material","values": ["None"]});
         attributeObj[4] = {"attributeName": "Collar Contrast Material","values": ["None"]};
       }
     }   
     if(designAttrs[index].attributeName == 'Collar Contrast Material Name'){
       if(designAttrs[index].values.length > 0){
         //attributeObj.push({"attributeName": "Collar Contrast Material Name","values": [designAttrs[index].values[0]]});


         var collarattr = designAttrs[index].values;
         collarContrastDefault = collarattr[0];

         attributeObj[5] = {"attributeName": "Collar Contrast Material Name","values": [collarContrastDefault]};
       } else {
         //attributeObj.push({"attributeName": "Collar Contrast Material Name","values": ["None"]});
         attributeObj[5] = {"attributeName": "Collar Contrast Material Name","values": ["None"]};
       }
     }   
   
     
     if(designAttrs[index].attributeName == 'Collar Piping'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Collar Piping","values": [imgattr[i]]});
     attributeObj[6] = {"attributeName": "Collar Piping","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Collar Inside Piping'){
       if(designAttrs[index].values.length > 0){
         var collarPipingattr = designAttrs[index].values;
         pipingContrastDefault = collarPipingattr[0];
         //attributeObj.push({"attributeName": "Collar Inside Piping","values": [pipingContrastDefault]});
         //attributeObj.push({"attributeName": "Collar Inside Piping Color","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Piping Color","values": ["None"]});
         attributeObj[7] = {"attributeName": "Collar Inside Piping","values": [pipingContrastDefault]};
         attributeObj[8] = {"attributeName": "Collar Inside Piping Color","values": ["None"]};
         attributeObj[9] = {"attributeName": "Collar Piping Color","values": ["None"]};
           
       } else {
         pipingContrastDefault = '';
         //attributeObj.push({"attributeName": "Collar Inside Piping","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Inside Piping Color","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Piping Color","values": ["None"]});
         attributeObj[7] = {"attributeName": "Collar Inside Piping","values": ["None"]};
         attributeObj[8] = {"attributeName": "Collar Inside Piping Color","values": ["None"]};
         attributeObj[9] = {"attributeName": "Collar Piping Color","values": ["None"]};
         
       }
     } 

       console.log(designAttrs[index].attributeName,"designAttrs[index].attributeName");

     if(designAttrs[index].attributeName == 'Placket Contrast'){
       var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Placket Contrast","values": [imgattr[i]]}); 
        attributeObj[12] = {"attributeName": "Placket Contrast","values": [imgattr[i]]};
      //  console.log(attributeObj[12],"attributeObj[12]");

      }
     if(designAttrs[index].attributeName == 'Placket Contrast Material'){
      // console.log("test PCM",designAttrs[index].attributeName);
      //  console.log(attributeObj[12],"attributeObj[12]");
      
         if(designAttrs[index].values.length > 0){
        var placketContrastattr = designAttrs[index].values;
         placketContrastDefault = placketContrastattr[0];
         }else{
           placketContrastDefault='';
         }
         //attributeObj.push({"attributeName": "Placket Contrast Material","values": [placketContrastDefault]});
         //attributeObj.push({"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]});
       
       name1='imageTitle';
       url1=attributeObj[12]['values'][0];
       
      //  console.log(url1,"url1");
       
          name1 = name1.replace(/[\[\]]/g, '\\$&');
   var regex = new RegExp('[?]' + name1 + '(=([^?#]*)|&|#|$)'),
       results = regex.exec(url1);
      var attr_obj_12=decodeURIComponent(results[2].replace(/\+/g, '+'));
    // console.log('attribute 12',attr_obj_12);   
       if(attr_obj_12=='Twill Tape'){
         attributeObj[13] = {"attributeName": "Placket Contrast Material","values": [placketContrastDefault]};
         attributeObj[14] = {"attributeName": "Placket Contrast Material Name","values": ['']};
       }else{
         attributeObj[13] = {"attributeName": "Placket Contrast Material","values": ['']};
         attributeObj[14] = {"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]};
       }
       
     } 
        
     if(designAttrs[index].attributeName == 'Cuff Contrast'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Cuff Contrast","values": [imgattr[i]]});
   attributeObj[20] = {"attributeName": "Cuff Contrast","values": [imgattr[i]]}; 
     }
     if(designAttrs[index].attributeName == 'Cuff Contrast Material'){
       if(designAttrs[index].values.length > 0){
         var cuffContrastMaterialattr = designAttrs[index].values;
         cuffContrastDefault = cuffContrastMaterialattr[0];
         //attributeObj.push({"attributeName": "Cuff Contrast Material","values": [cuffContrastDefault]});
         attributeObj[21] = {"attributeName": "Cuff Contrast Material","values": [cuffContrastDefault]};
         
       } else {
         //attributeObj.push({"attributeName": "Cuff Contrast Material","values": ["None"]});
         attributeObj[21] = {"attributeName": "Cuff Contrast Material","values": ["None"]}; 
       }
     }
     
     if(designAttrs[index].attributeName == 'Elbow Patch'){
       var imgattr = designAttrs[index].values;
       //attributeObj.push({"attributeName": "Elbow Patch","values": [imgattr[i]]});   
     attributeObj[24] = {"attributeName": "Elbow Patch","values": [imgattr[i]]};
     }
     if(designAttrs[index].attributeName == 'Elbow Patch Material'){
       if(designAttrs[index].values.length > 0){
         var elbowattr = designAttrs[index].values;
         elbowPatchDefault = elbowattr[0];
         //attributeObj.push({"attributeName": "Elbow Patch Material","values": [elbowPatchDefault]});
         attributeObj[25] = {"attributeName": "Elbow Patch Material","values": [elbowPatchDefault]}; 
       } else {
         //attributeObj.push({"attributeName": "Elbow Patch Material","values": ["None"]});
         attributeObj[25] = {"attributeName": "Elbow Patch Material","values": ["None"]};
       }
     }
   
   
     if(designAttrs[index].attributeName == 'Gusset'){
       var imgattr = designAttrs[index].values;
        //attributeObj.push({"attributeName": "Gusset","values": [imgattr[i]]});   
        attributeObj[26] = {"attributeName": "Gusset","values": [imgattr[i]]};
       
     }
     if(designAttrs[index].attributeName == 'Gusset Material'){
       if(designAttrs[index].values.length > 0){
         var gussetattr = designAttrs[index].values;
         gussetDefault = gussetattr[0];
         //attributeObj.push({"attributeName": "Gusset Material","values": [gussetDefault]});
         attributeObj[27] = {"attributeName": "Gusset Material","values": [gussetDefault]};
       } else {
         //attributeObj.push({"attributeName": "Gusset Material","values": ["None"]});
         attributeObj[27] = {"attributeName": "Gusset Material","values": ["None"]}
       }
     }  
      
   //}
   
     var fontStyleJson = 'Bell MT';
     var pStyleJson = "";

   
   if (isLastElement) {
     attributeObj[28] = {"attributeName": "Monogram","values": [pStyleJson,fontStyleJson,$('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(),$('.color-list-outer-box.active').attr('data-color')]};
     //attributeObj.push({"attributeName": "Monogram","values": [pStyleJson,fontStyleJson,$('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(),$('.color-list-outer-box.active').attr('data-color')]});
     //attrObj(attributeObj);
   }  
 });

// var attributeObjnew = {};
// var customObjnewDefault = {};
 attributeObjnew["attributes"] = attributeObj;
 $('[name="properties[_attributes]"]').val(JSON.stringify(attributeObjnew));
console.log("Before Customize");
console.log('attributeObjnew',attributeObjnew);
customObjnewDefault = attributeObj;


function getDesignDetails() {
  let valString = "";
  $(".customise-popup .tab-pane.active .Grid__Cell.active").each(function(index){
    let val = $(this).find("[data-imagevalue]").attr("data-imagevalue");
    console.log("val",val,$(this));
    valString += val;
    if(($(".customise-popup .tab-pane.active .Grid__Cell.active").length - 1) != index){
      valString += ` | `;
    }
  });
  console.log("valString",valString);
  $(".pro-customise-content").html(valString);
}

// $('.customize-shirt').click(function(){
$(document).on("click",".customize-shirt",function(){
  console.log("customize-shirt>>>>>>> clicked");

  if(!document.body.classList.contains("temp_webview")){
  if(!document.querySelector('[data-pro-standard-size-main] input:checked[name="properties[_Standard Size?]"]') && document.querySelector('[data-pro-saved-sizing].hide')){
    // debugger;
    $(".pro-customise-design-toast-msg").removeClass("hide");
    if(document.body.clientWidth <= 767){
      setTimeout(() => {
        $(".pro-customise-design-toast-msg").addClass("hide");
      },2000);
    }
    return false;
  }
  }
  $('body').addClass('picario_open');
  
 // if (window.history && window.history.pushState) {
 //   console.log('location',document.location.href.split('#')[0])
   
 //   console.log('documentTitle',document.title)
 //   // history.pushState(
 //   //   { url: document.location.href.split('#')[0] },
 //   //   document.title,
 //   //   "#modal"
 //   // );
 //   $(window).on('popstate', function() {
 //      if($('.common-btn-edit.added').length <= 0 && $('.customise-popup.customise-editor:not(.hide)').length > 0){
 //         $('.customise-popup.customise-editor:not(.hide) .common-btn.cancle').click();
 //        // history.pushState(
 //        // { url: document.location.href.split('#')[0] },
 //        // document.title,
 //        // "#modal"
 //        // );
 //       }else{
 //            $('.Exit_Popup').click();  
 //       }
     
 //   });
 // }

  var attributeObj = [];

// if($('.template-product').length > 0){
if($('body').length > 0){
  
$('#main').addClass('customiseBox--open');
 var pdpid = getUrlParameter('itemid');
 var cpid = getUrlParameter('cpid');
 if($('body').hasClass('temp_webview')){ 
  var webitem_id = getUrlParameter('web_itemid');
    if(webitem_id){
       var web_id = atob(getUrlParameter('web_itemid'));
      var ordeId = atob(getUrlParameter('ck'));
    }

  console.log('web_id',web_id);
  console.log('ordeId',ordeId);
  }
 if(pdpid){
   var pdpid = parseInt(pdpid) - 1;
   jQuery.getJSON('/cart.js', function(cart) {
     var getAttr = cart.items[pdpid]['properties']['_attributes'];
     var getAttrData = JSON.parse(getAttr);
     getAttrData = getAttrData['attributes'];

//     btnShirtlength = getParameterByName('imageValue',getAttrData[29]['values']);
// console.log('btnShirtlength',btnShirtlength);

// if($('[data-alt="Casual"]').length>0 && btnShirtlength == 'Casual'){
// $('[data-alt="Casual"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
// $('[data-alt="Formal"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
// }
// if($('[data-alt="Formal"]').length>0  && btnShirtlength == 'Formal'){
// $('[data-alt="Formal"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
// $('[data-alt="Casual"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
// }
     $.each(getAttrData, function(index, value) {
       if(getAttrData[index]['values'][0] != attributeObj[index]['values'][0]){
        //  console.log(getAttrData[index]['attributeName']);

         
         
         if(getAttrData[index]['attributeName'] == "Collar Style" | getAttrData[index]['attributeName'] == "Collar Stiffness" | getAttrData[index]['attributeName'] == "Collar Top Button"){
           $('.common-btn-edit.collar-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Pocket"){
           if(getParameterByName('imageValue',getAttrData[index]['values'][0]) == 'Single Pocket'){
             $('.common-btn-edit.persolise-pocket').removeClass('hide');
           } else {
             $('.common-btn-edit.persolise-pocket').addClass('hide');
           }
           $('.common-btn-edit.pocket-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Placket"){
           $('.common-btn-edit.front-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Buttons" | getAttrData[index]['attributeName'] == "Button Thread Color"){
           $('.common-btn-edit.thread-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Sleeves" | getAttrData[index]['attributeName'] == "Cuff Style" | getAttrData[index]['attributeName'] == "Cuff Stiffness"){
           if(getParameterByName('imageValue',getAttrData[index]['values'][0]) == 'Short Sleeves'){
             $('.common-btn-edit.cuff-sleeve-btn').addClass("added").addClass("half");
           } else {
             $('.common-btn-edit.cuff-sleeve-btn').addClass("added").removeClass("half");
           }
         } else if(getAttrData[index]['attributeName'] == "Back" | getAttrData[index]['attributeName'] == "Bottom Cut" | getAttrData[index]['attributeName'] == "Shirt Length"){
           $('.common-btn-edit.back-bottom-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Collar Contrast" | getAttrData[index]['attributeName'] == "Collar Contrast Material" | getAttrData[index]['attributeName'] == "Collar Contrast Material Name" | getAttrData[index]['attributeName'] == "Collar Piping"| getAttrData[index]['attributeName'] == "Collar Inside Piping" | getAttrData[index]['attributeName'] == "Collar Inside Piping Color" | getAttrData[index]['attributeName'] == "Collar Piping Color"){
           if(getAttrData[index]['attributeName'] == "Collar Contrast"){
             if(getParameterByName('imageTitle',getAttrData[index]['values'][0]) == 'No Contrast'){
               $('.common-btn-edit.persolise-collar').removeClass('hide');
             } else {
               // $('.common-btn-edit.persolise-collar').addClass('hide');
             }
           }

           if(getAttrData[index]['attributeName'] == "Collar Piping"){
             if(getParameterByName('imageTitle',getAttrData[index]['values'][0]) == 'Twill Tape'){
                 $('.common-btn-edit.persolise-collar').addClass('hide');
                 $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
             }else{
               $('.common-btn-edit.persolise-collar').removeClass('hide');
                $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
             }
           }
           
           $('.common-btn-edit.contrast-collar-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Placket Contrast" | getAttrData[index]['attributeName'] == "Placket Contrast Material" | getAttrData[index]['attributeName'] == "Placket Contrast Material Name"){
           $('.common-btn-edit.contrast-front-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Elbow Patch" | getAttrData[index]['attributeName'] == "Elbow Patch Material"){
           $('.common-btn-edit.contrast-elbow-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Cuff Contrast" | getAttrData[index]['attributeName'] == "Cuff Contrast Material"){
           $('.common-btn-edit.contrast-cuff-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Gusset" | getAttrData[index]['attributeName'] == "Gusset Material"){
           $('.common-btn-edit.contrast-gusset-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Monogram"){
           if(getAttrData[index]['values'][0] == "Collar"){
             $('.common-btn-edit.persolise-collar').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Pocket"){
             $('.common-btn-edit.persolise-pocket').addClass("added");
           } else if(getAttrData[index]['values'][0] == "LEFTCUFF"){
             $('.common-btn-edit.persolise-cuff').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Rib"){
             $('.common-btn-edit.persolise-rib').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Chest"){
             $('.common-btn-edit.persolise-chest').addClass("added");
           }
           
         }     
       }
     });
     
     
     attributeObj = getAttrData;
     attrObj(attributeObj);
     
     setTimeout(function(){
       refreshMainshirt();
     },500);    
   });  
 }else if(cpid){
      //get from local storage
     //jQuery.getJSON('/cart.js', function(dummy) {
   setTimeout(function(){
     var getAttrData = JSON.parse(localStorage.getItem('custom_getAttrData'));
     getAttrData = getAttrData['attributes'];

    //  console.log("getAttrData",getAttrData);

     $.each(getAttrData, function(index, value) {

       console.log(attributeObj[index]['values'][0]);

       if(getAttrData[index]['values'][0] != attributeObj[index]['values'][0]){
        //  console.log(getAttrData[index]['attributeName']);

         if(getAttrData[index]['attributeName'] == "Collar Style" | getAttrData[index]['attributeName'] == "Collar Stiffness" | getAttrData[index]['attributeName'] == "Collar Top Button"){
           $('.common-btn-edit.collar-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Pocket"){
           if(getParameterByName('imageValue',getAttrData[index]['values'][0]) == 'Single Pocket'){
             $('.common-btn-edit.persolise-pocket').removeClass('hide');
           } else {
             $('.common-btn-edit.persolise-pocket').addClass('hide');
           }
           
           $('.common-btn-edit.pocket-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Placket"){
           $('.common-btn-edit.front-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Buttons" | getAttrData[index]['attributeName'] == "Button Thread Color"){
           $('.common-btn-edit.thread-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Sleeves" | getAttrData[index]['attributeName'] == "Cuff Style" | getAttrData[index]['attributeName'] == "Cuff Stiffness"){
           $('.common-btn-edit.cuff-sleeve-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Back" | getAttrData[index]['attributeName'] == "Bottom Cut" | getAttrData[index]['attributeName'] == "Shirt Length"){
           $('.common-btn-edit.back-bottom-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Collar Contrast" | getAttrData[index]['attributeName'] == "Collar Contrast Material" | getAttrData[index]['attributeName'] == "Collar Contrast Material Name" | getAttrData[index]['attributeName'] == "Collar Piping"| getAttrData[index]['attributeName'] == "Collar Inside Piping" | getAttrData[index]['attributeName'] == "Collar Inside Piping Color" | getAttrData[index]['attributeName'] == "Collar Piping Color"){
           if(getAttrData[index]['attributeName'] == "Collar Contrast"){
             if(getParameterByName('imageTitle',getAttrData[index]['values'][0]) == 'No Contrast'){
               $('.common-btn-edit.persolise-collar').removeClass('hide');
             } else {
               // $('.common-btn-edit.persolise-collar').addClass('hide');
             }
           }
           if(getAttrData[index]['attributeName'] == "Collar Piping"){
              if(getParameterByName('imageTitle',getAttrData[index]['values'][0]) == 'Twill Tape'){
                 $('.common-btn-edit.persolise-collar').addClass('hide');
                 $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
             }else{
               $('.common-btn-edit.persolise-collar').removeClass('hide');
                $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
             }
           }
           $('.common-btn-edit.contrast-collar-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Placket Contrast" | getAttrData[index]['attributeName'] == "Placket Contrast Material" | getAttrData[index]['attributeName'] == "Placket Contrast Material Name"){
           $('.common-btn-edit.contrast-front-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Elbow Patch" | getAttrData[index]['attributeName'] == "Elbow Patch Material"){
           $('.common-btn-edit.contrast-elbow-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Cuff Contrast" | getAttrData[index]['attributeName'] == "Cuff Contrast Material"){
           $('.common-btn-edit.contrast-cuff-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Gusset" | getAttrData[index]['attributeName'] == "Gusset Material"){
           $('.common-btn-edit.contrast-gusset-btn').addClass("added");
         } else if(getAttrData[index]['attributeName'] == "Monogram"){
           if(getAttrData[index]['values'][0] == "Collar"){
             $('.common-btn-edit.persolise-collar').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Pocket"){
             $('.common-btn-edit.persolise-pocket').addClass("added");
           } else if(getAttrData[index]['values'][0] == "LEFTCUFF"){
             $('.common-btn-edit.persolise-cuff').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Rib"){
             $('.common-btn-edit.persolise-rib').addClass("added");
           } else if(getAttrData[index]['values'][0] == "Chest"){
             $('.common-btn-edit.persolise-chest').addClass("added");
           }

        }   
       }
     });


     attributeObj = getAttrData;
     attrObj(attributeObj);

     setTimeout(function(){
       refreshMainshirt();
     },500);  
   },500);
 }else if(web_id){

if(ordeId.includes("Checkout")){
  
  var settings = {
  "url": "https://www.bombayshirts.com/api/2022-10/graphql.json",
  "method": "POST",
  "timeout": 0,
  "headers": {
  "x-shopify-storefront-access-token": "0c4e8875084a8dd2cb70176e69465741",
  "Content-Type": "application/json",
  "Cookie": "request_method=POST"
  },
  "data": JSON.stringify({
  query: "{\r\n  node(\r\n    id: \""+ordeId+"\"\r\n  ) {\r\n    ... on Checkout {\r\n      id\r\n      webUrl\r\n      email\r\n      order {\r\n        id\r\n      }\r\n      customAttributes {\r\n        key\r\n        value\r\n      }\r\n      shippingLine {\r\n        handle\r\n        price {\r\n          amount\r\n          currencyCode\r\n        }\r\n        title\r\n      }\r\n      shippingAddress {\r\n        address1\r\n        address2\r\n        city\r\n        company\r\n        country\r\n        countryCodeV2\r\n        firstName\r\n        id\r\n        lastName\r\n        latitude\r\n        longitude\r\n        name\r\n        phone\r\n        province\r\n        provinceCode\r\n        zip\r\n      }\r\n      lineItems(first: 250) {\r\n        edges {\r\n          node {\r\n            id\r\n            title\r\n            customAttributes {\r\n              key\r\n              value\r\n            }\r\n            unitPrice {\r\n              amount\r\n              currencyCode\r\n            }\r\n            variant {\r\n              id\r\n              image {\r\n                url(transform: { maxWidth: 250 })\r\n              }\r\n              product {\r\n                id\r\n                vendor\r\n                handle\r\n                productType\r\n                tags\r\n                product_sku: metafield(namespace: \"my_fields\", key: \"sku\") {\r\n                  value\r\n                }\r\n              }\r\n              compareAtPrice {\r\n                amount\r\n                currencyCode\r\n              }\r\n              price {\r\n                amount\r\n                currencyCode\r\n              }\r\n              title\r\n            }\r\n            quantity\r\n            discountAllocations {\r\n              allocatedAmount {\r\n                amount\r\n                currencyCode\r\n              }\r\n              discountApplication {\r\n                ... on ScriptDiscountApplication {\r\n                  __typename\r\n                  title\r\n                  targetType\r\n                  targetSelection\r\n                  allocationMethod\r\n                  value {\r\n                    ... on MoneyV2 {\r\n                      __typename\r\n                      amount\r\n                      currencyCode\r\n                    }\r\n                    ... on PricingPercentageValue {\r\n                      __typename\r\n                      percentage\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      discountApplications(first: 100) {\r\n        edges {\r\n          node {\r\n            allocationMethod\r\n            targetSelection\r\n            targetType\r\n            ... on AutomaticDiscountApplication {\r\n              __typename\r\n              allocationMethod\r\n              targetSelection\r\n              targetType\r\n              title\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                  currencyCode\r\n                }\r\n              }\r\n            }\r\n            ... on DiscountCodeApplication {\r\n              __typename\r\n              allocationMethod\r\n              applicable\r\n              code\r\n              targetSelection\r\n              targetType\r\n              value\r\n            }\r\n            value {\r\n              ... on MoneyV2 {\r\n                __typename\r\n                amount\r\n                currencyCode\r\n              }\r\n              ... on PricingPercentageValue {\r\n                __typename\r\n                percentage\r\n              }\r\n            }\r\n            ... on ManualDiscountApplication {\r\n              description\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                }\r\n              }\r\n              title\r\n            }\r\n            ... on ScriptDiscountApplication {\r\n              __typename\r\n              title\r\n              value {\r\n                ... on MoneyV2 {\r\n                  __typename\r\n                  amount\r\n                  currencyCode\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n      appliedGiftCards {\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        id\r\n        lastCharacters\r\n        presentmentAmountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        amountUsed {\r\n          amount\r\n          currencyCode\r\n        }\r\n        balance {\r\n          amount\r\n          currencyCode\r\n        }\r\n      }\r\n      lineItemsSubtotalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n      subtotalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n      totalPrice {\r\n        amount\r\n        currencyCode\r\n      }\r\n    }\r\n  }\r\n}\r\n",
  variables: {}
  })
  };
  console.log('in webview js',web_id);
  
  $.ajax(settings).done(function (response) {
  console.log('response-',response);
  var edges = response.data.node.lineItems?.edges;
  console.log('edges',edges);
  if(edges != undefined){
  var nodeFilter = jQuery.grep(edges, function(n, i){
  var nodeId = n.node.id;
  if(web_id == nodeId){
  return nodeId;
  }
  });
  console.log('nodeFilter',nodeFilter);
  var custAttr = nodeFilter[0].node.customAttributes;
  var attrWeb = jQuery.grep(custAttr, function(n, i){
  return (n !== "" && n != null && n.key == '_attributes')
  });
  //console.log('attrWeb',attrWeb);
  if(attrWeb[0]){
  var getWebAttr = attrWeb[0].value;
  }
  //console.log('getWebAttr',getWebAttr);
  var getWebAttrData = JSON.parse(getWebAttr);
  //console.log('getAttrData',getWebAttrData);
  getWebAttrData = getWebAttrData['attributes'];
  //console.log('getAttrData--',getWebAttrData);
  //console.log('attributeObj',attributeObj);
  $.each(getWebAttrData, function(index, value) {
  //console.log('dd',getWebAttrData[index]['values'][0]);
  if(getWebAttrData[index]['values'][0] != attributeObj[index]['values'][0]  ){
  //console.log(getWebAttrData[index]['attributeName']);
  
  if(getWebAttrData[index]['attributeName'] == "Collar Style" | getWebAttrData[index]['attributeName'] == "Collar Stiffness" | getWebAttrData[index]['attributeName'] == "Collar Top Button"){
  $('.common-btn-edit.collar-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Pocket"){
  if(getParameterByName('imageValue',getWebAttrData[index]['values'][0]) == 'Single Pocket'){
  $('.common-btn-edit.persolise-pocket').removeClass('hide');
  } else {
  $('.common-btn-edit.persolise-pocket').addClass('hide');
  }
  $('.common-btn-edit.pocket-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Placket"){
  $('.common-btn-edit.front-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Buttons" | getWebAttrData[index]['attributeName'] == "Button Thread Color"){
  $('.common-btn-edit.thread-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Sleeves" | getWebAttrData[index]['attributeName'] == "Cuff Style" | getWebAttrData[index]['attributeName'] == "Cuff Stiffness"){
  if(getParameterByName('imageValue',getWebAttrData[index]['values'][0]) == 'Short Sleeves'){
  $('.common-btn-edit.cuff-sleeve-btn').addClass("added").addClass("half");
  } else {
  $('.common-btn-edit.cuff-sleeve-btn').addClass("added").removeClass("half");
  }
  } else if(getWebAttrData[index]['attributeName'] == "Back" | getWebAttrData[index]['attributeName'] == "Bottom Cut" | getWebAttrData[index]['attributeName'] == "Shirt Length"){
  $('.common-btn-edit.back-bottom-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Collar Contrast" | getWebAttrData[index]['attributeName'] == "Collar Contrast Material" | getWebAttrData[index]['attributeName'] == "Collar Contrast Material Name" | getWebAttrData[index]['attributeName'] == "Collar Piping"| getWebAttrData[index]['attributeName'] == "Collar Inside Piping" | getWebAttrData[index]['attributeName'] == "Collar Inside Piping Color" | getWebAttrData[index]['attributeName'] == "Collar Piping Color"){
  if(getWebAttrData[index]['attributeName'] == "Collar Contrast"){
  if(getParameterByName('imageTitle',getWebAttrData[index]['values'][0]) == 'No Contrast'){
  $('.common-btn-edit.persolise-collar').removeClass('hide');
  } else {
  // $('.common-btn-edit.persolise-collar').addClass('hide');
  }
  }
  if(getWebAttrData[index]['attributeName'] == "Collar Piping"){
  if(getParameterByName('imageTitle',getWebAttrData[index]['values'][0]) == 'Twill Tape'){
   $('.common-btn-edit.persolise-collar').addClass('hide');
   $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
  }else{
  $('.common-btn-edit.persolise-collar').removeClass('hide');
  $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
  }
  }
  $('.common-btn-edit.contrast-collar-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Placket Contrast" | getWebAttrData[index]['attributeName'] == "Placket Contrast Material" | getWebAttrData[index]['attributeName'] == "Placket Contrast Material Name"){
  $('.common-btn-edit.contrast-front-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Elbow Patch" | getWebAttrData[index]['attributeName'] == "Elbow Patch Material"){
  $('.common-btn-edit.contrast-elbow-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Cuff Contrast" | getWebAttrData[index]['attributeName'] == "Cuff Contrast Material"){
  $('.common-btn-edit.contrast-cuff-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Gusset" | getWebAttrData[index]['attributeName'] == "Gusset Material"){
  $('.common-btn-edit.contrast-gusset-btn').addClass("added");
  } else if(getWebAttrData[index]['attributeName'] == "Monogram"){
  if(getWebAttrData[index]['values'][0] == "Collar"){
  $('.common-btn-edit.persolise-collar').addClass("added");
  } else if(getWebAttrData[index]['values'][0] == "Pocket"){
  $('.common-btn-edit.persolise-pocket').addClass("added");
  } else if(getWebAttrData[index]['values'][0] == "LEFTCUFF"){
  $('.common-btn-edit.persolise-cuff').addClass("added");
  } else if(getWebAttrData[index]['values'][0] == "Rib"){
  $('.common-btn-edit.persolise-rib').addClass("added");
  } else if(getWebAttrData[index]['values'][0] == "Chest"){
  $('.common-btn-edit.persolise-chest').addClass("added");
  }
  
  }     
  }
  });
  attributeObj = getWebAttrData;
  attrObj(attributeObj);  
  setTimeout(function(){
  refreshMainshirt();
  },500);
  }
  });

}else{// cartID api
   
  // new API setup
  // GraphQL query string
  const query = `
  query MyQuery {
    cart(id: "${ordeId}") {
      attributes {
        key
        value
      }
      checkoutUrl
      buyerIdentity {
        customer {
          displayName
          email
          firstName
          id
          lastName
        }
        countryCode
        email
      }
      lines(first: 250) {
        edges {
          node {
            attributes {
              key
              value
            }
            cost {
              totalAmount {
                amount
                currencyCode
              }
              amountPerQuantity {
                amount
                currencyCode
              }
            }
            id
          }
        }
      }
    }
  }`;
  
  // Function to fetch cart data
  async function fetchCartData() {
    try {
      const response = await fetch(`https://${shopURL}/api/2025-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': `${storefrontAccessToken}`, // Replace with your actual Storefront API access token
        },
        body: JSON.stringify({ query })
      });
  
      const data = await response.json();
  
      // Process the response data
      console.log('Cart data:>>>>>>>>>>>>', data);
      var edges = data.data.cart.lines?.edges;
      if(edges != undefined){
      var nodeFilter = jQuery.grep(edges, function(n, i){
      var nodeId = n.node.id;
      if(web_id == nodeId){
      return nodeId;
      }
      });
      console.log('nodeFilter',nodeFilter);
      var custAttr = nodeFilter[0].node.attributes;
      var attrWeb = jQuery.grep(custAttr, function(n, i){
      return (n !== "" && n != null && n.key == '_attributes')
      });
      //console.log('attrWeb',attrWeb);
      if(attrWeb[0]){
      var getWebAttr = attrWeb[0].value;
      }
      //console.log('getWebAttr',getWebAttr);
      var getWebAttrData = JSON.parse(getWebAttr);
      //console.log('getAttrData',getWebAttrData);
      getWebAttrData = getWebAttrData['attributes'];
      //console.log('getAttrData--',getWebAttrData);
      //console.log('attributeObj',attributeObj);
      $.each(getWebAttrData, function(index, value) {
      //console.log('dd',getWebAttrData[index]['values'][0]);
      if(getWebAttrData[index]['values'][0] != attributeObj[index]['values'][0]  ){
      //console.log(getWebAttrData[index]['attributeName']);
      
      if(getWebAttrData[index]['attributeName'] == "Collar Style" | getWebAttrData[index]['attributeName'] == "Collar Stiffness" | getWebAttrData[index]['attributeName'] == "Collar Top Button"){
      $('.common-btn-edit.collar-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Pocket"){
      if(getParameterByName('imageValue',getWebAttrData[index]['values'][0]) == 'Single Pocket'){
      $('.common-btn-edit.persolise-pocket').removeClass('hide');
      } else {
      $('.common-btn-edit.persolise-pocket').addClass('hide');
      }
      $('.common-btn-edit.pocket-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Placket"){
      $('.common-btn-edit.front-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Buttons" | getWebAttrData[index]['attributeName'] == "Button Thread Color"){
      $('.common-btn-edit.thread-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Sleeves" | getWebAttrData[index]['attributeName'] == "Cuff Style" | getWebAttrData[index]['attributeName'] == "Cuff Stiffness"){
      if(getParameterByName('imageValue',getWebAttrData[index]['values'][0]) == 'Short Sleeves'){
      $('.common-btn-edit.cuff-sleeve-btn').addClass("added").addClass("half");
      } else {
      $('.common-btn-edit.cuff-sleeve-btn').addClass("added").removeClass("half");
      }
      } else if(getWebAttrData[index]['attributeName'] == "Back" | getWebAttrData[index]['attributeName'] == "Bottom Cut" | getWebAttrData[index]['attributeName'] == "Shirt Length"){
      $('.common-btn-edit.back-bottom-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Collar Contrast" | getWebAttrData[index]['attributeName'] == "Collar Contrast Material" | getWebAttrData[index]['attributeName'] == "Collar Contrast Material Name" | getWebAttrData[index]['attributeName'] == "Collar Piping"| getWebAttrData[index]['attributeName'] == "Collar Inside Piping" | getWebAttrData[index]['attributeName'] == "Collar Inside Piping Color" | getWebAttrData[index]['attributeName'] == "Collar Piping Color"){
      if(getWebAttrData[index]['attributeName'] == "Collar Contrast"){
      if(getParameterByName('imageTitle',getWebAttrData[index]['values'][0]) == 'No Contrast'){
      $('.common-btn-edit.persolise-collar').removeClass('hide');
      } else {
      // $('.common-btn-edit.persolise-collar').addClass('hide');
      }
      }
      if(getWebAttrData[index]['attributeName'] == "Collar Piping"){
      if(getParameterByName('imageTitle',getWebAttrData[index]['values'][0]) == 'Twill Tape'){
      $('.common-btn-edit.persolise-collar').addClass('hide');
      $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
      }else{
      $('.common-btn-edit.persolise-collar').removeClass('hide');
      $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
      }
      }
      $('.common-btn-edit.contrast-collar-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Placket Contrast" | getWebAttrData[index]['attributeName'] == "Placket Contrast Material" | getWebAttrData[index]['attributeName'] == "Placket Contrast Material Name"){
      $('.common-btn-edit.contrast-front-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Elbow Patch" | getWebAttrData[index]['attributeName'] == "Elbow Patch Material"){
      $('.common-btn-edit.contrast-elbow-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Cuff Contrast" | getWebAttrData[index]['attributeName'] == "Cuff Contrast Material"){
      $('.common-btn-edit.contrast-cuff-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Gusset" | getWebAttrData[index]['attributeName'] == "Gusset Material"){
      $('.common-btn-edit.contrast-gusset-btn').addClass("added");
      } else if(getWebAttrData[index]['attributeName'] == "Monogram"){
      if(getWebAttrData[index]['values'][0] == "Collar"){
      $('.common-btn-edit.persolise-collar').addClass("added");
      } else if(getWebAttrData[index]['values'][0] == "Pocket"){
      $('.common-btn-edit.persolise-pocket').addClass("added");
      } else if(getWebAttrData[index]['values'][0] == "LEFTCUFF"){
      $('.common-btn-edit.persolise-cuff').addClass("added");
      } else if(getWebAttrData[index]['values'][0] == "Rib"){
      $('.common-btn-edit.persolise-rib').addClass("added");
      } else if(getWebAttrData[index]['values'][0] == "Chest"){
      $('.common-btn-edit.persolise-chest').addClass("added");
      }
      
      }     
      }
      });
      attributeObj = getWebAttrData;
      attrObj(attributeObj);        
      setTimeout(function(){
      refreshMainshirt();
      },500);
      }
  
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  }    
  // Call the function to fetch data
  fetchCartData();
  // new API setup -- END
 }
   
 }


 /*
 $(window).on("load",function(){
   if($(window).width() < 1008){
     $(".content-box-wrapper .collar-icons-wrapper").mCustomScrollbar();
     //$(".content-box-wrapper .collar-icons-wrapper").customScrollbar();
   }
 });
 */  
 function attrObj(attributeObj){
 setTimeout(function(){
   refreshMainshirt();
 },200);
 
 var attributeObjnew = {};
 attributeObjnew["attributes"] = attributeObj;
 $('[name="properties[_attributes]"]').val(JSON.stringify(attributeObjnew));

}

 
 function getParameterByName(name, url) {
   name = name.replace(/[\[\]]/g, '\\$&');
   var regex = new RegExp('[?]' + name + '(=([^?#]*)|&|#|$)'),
       results = regex.exec(url);
   if (!results) return null;
   if (!results[2]) return '';
   return decodeURIComponent(results[2].replace(/\+/g, '+'));
 }
 var designAttrs = atr['designAttributes'];
 console.log('12',designAttrs);
 var html = '';
 
 var navTabCollar = '';
 var navTabPaneCollar = '';
 
 var navTabPocket = '';
 var navTabPanePocket = '';
 
 var navTabPlacket = '';
 var navTabPanePlacket = '';
 
 var navTabThread = '';
 var navTabPaneThread = '';
 
 var navTabSleeves = '';
 var navTabPaneSleeves = '';
 
 var navTabBackBottomCut = '';
 var navTabPaneBackBottomCut = '';
 
 /*-- Contrast --*/
 var navTabCollarContrast = '';
 var navTabPaneCollarContrast  = '';
 
 var navTabPlacketContrast = '';
 var navTabPanePlacketContrast  = '';
 
 var navTabCuffContrast = '';
 var navTabPaneCuffContrast  = '';
 
 var navTabElbowPatch = '';
 var navTabPaneElbowPatch  = '';
 
 var navTabGusset = '';
 var navTabPaneGusset  = '';
 
 
 
 var picarioxpo = 'https://bombayshirts.picarioxpo.com/';
 var shirtWidth = '?1=1&width=500';
 var designCode = $('.customizePDP').attr('data-pdp-code');
 
 var pfsFileCollar = 'bsc-collar-polo.pfs';
 var pfsFileButton = 'bsc-collar-base-single-button.pfs';
 var pfsPocket = 'bsc-pocket-single-angled.pfs';
 var pfsPlacket = 'bsc-placket-regular.pfs';
 var pfssleeves = 'bsc-sleeve-long-regular.pfs';
 var pfscuff = 'bsc-cuff-single-button.pfs';
 var pfsBottomCollar = 'bsc-bottom.pfs';
 
 
 var pfsZoomFileCollar = 'bsc-zoom-collar-polo.pfs';
 var pfsZoomFileButton = 'bsc-zoom-collar-bottom-single-button.pfs';
 var pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';
 var pfsZoomPlacket = 'bsc-zoom-placket-regular.pfs';
 var pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-regular.pfs';
 var pfsZoomsleeves = 'bsc-zoom-cuff-sleeve-long-regular.pfs';
 var pfsZoomcuff = 'bsc-zoom-cuff-single-button.pfs';
 
 
 var pfszoomBottomCollar = 'bsc-zoom-collar-bottom.pfs';
 var pfsZoomBackElbowPatches = 'bsc-back-elbow-patches.pfs';
 var pfsZoomGussets = 'bsc-gussets-gussets.pfs';
 var pfsBottomCut = 'bsc-back-no-pleats.pfs';
 
 var btnthreadcolor = 'Self';
 var btncolor = 'newbutton_natural';
 var cuffVar = '';
 
 var elbowPatchDefault = '';
 var gussetDefault = '';
 var collarContrastDefault = '';
 var pipingContrastDefault = '';
 var placketContrastDefault = '';
 var cuffContrastDefault = '';
 var fontStyle = 'Monotype Corsiva';
   
 if ($('.collar-icons-wrapper').length > 0) {
   $('.customise-box').removeClass('hide');
   $(this).closest('.ProductMeta__Size').addClass('hide');
   $(this).closest('.product-handle-button').addClass('full-btn-atc');
   $('.Customize-Your-Item').addClass('hide');
   if (window.innerWidth < 768) {
     document.querySelector('#addtocart-handle')?.classList.add('custom-direct-addto-cart');
   }
   setTimeout(() => {
     if(!document.body.classList.contains("product-quickview")){
       console.log("798--------------");
       $("html, body").animate({ scrollTop: 0 }, 200);
     }
   }, 400);
   $('header').addClass('no-brands');
   return;
 }

 
  $.each(designAttrs, function(index, value) {
  // console.log('is it right ?',designAttrs[index].attributeName);
   var isLastElement = index == designAttrs.length -1;
   
   //if(designAttrs[index].values.length > 0){
     
     if(designAttrs[index].attributeName == 'Collar Style'){
       
       navTabCollar += '<li class="nav-item"><a href="javascript:void(0);" data-tag="collar-style" class="active">'+designAttrs[index].attributeName.replace("Collar ", "")+'</a></li>';
       
       navTabPaneCollar += '<div class="tab-pane active" id="collar-style"><div class="collar-icons-wrapper"><div class="icons Grid">';

       // console.log("collarstyleLENGTH",designAttrs[index].values);
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){
             
             //attributeObj.push({"attributeName": "Collar Style","values": [imgattr[i]]});
             attributeObj[0] = {"attributeName": "Collar Style","values": [imgattr[i]]};
             
             var activeclass = 'active'; 
       if(alt == 'Polo'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');

               pfsZoomFileCollar = 'bsc-zoom-collar-polo.pfs';
               pfsFileCollar = 'bsc-collar-polo.pfs';
             } else if(alt == 'Prince Charlie'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-prince-charlie.pfs';
               pfsFileCollar = 'bsc-collar-prince-charile.pfs';
             } else if(alt == 'Spread Collar'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-spread-eagle.pfs';
               pfsFileCollar = 'bsc-collar-spread-eagle.pfs';
             } else if(alt == 'Madmen' || alt == 'Madmen Collar'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-madmen.pfs';
               pfsFileCollar = 'bsc-collar-madmen.pfs';
             } else if(alt == 'Bandhgala'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = '';
               pfsFileCollar = '';
               
               $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2,.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').addClass('hide');
               $('#style .style2,#contrast .contrast2,#personalise .personalise2').addClass('hide');
               
             } else if(alt == 'Hipster'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-hipster.pfs';
               pfsFileCollar = 'bsc-collar-hipster.pfs';
             } else if(alt == 'Hipster Rounded'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-hipster-rounded.pfs';
               pfsFileCollar = 'bsc-collar-hipster-rounded.pfs';
             } else if(alt == 'Concealed'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-concealed-polo.pfs';
               pfsFileCollar = 'bsc-collar-concealed-polo.pfs';
             } else if(alt == 'Club Collar'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-club.pfs';
               pfsFileCollar = 'bsc-collar-club.pfs';
             } else if(alt == 'Ozwald Boateng'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-boateng.pfs';
               pfsFileCollar = 'bsc-collar-boateng.pfs';
             } else if(alt == 'Tuxedo Collar' || alt == 'Wing Collar'){
               $('[data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
               $('[data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
               
               pfsZoomFileCollar = 'bsc-zoom-collar-wing-tuxedo.pfs';
               pfsFileCollar = 'bsc-collar-wing-tuxedo.pfs';
             } 
             
     }else{var activeclass = '';}
            navTabPaneCollar += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneCollar += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_collar">';
           
           if(alt == 'Polo'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Better known as Button Down collar, it is ideally paired with sports jacket and loafers, but goes well with less dressy suits.</p></div></div></div>';
           } else if(alt == 'Prince Charlie'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Classic Straight collar is based pair with a suit and tie. It was made famous by British royalty.</p></div></div></div>';
           } else if(alt == 'Spread Collar'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Spread collar remains a classic men’s staple like the pocket square, hat and custom suit. </p></div></div></div>';
           } else if(alt == 'Madmen' || alt == 'Madmen Collar'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Cutaway collar can be worn with a tie to work or without a tie for after work drinks. While wearing a tie, we recommend you use a Windsor knot.</p></div></div></div>';
           } else if(alt == 'Bandhgala'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The traditional Bandh Gala for all the old school folks out there.</p></div></div></div>';
           } else if(alt == 'Hipster'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Hipster, also known as the Skinny collar, is a fairly recent phenomenon. Ideally worn without a tie, but if you must, choose a skinny one!</p></div></div></div>';
           } else if(alt == 'Hipster Rounded'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Why be square? Our most unconventional collar is the skinny rounded collar.</p></div></div></div>';
           } else if(alt == 'Concealed'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>a metallic snap button on the inside keeps your button down a secret.</p></div></div></div>';
           } else if(alt == 'Club Collar'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Made famous by NBA coach Pat Riley, the Rounded or Club collar goes well with bespoke shirts and dressy suits.</p></div></div></div>';
           } else if(alt == 'Ozwald Boateng'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Designed by its namesake, perhaps the classiest of all our collar offerings.</p></div></div></div>';
           } else if(alt == 'Tuxedo Collar' || alt == 'Wing Collar'){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Our old school Wing Collar is best worn with a tuxedo. Slap on a cool bow tie and transport yourself to the early 1900’s</p></div></div></div>';
          } else if(alt == 'Cuban Collar' ){
     navTabPaneCollar += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Our old school Wing Collar is best worn with a tuxedo. Slap on a cool bow tie and transport yourself to the early 1900’s</p></div></div></div>';
           }
         
           navTabPaneCollar += '</div></div>';
         }
         navTabPaneCollar += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Collar Stiffness'){
       navTabCollar += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="collar-stiffness" class="">'+designAttrs[index].attributeName.replace("Collar ", "")+'</a></li>';
     
       navTabPaneCollar += '<div class="tab-pane hide" id="collar-stiffness"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
         console.log("Collar Stiffness",imgattr);
         var alt = getParameterByName('imageTitle',imgattr[i]);
         var imageValue = getParameterByName('imageValue',imgattr[i]);
         if(i == 0){var activeclass = 'active'; 
                     
           //attributeObj.push({"attributeName": "Collar Stiffness","values": [imgattr[i]]});
           attributeObj[1] = {"attributeName": "Collar Stiffness","values": [imgattr[i]]};
         }else{var activeclass = '';}
           navTabPaneCollar += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneCollar += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_collar">';
           navTabPaneCollar += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneCollar += '</div></div>';
         }
       navTabPaneCollar += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Collar Top Button'){
       navTabCollar += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="collar-top-button" class="">'+designAttrs[index].attributeName.replace("Collar ", "")+'</a></li>';
     
       navTabPaneCollar += '<div class="tab-pane hide" id="collar-top-button"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Collar Top Button","values": [imgattr[i]]});
     attributeObj[2] = {"attributeName": "Collar Top Button","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPaneCollar += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneCollar += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_collar">';
           navTabPaneCollar += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneCollar += '</div></div>';
         }
       navTabPaneCollar += '</div></div></div>';
     }
     $('.customise-editor[data-custom="collar-btn"] .nav-tabs').html(navTabCollar);
     $('.customise-editor[data-custom="collar-btn"] .nav-tabs').append('<li class="nav-item guidetab"><a href="#collarGuideLink" class="collarGuideLink notclickGuide">Guide</a></li>');
     console.log("navTabPaneCollar",navTabPaneCollar);
     $('.customise-editor[data-custom="collar-btn"] .tab-wrap').html(navTabPaneCollar);
     
     
     if(designAttrs[index].attributeName == 'Pocket'){
       navTabPocket += '<li class="nav-item"><a href="javascript:void(0);" data-tag="pocket" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPanePocket += '<div class="tab-pane active" id="pocket"><div class="collar-icons-wrapper"><div class="icons Grid">';
       // console.log("POCKET>>>>",designAttrs[index].values);
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
       //attributeObj.push({"attributeName": "Pocket","values": [imgattr[i]]});
             attributeObj[10] = {"attributeName": "Pocket","values": [imgattr[i]]};         
             if(alt == 'Single Pocket'){
               pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';
               pfsPocket = 'bsc-pocket-single-angled.pfs';
               $('.common-btn-edit.persolise-pocket').removeClass('hide');
               
               $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').removeClass('hide');
               $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide');
               $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
             } else if(alt == 'Single Pocket with Flap'){
               pfsZoomPocket = 'bsc-zoom-placket-pocket-single-flap.pfs';
               pfsPocket = 'bsc-pocket-single-flap.pfs';
               $('.common-btn-edit.persolise-pocket').addClass('hide');
               
               $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').removeClass('hide');
               $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide')
               $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
             } else if(alt == 'Double Pocket with Flap'){
               pfsZoomPocket = 'bsc-zoom-placket-pocket-double-flap.pfs';
               pfsPocket = 'bsc-pocket-double-flap.pfs';
               $('.common-btn-edit.persolise-pocket').addClass('hide');
               
               $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').removeClass('hide');
               $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide')
               $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
             } else if(alt == 'No Pocket'){
               //$('.common-btn-edit.persolise-pocket').addClass('hide');
               $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').addClass('hide');
               $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').addClass('hide');
               $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
             } 
       
                     
     }else{var activeclass = '';}
           navTabPanePocket += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPanePocket += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_pocket">';
           navTabPanePocket += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPanePocket += '</div></div>';
         }
       navTabPanePocket += '</div></div></div>';
     }
     $('.customise-editor[data-custom="pocket-btn"] .nav-tabs').html(navTabPocket);
     $('.customise-editor[data-custom="pocket-btn"] .tab-wrap').html(navTabPanePocket);
     
     
     if(designAttrs[index].attributeName == 'Placket'){
       navTabPlacket += '<li class="nav-item"><a href="javascript:void(0);" data-tag="placket" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPanePlacket += '<div class="tab-pane active" id="placket"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
       //attributeObj.push({"attributeName": "Placket","values": [imgattr[i]]});
       attributeObj[11] = {"attributeName": "Placket","values": [imgattr[i]]};
               if(alt == 'Regular Placket'){
                 pfsZoomPlacket = 'bsc-zoom-placket-regular.pfs';  
                 pfsPlacket = 'bsc-placket-regular.pfs';
                 pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-regular.pfs';
                 
                 $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
                 
               } else if(alt == 'French Placket'){
                 pfsZoomPlacket = 'bsc-zoom-placket-french.pfs';    
                 pfsPlacket = 'bsc-placket-french.pfs';
                 pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-french.pfs';
                 
                 $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
                 
               } else if(alt == 'Concealed Placket'){
                 pfsZoomPlacket = 'bsc-zoom-placket-concealed.pfs';
                 pfsPlacket = 'bsc-placket-concealed.pfs';
                 pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-concealed.pfs';
                 
                 $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
                 
               } else if(alt == 'Skinny Placket'){
                 pfsZoomPlacket = 'bsc-zoom-placket-skinny.pfs';
                 pfsPlacket = 'bsc-placket-skinny.pfs';
                 pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-skinny.pfs';
                 
                 $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
                 
               } else if(alt == 'Tuxedo Placket'){
                 pfsZoomPlacket = 'bsc-zoom-placket-tuxedo.pfs';
                 pfsPlacket = 'bsc-placket-tuxedo.pfs';
                 pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-tuxedo.pfs';
                 
                 $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').addClass('hide');
                 $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').addClass('hide');
               }
                     
     }else{var activeclass = '';}
           navTabPanePlacket += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPanePlacket += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_placket">';
         
           if(alt == 'Regular Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Regular Placket is seen on all traditional English and American shirts. Functionally, it adds stability to the front of the shirt.</p></div></div></div>';  
           } else if(alt == 'French Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The French placket lends a cleaner, plain front that gives the shirt a simple look. This simplicity translates into formality and hence goes well with dressier shirts.</p></div></div></div>';
           } else if(alt == 'Concealed Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Concealed Placket or the Fly front has an extra strip of fabric that covers the buttons. Seen mainly on bespoke shirts. This style can be pulled off by very few.</p></div></div></div>';  
           } else if(alt == 'Skinny Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The pencil/skinny placket is a skinny version of the regular placket. All the rage nowadays</p></div></div></div>';
           } else if(alt == 'Tuxedo Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span></div>';
           }else if(alt == 'Zipper Placket'){
             navTabPanePlacket += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span></div>';
           }
         
           //navTabPanePlacket += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPanePlacket += '</div></div>';
         }
       navTabPanePlacket += '</div></div></div>';
     }
     $('.customise-editor[data-custom="placket-btn"] .nav-tabs').html(navTabPlacket);
     $('.customise-editor[data-custom="placket-btn"] .tab-wrap').html(navTabPanePlacket);

     
     if(designAttrs[index].attributeName == 'Buttons'){
       navTabThread += '<li class="nav-item"><a href="javascript:void(0);" data-tag="buttons" class="active">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneThread += '<div class="tab-pane active" id="buttons"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
       //attributeObj.push({"attributeName": "Buttons","values": [imgattr[i]]});
                attributeObj[15] = {"attributeName": "Buttons","values": [imgattr[i]]};
                btncolor = imageValue;
     }else{var activeclass = '';}
           navTabPaneThread += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneThread += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_btnThread">';
           navTabPaneThread += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneThread += '</div></div>';
         }
       navTabPaneThread += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Button Thread Color'){
       navTabThread += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="button-thread-color" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneThread += '<div class="tab-pane hide" id="button-thread-color"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
       //attributeObj.push({"attributeName": "Button Thread Color","values": [imgattr[i]]});
         attributeObj[16] = {"attributeName": "Button Thread Color","values": [imgattr[i]]}; 
       btnthreadcolor = imageValue; 
     }else{var activeclass = '';}
           navTabPaneThread += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneThread += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_btnThread">';
           navTabPaneThread += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneThread += '</div></div>';
         }
       navTabPaneThread += '</div></div></div>';
     }
     $('.customise-editor[data-custom="thread-btn"] .nav-tabs').html(navTabThread);
     $('.customise-editor[data-custom="thread-btn"] .tab-wrap').html(navTabPaneThread);
     
     if(designAttrs[index].attributeName == 'Sleeves'){
       navTabSleeves += '<li class="nav-item"><a href="javascript:void(0);" data-tag="sleeves" class="active">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneSleeves += '<div class="tab-pane active" id="sleeves"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
       //attributeObj.push({"attributeName": "Sleeves","values": [imgattr[i]]});
               attributeObj[17] = {"attributeName": "Sleeves","values": [imgattr[i]]};
             if(alt == 'Short Sleeves' || alt == 'Short Sleeve' || alt == 'Short'){
                 pfssleeves = 'bsc-sleeve-half.pfs';
                 
                 $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.long-sleeve').addClass('hide');
                 $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.short-sleeve').removeClass('hide');
                 $('[data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('hide');

                 $('.common-btn-edit.cuff-sleeve-btn').addClass('half');
                 
                 $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
                 $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
                 console.log('pfssleeves--',pfssleeves);
               } else if(alt == 'Long Sleeves' || alt == 'Long Sleeve'){
                 pfssleeves = 'bsc-sleeve-long-regular.pfs';
                 pfsZoomsleeves = 'bsc-zoom-cuff-sleeve-long-regular.pfs';
                 
               } else if(alt == 'French Sleeves'){
                 pfssleeves = 'bsc-sleeve-long-cuff-french.pfs';
                 pfsZoomsleeves = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';
               }
                      
     }else{var activeclass = '';}
           navTabPaneSleeves += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneSleeves += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_cuffSlBtn">';
           navTabPaneSleeves += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneSleeves += '</div></div>';
         }
       navTabPaneSleeves += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Cuff Style'){
       navTabSleeves += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="cuff-style" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneSleeves += '<div class="tab-pane hide" id="cuff-style"><div class="collar-icons-wrapper"><div class="icons Grid">';
       console.log("designAttrs[index].values",designAttrs[index].values);
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
                      //attributeObj.push({"attributeName": "Cuff Style","values": [imgattr[i]]});
                      attributeObj[18] = {"attributeName": "Cuff Style","values": [imgattr[i]]};
                      if(alt == 'Single Button Cuff' || alt == 'Single Button'){
                        pfscuff = 'bsc-cuff-single-button.pfs';
                        pfsZoomcuff = 'bsc-zoom-cuff-single-button.pfs';
                      } else if(alt == 'Double Button Cuff' || alt == 'Double Button'){
                        pfscuff = 'bsc-cuff-double-button.pfs';
                        pfsZoomcuff = 'bsc-zoom-cuff-double-button.pfs';
                      } else if(alt == 'Neapolitan Cuff'){
                        pfscuff = 'bsc-cuff-neopolitan.pfs';
                        pfsZoomcuff = 'bsc-zoom-cuff-neopolitan.pfs';
                      } else if(alt == 'French Cuff' || alt == 'French cuff'){
                        cuffVar = 'french';
                        //$('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
                        pfscuff = 'bsc-sleeve-long-cuff-french.pfs';
                        pfsZoomcuff = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';
                      }
                     
     }else{var activeclass = '';}
           let tempAlt = alt;
           if(alt == 'Single Button Round Cuff'){
             tempAlt = 'Single Button Cuff';
           }else if(alt == 'Double Button Square Cuff'){
             tempAlt = 'Double Button Cuff';
           }
           navTabPaneSleeves += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+tempAlt+'" data-imageValue="'+imageValue+'">';
           navTabPaneSleeves += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_cuffSlBtn">';
         
           if(alt == 'Single Button Cuff' || alt == 'Single Button'){
             navTabPaneSleeves += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>Comes with the option of using cufflinks</p></div></div></div>';
           } else if(alt == 'Double Button Cuff' || alt == 'Double Button' || alt == 'Double Button Square Cuff'){
             navTabPaneSleeves += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The double button cuff has been popularised by various 007s from Sean Connery to Daniel Craig.</p></div></div></div>';
           } else if(alt == 'Neapolitan Cuff'){
             navTabPaneSleeves += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The Neapolitan cuff is a compromise between buttoned cuffs and link cuffs. It does fold back on itself however, and is fastened with buttons not cufflinks.</p></div></div></div>';
           } else if(alt == 'French Cuff' || alt == 'French cuff'){
             navTabPaneSleeves += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The French cuff is typically seen on formal shirts. Pair it up with cuff links or a silk knot to complete the look.</p></div></div></div>';
           } else if(alt == 'Single Button Rounded Cuff' || alt == 'Single Button Round Cuff'){
             navTabPaneSleeves += '<div class="label-box tooltip-box"><span class="title">'+alt+'</span><div class="tooltip"><span>i</span><div class="tooltip-popup"><a href="javascript:void(0);" class="tooltip-close"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg"></a><p>The French cuff is typically seen on formal shirts. Pair it up with cuff links or a silk knot to complete the look.</p></div></div></div>';
           }
           
           //navTabPaneSleeves += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneSleeves += '</div></div>';
         }
       navTabPaneSleeves += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Cuff Stiffness'){
       navTabSleeves += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="cuff-stiffness" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneSleeves += '<div class="tab-pane hide" id="cuff-stiffness"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Cuff Stiffness","values": [imgattr[i]]});
           attributeObj[19] = {"attributeName": "Cuff Stiffness","values": [imgattr[i]]};          
     }else{var activeclass = '';}
           navTabPaneSleeves += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneSleeves += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_cuffSlBtn">';
           navTabPaneSleeves += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneSleeves += '</div></div>';
         }
       navTabPaneSleeves += '</div></div></div>';
     }
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .nav-tabs').html(navTabSleeves);
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .tab-wrap').html(navTabPaneSleeves);
     
     if(designAttrs[index].attributeName == 'Back'){
       navTabBackBottomCut += '<li class="nav-item"><a href="javascript:void(0);" data-tag="back" class="active">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneBackBottomCut += '<div class="tab-pane active" id="back"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Back","values": [imgattr[i]]});
     attributeObj[22] = {"attributeName": "Back","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPaneBackBottomCut += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneBackBottomCut += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_backbtn">';
           navTabPaneBackBottomCut += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneBackBottomCut += '</div></div>';
         }
       navTabPaneBackBottomCut += '</div></div></div>';
     }
     
     if(designAttrs[index].attributeName == 'Bottom Cut'){
       navTabBackBottomCut += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="bottom-cut" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneBackBottomCut += '<div class="tab-pane hide" id="bottom-cut"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Bottom Cut","values": [imgattr[i]]});
     attributeObj[23] = {"attributeName": "Bottom Cut","values": [imgattr[i]]}; 
     }else{var activeclass = '';}
           navTabPaneBackBottomCut += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneBackBottomCut += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_backbtn">';
           navTabPaneBackBottomCut += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneBackBottomCut += '</div></div>';
         }
       navTabPaneBackBottomCut += '</div></div></div>';
     }

     if(designAttrs[index].attributeName == 'Shirt Length'){
       navTabBackBottomCut += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="shirt-length" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneBackBottomCut += '<div class="tab-pane hide" id="shirt-length"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){ 
         var imgattr = designAttrs[index].values;
         //console.log('imgattr--',imgattr);
           var alt = getParameterByName('imageTitle',imgattr[i]);
        // console.log('alt--',alt);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){
           var activeclass = 'active'; 
     attributeObj[29] = {"attributeName": "Shirt Length","values": [imgattr[i]]}; 
           console.log('attributeObj[29]--',attributeObj[29]);
     }else{var activeclass = '';}
           navTabPaneBackBottomCut += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneBackBottomCut += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_backbtn">';
           navTabPaneBackBottomCut += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneBackBottomCut += '</div></div>';
         }
       navTabPaneBackBottomCut += '</div></div></div>';
     }


     if(designAttrs[index].attributeName == 'Placket Stay'){
       navTabBackBottomCut += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="placket-stay" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneBackBottomCut += '<div class="tab-pane hide" id="placket-stay"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){ 
         var imgattr = designAttrs[index].values;
         //console.log('imgattr--',imgattr);
           var alt = getParameterByName('imageTitle',imgattr[i]);
        // console.log('alt--',alt);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){
           var activeclass = 'active'; 
     attributeObj[30] = {"attributeName": "Placket Stay","values": [imgattr[i]]}; 
           console.log('attributeObj[30]--',attributeObj[30]);
     }else{var activeclass = '';}
           navTabPaneBackBottomCut += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneBackBottomCut += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_backbtn">';
           navTabPaneBackBottomCut += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneBackBottomCut += '</div></div>';
         }
       navTabPaneBackBottomCut += '</div></div></div>';
     }

     if(designAttrs[index].attributeName == 'Stitching Thread Color'){
       navTabBackBottomCut += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="stitching-thread-color" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneBackBottomCut += '<div class="tab-pane hide" id="stitching-thread-color"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){ 
         var imgattr = designAttrs[index].values;
         //console.log('imgattr--',imgattr);
           var alt = getParameterByName('imageTitle',imgattr[i]);
        // console.log('alt--',alt);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){
           var activeclass = 'active'; 
     attributeObj[31] = {"attributeName": "Stitching Thread Color","values": [imgattr[i]]}; 
           console.log('attributeObj[31]--',attributeObj[31]);
     }else{var activeclass = '';}
           navTabPaneBackBottomCut += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneBackBottomCut += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_backbtn">';
           navTabPaneBackBottomCut += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneBackBottomCut += '</div></div>';
         }
       navTabPaneBackBottomCut += '</div></div></div>';
     }
   
     $('.customise-editor[data-custom="back-bottom-btn"] .nav-tabs').html(navTabBackBottomCut);
     $('.customise-editor[data-custom="back-bottom-btn"] .tab-wrap').html(navTabPaneBackBottomCut);
     
     /*-- Constrast Tabs --*/
     if(designAttrs[index].attributeName == 'Collar Contrast'){
       navTabCollarContrast += '<li class="nav-item"><a href="javascript:void(0);" data-tag="collar-contrast" class="active">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneCollarContrast += '<div class="tab-pane active" id="collar-contrast"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Collar Contrast","values": [imgattr[i]]});
     attributeObj[3] = {"attributeName": "Collar Contrast","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPaneCollarContrast += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneCollarContrast += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
           navTabPaneCollarContrast += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneCollarContrast += '</div></div>';
         }
       navTabPaneCollarContrast += '</div></div></div>';   
       
     }
   if(designAttrs[index].attributeName == 'Collar Contrast Material'){
       if(designAttrs[index].values.length > 0){
         var collarattr = designAttrs[index].values;
         collarContrastDefault = collarattr[0];
         //attributeObj.push({"attributeName": "Collar Contrast Material","values": [collarContrastDefault]});
         attributeObj[4] = {"attributeName": "Collar Contrast Material","values": [collarContrastDefault]};
       } else {
         collarContrastDefault = '';
         //attributeObj.push({"attributeName": "Collar Contrast Material","values": ["None"]});
         attributeObj[4] = {"attributeName": "Collar Contrast Material","values": ["None"]}
       }
     }   
     if(designAttrs[index].attributeName == 'Collar Contrast Material Name'){
       if(designAttrs[index].values.length > 0){
         //attributeObj.push({"attributeName": "Collar Contrast Material Name","values": [designAttrs[index].values[0]]});
         attributeObj[5] = {"attributeName": "Collar Contrast Material Name","values": [designAttrs[index].values[0]]};
       } else {
         //attributeObj.push({"attributeName": "Collar Contrast Material Name","values": ["None"]});
         attributeObj[5] = {"attributeName": "Collar Contrast Material Name","values": ["None"]};
       }
     }   
   
     
     if(designAttrs[index].attributeName == 'Collar Piping'){
       navTabCollarContrast += '<li class="nav-item item_'+designAttrs[index].values.length+'"><a href="javascript:void(0);" data-tag="collar-piping" class="">'+designAttrs[index].attributeName+'</a></li>';
       
       navTabPaneCollarContrast += '<div class="tab-pane hide" id="collar-piping"><div class="collar-icons-wrapper"><div class="icons Grid">';

       let checkForPiping = false;
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
         var alt = getParameterByName('imageTitle',imgattr[i]);
         if(checkForPiping == false && alt == "No Piping"){
           checkForPiping = true;
         }
       }

       if(checkForPiping){
          for (var i=0;i<designAttrs[index].values.length;i++){
            var imgattr = designAttrs[index].values;
            var alt = getParameterByName('imageTitle',imgattr[i]);
            var imageValue = getParameterByName('imageValue',imgattr[i]);
            if(alt == "No Piping"){
              var activeclass = 'active';
              attributeObj[6] = {"attributeName": "Collar Piping","values": [imgattr[i]]};
            }else{
              var activeclass = '';
            }
            navTabPaneCollarContrast += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
            navTabPaneCollarContrast += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
            navTabPaneCollarContrast += '<div class="label-box"><span class="title">'+alt+'</span></div>'
            navTabPaneCollarContrast += '</div></div>';
          }
       }else{

         
         for (var i=0;i<designAttrs[index].values.length;i++){
           var imgattr = designAttrs[index].values;
             var alt = getParameterByName('imageTitle',imgattr[i]);
             var imageValue = getParameterByName('imageValue',imgattr[i]);
              if(i == 0){
                var activeclass = 'active'; 
                //attributeObj.push({"attributeName": "Collar Piping","values": [imgattr[i]]});
                attributeObj[6] = {"attributeName": "Collar Piping","values": [imgattr[i]]}; 
                if(alt == 'Twill Tape'){
                  $('.common-btn-edit.persolise-collar').addClass('hide');
                  $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide'); 
                }
              }else{
                var activeclass = '';
              }
             navTabPaneCollarContrast += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
             navTabPaneCollarContrast += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
             navTabPaneCollarContrast += '<div class="label-box"><span class="title">'+alt+'</span></div>'
             navTabPaneCollarContrast += '</div></div>';
           }
       }
       navTabPaneCollarContrast += '</div></div></div>';   
     }
     if(designAttrs[index].attributeName == 'Collar Inside Piping'){
       if(designAttrs[index].values.length > 0){
         var collarPipingattr = designAttrs[index].values;
         pipingContrastDefault = collarPipingattr[0];
         //attributeObj.push({"attributeName": "Collar Inside Piping","values": [pipingContrastDefault]});
         //attributeObj.push({"attributeName": "Collar Inside Piping Color","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Piping Color","values": ["None"]});
         attributeObj[7] = {"attributeName": "Collar Inside Piping","values": [pipingContrastDefault]};
         attributeObj[8] = {"attributeName": "Collar Inside Piping Color","values": ["None"]};
         attributeObj[9] = {"attributeName": "Collar Piping Color","values": ["None"]};
       } else {
         pipingContrastDefault = '';
         //attributeObj.push({"attributeName": "Collar Inside Piping","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Inside Piping Color","values": ["None"]});
         //attributeObj.push({"attributeName": "Collar Piping Color","values": ["None"]});
         attributeObj[7] = {"attributeName": "Collar Inside Piping","values": ["None"]};
         attributeObj[8] = {"attributeName": "Collar Inside Piping Color","values": ["None"]};
         attributeObj[9] = {"attributeName": "Collar Piping Color","values": ["None"]};
       }
     } 
     $('.customise-editor[data-custom="contrast-collar-btn"] .nav-tabs.first').html(navTabCollarContrast);
     $('.customise-editor[data-custom="contrast-collar-btn"] .tab-wrap.first').html(navTabPaneCollarContrast);
     
     
     if(designAttrs[index].attributeName == 'Placket Contrast'){
       navTabPlacketContrast += '<li class="nav-item"><a href="javascript:void(0);" data-tag="contrast-placket" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPanePlacketContrast += '<div class="tab-pane active" id="contrast-placket"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Placket Contrast","values": [imgattr[i]]});
     attributeObj[12] = {"attributeName": "Placket Contrast","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPanePlacketContrast += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPanePlacketContrast += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
           navTabPanePlacketContrast += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPanePlacketContrast += '</div></div>';
         }
       navTabPanePlacketContrast += '</div></div></div>';
       
     }
     if(designAttrs[index].attributeName == 'Placket Contrast Material'){
        var p_cnt_tmp = getParameterByName('imageTitle',attributeObj[12]['values'][0]);
       if(designAttrs[index].values.length > 0){
         var placketContrastattr = designAttrs[index].values;
         placketContrastDefault = placketContrastattr[0];
         //attributeObj.push({"attributeName": "Placket Contrast Material","values": [placketContrastDefault]});
         //attributeObj.push({"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]});
        
          if(p_cnt_tmp=='Twill Tape'){
         attributeObj[13] = {"attributeName": "Placket Contrast Material","values": [placketContrastDefault]};
         attributeObj[14] = {"attributeName": "Placket Contrast Material Name","values": ['']};
       }else{
         attributeObj[13] = {"attributeName": "Placket Contrast Material","values": ['']};
         attributeObj[14] = {"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]};
       }
       
       } else {
     //attributeObj.push({"attributeName": "Placket Contrast Material","values": [placketContrastDefault]});
         //attributeObj.push({"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]});
         attributeObj[13] = {"attributeName": "Placket Contrast Material","values": [placketContrastDefault]};
         attributeObj[14] = {"attributeName": "Placket Contrast Material Name","values": [placketContrastDefault]};
       }
     } 
     $('.customise-editor[data-custom="contrast-placket-btn"] .nav-tabs.first').html(navTabPlacketContrast);
     $('.customise-editor[data-custom="contrast-placket-btn"] .tab-wrap.first').html(navTabPanePlacketContrast);
     
     
     if(designAttrs[index].attributeName == 'Cuff Contrast'){
       navTabCuffContrast += '<li class="nav-item"><a href="javascript:void(0);" data-tag="contrast-cuff" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPaneCuffContrast += '<div class="tab-pane active" id="contrast-cuff"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Cuff Contrast","values": [imgattr[i]]}); 
     attributeObj[20] = {"attributeName": "Cuff Contrast","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPaneCuffContrast += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneCuffContrast += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
           navTabPaneCuffContrast += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneCuffContrast += '</div></div>';
         }
       navTabPaneCuffContrast += '</div></div></div>'; 
     }
     if(designAttrs[index].attributeName == 'Cuff Contrast Material'){
       if(designAttrs[index].values.length > 0){
         var cuffContrastMaterialattr = designAttrs[index].values;
         cuffContrastDefault = cuffContrastMaterialattr[0];
         //attributeObj.push({"attributeName": "Cuff Contrast Material","values": [cuffContrastDefault]});
         attributeObj[21] = {"attributeName": "Cuff Contrast Material","values": [cuffContrastDefault]};
       } else {
         cuffContrastDefault = designCode;
         //attributeObj.push({"attributeName": "Cuff Contrast Material","values": ["None"]});
         attributeObj[21] = {"attributeName": "Cuff Contrast Material","values": ["None"]}; 
       }
     }
     $('.customise-editor[data-custom="contrast-cuff-btn"] .nav-tabs.first').html(navTabCuffContrast);
     $('.customise-editor[data-custom="contrast-cuff-btn"] .tab-wrap.first').html(navTabPaneCuffContrast);
     
   
     if(designAttrs[index].attributeName == 'Elbow Patch'){
       navTabElbowPatch += '<li class="nav-item"><a href="javascript:void(0);" data-tag="elbow-patch" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPaneElbowPatch += '<div class="tab-pane active" id="elbow-patch"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Elbow Patch","values": [imgattr[i]]});    
     attributeObj[24] = {"attributeName": "Elbow Patch","values": [imgattr[i]]}; 
     }else{var activeclass = '';}
           navTabPaneElbowPatch += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneElbowPatch += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
           navTabPaneElbowPatch += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneElbowPatch += '</div></div>';
         }
       navTabPaneElbowPatch += '</div></div></div>';
     }
     if(designAttrs[index].attributeName == 'Elbow Patch Material'){
       if(designAttrs[index].values.length > 0){
         var elbowattr = designAttrs[index].values;
         elbowPatchDefault = elbowattr[0];
         //attributeObj.push({"attributeName": "Elbow Patch Material","values": [elbowPatchDefault]});
         attributeObj[25] = {"attributeName": "Elbow Patch Material","values": [elbowPatchDefault]};
       } else {
         //attributeObj.push({"attributeName": "Elbow Patch Material","values": ["None"]});
         attributeObj[25] = {"attributeName": "Elbow Patch Material","values": ["None"]};
       }
     }
     $('.customise-editor[data-custom="elbow-patch-btn"] .nav-tabs.first').html(navTabElbowPatch);
     $('.customise-editor[data-custom="elbow-patch-btn"] .tab-wrap.first').html(navTabPaneElbowPatch);
   
   
     if(designAttrs[index].attributeName == 'Gusset'){
       navTabGusset += '<li class="nav-item"><a href="javascript:void(0);" data-tag="gusset" class="">'+designAttrs[index].attributeName+'</a></li>';
     
       navTabPaneGusset += '<div class="tab-pane active" id="gusset"><div class="collar-icons-wrapper"><div class="icons Grid">';
       for (var i=0;i<designAttrs[index].values.length;i++){
         var imgattr = designAttrs[index].values;
           var alt = getParameterByName('imageTitle',imgattr[i]);
           var imageValue = getParameterByName('imageValue',imgattr[i]);
           if(i == 0){var activeclass = 'active'; 
           //attributeObj.push({"attributeName": "Gusset","values": [imgattr[i]]}); 
     attributeObj[26] = {"attributeName": "Gusset","values": [imgattr[i]]};
     }else{var activeclass = '';}
           navTabPaneGusset += '<div class="Grid__Cell 1/3--phone 1/3--tablet-and-up 1/4--lap-and-up comoon-col-space '+activeclass+'"><div class="icon" data-alt="'+alt+'" data-imageValue="'+imageValue+'">';
           navTabPaneGusset += '<img src="" data-picario="'+imgattr[i]+'" alt="'+alt+'" class="lazyimg_contrast">';
           navTabPaneGusset += '<div class="label-box"><span class="title">'+alt+'</span></div>'
           navTabPaneGusset += '</div></div>';
         }
       navTabPaneGusset += '</div></div></div>';
       
     }
     if(designAttrs[index].attributeName == 'Gusset Material'){
       if(designAttrs[index].values.length > 0){
         var gussetattr = designAttrs[index].values;
         gussetDefault = gussetattr[0];
         //attributeObj.push({"attributeName": "Gusset Material","values": [gussetDefault]});
         attributeObj[27] = {"attributeName": "Gusset Material","values": [gussetDefault]};
       } else {
         //attributeObj.push({"attributeName": "Gusset Material","values": ["None"]});
         attributeObj[27] = {"attributeName": "Gusset Material","values": ["None"]};
       }
     }  
     $('.customise-editor[data-custom="gusset-btn"] .nav-tabs.first').html(navTabGusset);
     $('.customise-editor[data-custom="gusset-btn"] .tab-wrap.first').html(navTabPaneGusset);
     
   //}
   
   
   if($('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style') == 'Italic'){
     var fontStyleJson = 'Monotype Corsiva';
   } else {
     var fontStyleJson = 'Bell MT';
   }

   var personaliseAltJson = $('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt');
   if(personaliseAltJson == 'Placement Rib'){
     var pStyleJson = "Rib";
   } else if(personaliseAltJson == 'Placement Collar'){
     var pStyleJson = "Collar";
   } else if(personaliseAltJson == 'Placement Cuff'){
     var pStyleJson = "LEFTCUFF";
   } else if(personaliseAltJson == 'Placement Pocket'){
     var pStyleJson = "Pocket";
   } else {
     var pStyleJson = "";
   }
   
   if (isLastElement) {
     attributeObj[28] = {"attributeName": "Monogram","values": [pStyleJson,fontStyleJson,$('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(),$('.color-list-outer-box.active').attr('data-color')]}; 
     //attributeObj.push({"attributeName": "Monogram","values": [pStyleJson,fontStyleJson,$('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(),$('.color-list-outer-box.active').attr('data-color')]});
     attrObj(attributeObj);
   }  
 });

  // for toggle hide class as per options length -- START
  $.each(designAttrs, function(index, value) {
    
    let handle = designAttrs[index].attributeName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    if(designAttrs[index].attributeName == 'Collar Style'){
      // $('.common-btn-edit.collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.collar-btn').removeClass('no-options');
        $('.common-btn-edit.collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Stiffness'){
      // $('.common-btn-edit.collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.collar-btn').removeClass('no-options');
        $('.common-btn-edit.collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Top Button'){
      // $('.common-btn-edit.collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.collar-btn').removeClass('no-options');
        $('.common-btn-edit.collar-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Pocket'){
      // $('.common-btn-edit.pocket-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.pocket-btn:not(.have-options)').addClass('no-options');
        // debugger;
      }else{
        $('.common-btn-edit.pocket-btn').removeClass('no-options');
        $('.common-btn-edit.pocket-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Placket'){
      // $('.common-btn-edit.placket-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.placket-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.front-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.placket-btn').removeClass('no-options');
        $('.common-btn-edit.placket-btn').addClass('have-options');
        $('.common-btn-edit.front-btn').removeClass('no-options');
        $('.common-btn-edit.front-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Buttons'){
      // $('.common-btn-edit.thread-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.thread-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.thread-btn').removeClass('no-options');
        $('.common-btn-edit.thread-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Button Thread Color'){
      // $('.common-btn-edit.thread-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.thread-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.thread-btn').removeClass('no-options');
        $('.common-btn-edit.thread-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Sleeves'){
      // $('.common-btn-edit.cuff-sleeve-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.cuff-sleeve-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.cuff-sleeve-btn').removeClass('no-options');
        $('.common-btn-edit.cuff-sleeve-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Cuff Style'){
      // $('.common-btn-edit.cuff-sleeve-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.cuff-sleeve-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.cuff-sleeve-btn').removeClass('no-options');
        $('.common-btn-edit.cuff-sleeve-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Cuff Stiffness'){
      // $('.common-btn-edit.cuff-sleeve-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.cuff-sleeve-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.cuff-sleeve-btn').removeClass('no-options');
        $('.common-btn-edit.cuff-sleeve-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Back'){
      // $('.common-btn-edit.back-bottom-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.back-bottom-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.back-bottom-btn').removeClass('no-options');
        $('.common-btn-edit.back-bottom-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Bottom Cut'){
      // $('.common-btn-edit.back-bottom-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.back-bottom-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.back-bottom-btn').removeClass('no-options');
        $('.common-btn-edit.back-bottom-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Shirt Length'){
      // $('.common-btn-edit.back-bottom-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.back-bottom-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.back-bottom-btn').removeClass('no-options');
        $('.common-btn-edit.back-bottom-btn').addClass('have-options');
      }
    }
    
    /*-- Constrast Tabs --*/
    if(designAttrs[index].attributeName == 'Collar Contrast'){
      // $('.common-btn-edit.contrast-collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-collar-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Contrast Material'){
      // $('.common-btn-edit.contrast-collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-collar-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Contrast Material Name'){
      // $('.common-btn-edit.contrast-collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-collar-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Piping'){
      // $('.common-btn-edit.contrast-collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-collar-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-collar-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Collar Inside Piping'){
      // $('.common-btn-edit.contrast-collar-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-collar-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-collar-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-collar-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Placket Contrast'){
      // $('.common-btn-edit.contrast-placket-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-placket-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-front-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-placket-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-placket-btn').addClass('have-options');
        $('.common-btn-edit.contrast-front-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-front-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Placket Contrast Material'){
      // $('.common-btn-edit.contrast-placket-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-placket-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-front-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-placket-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-placket-btn').addClass('have-options');
        $('.common-btn-edit.contrast-front-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-front-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Cuff Contrast'){
      // $('.common-btn-edit.contrast-cuff-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-cuff-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-cuff-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-cuff-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Cuff Contrast Material'){
      // $('.common-btn-edit.contrast-cuff-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.contrast-cuff-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.contrast-cuff-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-cuff-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Elbow Patch'){
      // $('.common-btn-edit.elbow-patch-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.elbow-patch-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-elbow-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.elbow-patch-btn').removeClass('no-options');
        $('.common-btn-edit.elbow-patch-btn').addClass('have-options');
        $('.common-btn-edit.contrast-elbow-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-elbow-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Elbow Patch Material'){
      // $('.common-btn-edit.elbow-patch-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.elbow-patch-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-elbow-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.elbow-patch-btn').removeClass('no-options');
        $('.common-btn-edit.elbow-patch-btn').addClass('have-options');
        $('.common-btn-edit.contrast-elbow-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-elbow-btn').addClass('have-options');
      }
    }
    
    if(designAttrs[index].attributeName == 'Gusset'){
      // $('.common-btn-edit.gusset-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.gusset-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-gusset-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.gusset-btn').removeClass('no-options');
        $('.common-btn-edit.gusset-btn').addClass('have-options');
        $('.common-btn-edit.contrast-gusset-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-gusset-btn').addClass('have-options');
      }
    }
    if(designAttrs[index].attributeName == 'Gusset Material'){
      // $('.common-btn-edit.gusset-btn').addClass(`${handle}_${designAttrs[index].values.length}`);
      if(designAttrs[index].values.length < 2){
        $('.common-btn-edit.gusset-btn:not(.have-options)').addClass('no-options');
        $('.common-btn-edit.contrast-gusset-btn:not(.have-options)').addClass('no-options');
      }else{
        $('.common-btn-edit.gusset-btn').removeClass('no-options');
        $('.common-btn-edit.gusset-btn').addClass('have-options');
        $('.common-btn-edit.contrast-gusset-btn').removeClass('no-options');
        $('.common-btn-edit.contrast-gusset-btn').addClass('have-options');
      }
    }
    
  });
  // for toggle hide class as per options length -- END

  // check for contrast tab, if no more options then add disabled class
  if($(".customise-box #contrast .customise-btn .common-btn-edit").length == $(".customise-box #contrast .customise-btn .common-btn-edit.no-options").length){
    $(`.customise-tabs a[data-tag="contrast"]`).addClass("disabled");
  }
 
 
 $('.customise-editor .nav-item a:not(.notclickGuide)').click(function(){
   $(this).closest('.nav-tabs').find('.nav-item a').removeClass('active');
   $(this).addClass('active');
   var tagid = $(this).data('tag');
   if($(this).closest('.customise-editor').attr('data-custom') == 'collar-btn'){
     if(tagid == 'collar-style'){
       $('.collarGuideLink').closest('.nav-item').removeClass('hide');
     } else {
       $('.collarGuideLink').closest('.nav-item').addClass('hide');
     }
   }
   $(this).closest('.nav-tabs').closest('.customise-editor').find('.tab-pane').removeClass('active').addClass('hide');
   $(this).closest('.nav-tabs').closest('.customise-editor').find('#'+tagid).addClass('active').removeClass('hide');
 });
 
 var customCollar = '';
 var customPocket = '';
 var customPlacket = '';
 var customThreadButton = '';
 var customBackBottomBtn = '';
 var customSleeve = '';
 
 var personaliseMonogram = '';
 
 var fontStyle = 'Monotype Corsiva';
 
 var personaliseAlt = $('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt');
 var personaliseStyle = $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style');
 var personaliseColor = 'transparent';
 var monogramText = '';

 
 var contrastCollarBtn = '';
 var contrastCollarBtnNew = '';
 var contrastCollarQuery = '';
 var contrastCollarOutQuery = '';
 var contrastCollarOutFabriclist = '';
 
 var contrastCollarPipingBtn = '';
 var contrastCollarPipingQuery = '';
 var contrastCollarPipingFabriclist = '';
 
 var contrastPlacketBtn = '';
 var contrastPlacketTwillTape = '';
 var placketFabriclist = '';
 var contrastPlacketQuery = '';

 var contrastCuffBtn = '';
 var contrastCuffQuery = '';
 var cuffFabriclist = '';

 var contrastElbowPatchBtn = '';
 var contrastElbowPatchQuery = '';
 var ElbowPatchFabriclist = '';

 var contrastGussetBtn = '';
 var contrastGussetQuery = '';
 var GussetFabriclist = '';
 
 var contrastCollarBtn2 = '';
 
 /*-- Custom Collar  --*/
 $('.customise-popup[data-custom="collar-btn"] .icons .icon').click(function(){
   console.log('icondaata');
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);
   
   var iconalt = $(this).attr('data-alt');
   // console.log("iconalt",iconalt);
   // console.log("design_stiffff",getParameterByName('imageValue',attributeObj[1].values[0]));

   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');

   collarContrastDefault = attributeObj[4]['values'][0];

   if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Inside'){ 
     contrastCollarBtn2 =  designCode;
     contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn2+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
   } else if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Outside'){
     contrastCollarBtn2 =  collarContrastDefault;
     contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn2+'.jpg,'+contrastCollarBtn2+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
   } else {
     contrastCollarBtn2 =  designCode;
     contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
   }

   // console.log("picarioxpo",picarioxpo);
   // console.log("shirtWidth",shirtWidth);
   // console.log("contrastCollarBtn2",contrastCollarBtn2);
   // console.log("contrastCollarPipingQuery",contrastCollarPipingQuery);
    if(iconalt == 'Polo' || iconalt == 'Cuban Collar'){
                
     default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
     // console.log('default_stiff',default_stiff);   
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     

     pfsZoomFileCollar = 'bsc-zoom-collar-polo.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     
   } else if(iconalt == 'Prince Charlie'){
    
     
     default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
         
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     
     
     pfsZoomFileCollar = 'bsc-zoom-collar-prince-charlie.pfs';
     // console.log("pfsZoomFileCollar",pfsZoomFileCollar);
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     
   } else if(iconalt == 'Spread Collar'){
   default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
         
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     
     
     pfsZoomFileCollar = 'bsc-zoom-collar-spread-eagle.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Madmen' || iconalt == 'Madmen Collar'){
   
     default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
        
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
   
     pfsZoomFileCollar = 'bsc-zoom-collar-madmen.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Bandhgala'){
       default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);  
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     
     pfsZoomFileCollar = '';
     var query = '';
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').addClass('hide');
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').addClass('hide');
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').addClass('hide');
   } else if(iconalt == 'Hipster'){
         
     if($('#collar-stiffness [data-alt="Soft"]').length>0){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
        $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
         }
       
     pfsZoomFileCollar = 'bsc-zoom-collar-hipster.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Hipster Rounded'){
 
     if($('#collar-stiffness [data-alt="Soft"]').length>0){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
      }
     
     pfsZoomFileCollar = 'bsc-zoom-collar-hipster-rounded.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Concealed'){
   default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
        
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     
     pfsZoomFileCollar = 'bsc-zoom-collar-concealed-polo.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Club Collar'){
    default_stiff = getParameterByName('imageValue',attributeObj[1].values[0]);
        
     if($('#collar-stiffness [data-alt="Stiff"]').length>0 && default_stiff == 'Stiff'){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     if($('#collar-stiffness [data-alt="Soft"]').length>0  && default_stiff == 'Soft'){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
       $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     }
     
     pfsZoomFileCollar = 'bsc-zoom-collar-club.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Ozwald Boateng'){
     if($('#collar-stiffness [data-alt="Stiff"]').length>0){
     $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
        $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
      }

     pfsZoomFileCollar = 'bsc-zoom-collar-boateng.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Tuxedo Collar' || iconalt == 'Wing Collar'){
     
     if($('#collar-stiffness [data-alt="Soft"]').length>0){
     $('#collar-stiffness [data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
        $('#collar-stiffness [data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
      }

     pfsZoomFileCollar = 'bsc-zoom-collar-wing-tuxedo.pfs';
     var query = '&p.tn='+contrastCollarBtn2+'.jpg&p.tr=True,True,True,True,True';
     customCollar = picarioxpo + pfsZoomFileCollar + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').removeClass('hide').attr('src',customCollar);
   } else if(iconalt == 'Single Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-single-button.pfs';
     var query = '&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True';
     customCollar = picarioxpo + pfsZoomFileButton + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',customCollar);
     
   } else if(iconalt == 'Double Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-double-button.pfs';
     var query = '&p.tn=,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+'&p.tr=True,True';
     customCollar = picarioxpo + pfsZoomFileButton + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',customCollar);
     
   }
 });
 
 
 /*-- Pocket  --*/
 $('.customise-popup[data-custom="pocket-btn"] .icons .icon').click(function(){
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);
   
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'Single Pocket'){
     $('.common-btn-edit.persolise-pocket').removeClass('hide');
     
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';

     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
      var query = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     } else {
      var query = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     }
     
     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + query;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3').removeClass('hide').attr('src',customPocket);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
     
   } else if(iconalt == 'Single Pocket with Flap'){
     //01-11-$('.common-btn-edit.persolise-pocket').removeClass('hide');
     $('.common-btn-edit.persolise-pocket').addClass('hide');
     console.log('pcdata2')
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-flap.pfs';
     var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True';
     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + query;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3').removeClass('hide').attr('src',customPocket);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
     
   } else if(iconalt == 'Double Pocket with Flap'){
     //01-11-$('.common-btn-edit.persolise-pocket').removeClass('hide');
     $('.common-btn-edit.persolise-pocket').addClass('hide');
     
     pfsZoomPocket = 'bsc-zoom-placket-pocket-double-flap.pfs';
     var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True';
     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + query;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3').removeClass('hide').attr('src',customPocket);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
     
   } else if(iconalt == 'No Pocket'){
     $('.common-btn-edit.persolise-pocket').removeClass('added').addClass('hide');
     
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3').addClass('hide');
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').addClass('hide');
   }
 });
 
 /*-- Placket  --*/
 $('.customise-popup[data-custom="placket-btn"] .icons .icon').click(function(){
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);
   
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(getParameterByName('imageTitle',attributeObj[10]['values']) != 'No Pocket'){
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').removeClass('hide');
   }
   
   
   if(iconalt == 'Regular Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-regular.pfs';
       pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-regular.pfs';
     
       var query = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True';
       customPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + query;
       $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customPlacket);
       
       
   } else if(iconalt == 'French Placket'){
       pfsZoomPlacket = 'bsc-zoom-placket-french.pfs';
       pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-french.pfs';
     
       var query = '&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True';
       customPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + query;
       $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customPlacket);
       
   } else if(iconalt == 'Concealed Placket'){
       pfsZoomPlacket = 'bsc-zoom-placket-concealed.pfs';
       pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-concealed.pfs';
     
       var query = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.tr=True';
       customPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + query;
       $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customPlacket);
       
   } else if(iconalt == 'Skinny Placket'){
       pfsZoomPlacket = 'bsc-zoom-placket-skinny.pfs';
       pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-skinny.pfs';
     
       var query = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True';
       customPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + query;
       $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customPlacket);
       
   } else if(iconalt == 'Tuxedo Placket'){
       pfsZoomPlacket = 'bsc-zoom-placket-tuxedo.pfs';
       pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-tuxedo.pfs';
     
       var query = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+'&p.tr=True';
   customPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + query;
       $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customPlacket);
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').addClass('hide');
     
   }
   console.log("iconalt",iconalt);
 });
 
 /*-- Thread Button  --*/
 $('.customise-popup[data-custom="thread-btn"] .icons .icon').click(function(){
   var iconalt = $(this).attr('data-alt');
   
   if($(this).closest('.tab-pane').attr('id') == 'buttons'){
     btncolor = $(this).attr('data-imagevalue');
   } else if($(this).closest('.tab-pane').attr('id') == 'button-thread-color'){
     btnthreadcolor = $(this).attr('data-imagevalue');
   }
   
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(getParameterByName('imageTitle',attributeObj[11]['values']) == 'French Placket'){
     var query = '&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True';
   } else {
     var query = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True';
   }
   
   
   customThreadButton = picarioxpo + pfsZoomPlacket + shirtWidth + query;
   $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').attr('src',customThreadButton);
   $('.customise-popup[data-custom="thread-btn"] .customise-left .pocket2').attr('src',customThreadButton);
   $('.customise-popup[data-custom="pocket-btn"] .customise-left .placket2').attr('src',customThreadButton);
   
   if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';
     pfsPocket = 'bsc-pocket-single-angled.pfs';
     btnpockercolor = '';
     $('.common-btn-edit.persolise-pocket').removeClass('hide');
     $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');

     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
      var cpquery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     } else {
      var cpquery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     }
     

     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',customPocket);

   } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket with Flap'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-flap.pfs';
     pfsPocket = 'bsc-pocket-single-flap.pfs';
     btnpockercolor = btncolor+'.jpg';
     $('.common-btn-edit.persolise-pocket').addClass('hide');
     $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');

     var cpquery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True';
     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',customPocket);
     
   } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Double Pocket with Flap'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-double-flap.pfs';
     pfsPocket = 'bsc-pocket-double-flap.pfs';
     btnpockercolor = btncolor+'.jpg';
     $('.common-btn-edit.persolise-pocket').addClass('hide');
     $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');

     var cpquery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True';
     customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',customPocket);

   } else {
     btnpockercolor = '';
   }
   
   if(btnpockercolor == ''){
     if($('#pocket .Grid__Cell.active .icon').attr('data-alt') != "No Pocket"){
       $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide').attr('src',picarioxpo + pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,50&p.text.px=,0.52&p.text.py=,0.5&p.text.align=,1');
     }
   } else {
     $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide').attr('src',picarioxpo + pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btnpockercolor+'&p.c=,,,'+btnthreadcolor+'&p.tr=True');
   }
   
   
   btnthreadcolor = $('#button-thread-color .Grid__Cell.active .icon').attr('data-imagevalue');
   if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Single Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-single-button.pfs';
     var query = '&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True';
     customCollar = picarioxpo + pfsZoomFileButton + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',customCollar);
   } else if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Double Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-double-button.pfs';
     var query = '&p.tn=,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+'&p.tr=True,True';
     customCollar = picarioxpo + pfsZoomFileButton + shirtWidth + query;
     $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn3').attr('src',customCollar);
     $('.customise-popup[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',customCollar);
   }
   
 });
 
 
 /*-- Thread Button  --*/
 $('.customise-popup[data-custom="cuff-sleeve-btn"] .icons .icon').click(function(){
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);
   
   var iconalt = $(this).attr('data-alt');
   
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'Long Sleeves' || iconalt == 'Long Sleeve' || iconalt == 'Long'){
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.long-sleeve').removeClass('hide');
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.short-sleeve').addClass('hide');
     $('[data-alt="Placement Cuff"]').closest('.Grid__Cell').removeClass('hide');
     
     $('[data-tag="cuff-style"]').closest('.nav-item').removeClass('hide');
     $('[data-tag="cuff-stiffness"]').closest('.nav-item').removeClass('hide');
     
     pfsZoomsleeves = 'bsc-zoom-cuff-sleeve-long-regular.pfs';  
     var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True';
     customSleeve = picarioxpo + pfsZoomsleeves + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .placket2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket2').removeClass('hide').attr('src',customSleeve);
     
   } else if(iconalt == 'Short Sleeves' || iconalt == 'Short Sleeve'|| iconalt == 'Short'){
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.long-sleeve').addClass('hide');
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.short-sleeve').removeClass('hide');
     $('[data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('hide');
     
   $('[data-tag="cuff-style"],[data-tag="cuff-stiffness"]').closest('.nav-item').addClass('hide');
     //$('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
     //Short Sleeves

   } else if(iconalt == 'French Sleeves'){
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.long-sleeve').removeClass('hide');
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .render.short-sleeve').addClass('hide');
     $('[data-tag="cuff-style"]').closest('.nav-item').removeClass('hide');
     $('[data-tag="cuff-stiffness"]').closest('.nav-item').removeClass('hide');
     
     pfsZoomsleeves = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';  
     var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True'
     customSleeve = picarioxpo + pfsZoomsleeves + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .placket2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket2').removeClass('hide').attr('src',customSleeve);
     $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
   } else if(iconalt == 'Single Button Cuff' || iconalt == 'Single Button'){
     $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
     $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     
     pfsZoomcuff = 'bsc-zoom-cuff-single-button.pfs';
     
     if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }

     } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }
     } else {
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }
     }
     
     customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3').removeClass('hide');

   } else if(iconalt == 'Double Button Cuff' || iconalt == 'Double Button'){
     $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
     $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').removeClass('hide');
     
     pfsZoomcuff = 'bsc-zoom-cuff-double-button.pfs';
     
     if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }
     } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }
     } else {
      if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
       var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      } else {
       var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
      }
     }
     
     customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
   $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3').removeClass('hide');
   } else if(iconalt == 'Neapolitan Cuff'){
     $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
     $('[data-alt="Stiff"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
     $('[data-alt="Soft"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     
     pfsZoomcuff = 'bsc-zoom-cuff-neopolitan.pfs';
     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
      var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,500&p.text.px=,,,,,0.6&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
     } else {
      var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,500&p.text.px=,,,,,0.6&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
     }
     
     customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3').removeClass('hide');
   } else if(iconalt == 'French Cuff' || iconalt == 'French cuff'){
     $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
     $('[data-alt="Stiff"]').closest('.Grid__Cell').addClass('active').removeClass('hide');
     $('[data-alt="Soft"]').closest('.Grid__Cell').removeClass('active').addClass('hide');
     
     pfsZoomcuff = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';
     
     if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
       var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     }
     customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
     $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3').addClass('hide');
   } 
   
 });
 
 /*-- Back Bottom Button  --*/
 
 $('.customise-popup[data-custom="back-bottom-btn"] .icons .icon').click(function(){

   
   var iconalt = $(this).attr('data-alt');
   var bottomCutActive = $('[id="bottom-cut"] .Grid__Cell.active .icon').attr('data-imagevalue');
   var backActive = $('[id="back"] .Grid__Cell.active .icon').attr('data-imagevalue');
   var shirtLenActive = $('[id="back"] .Grid__Cell.active .icon').attr('data-imagevalue');
   
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'No Pleats'){
     if(bottomCutActive == 'Tuck In + Out'){
       var pfsFile = 'bsc-back-no-pleats.pfs';
     } else { 
       var pfsFile = 'bsc-back-no-pleats-long.pfs';
     }
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Box Pleats'){
     if(bottomCutActive == 'Tuck In + Out'){
       var pfsFile = 'bsc-back-box-pleats.pfs';
     } else { 
       var pfsFile = 'bsc-back-box-pleats-long.pfs';
     }
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Side Pleats'){
     if(bottomCutActive == 'Tuck In + Out'){
       var pfsFile = 'bsc-back-side-pleats.pfs';
     } else { 
       var pfsFile = 'bsc-back-side-pleats-long.pfs';
     }
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Darts'){
     if(bottomCutActive == 'Tuck In + Out'){
       var pfsFile = 'bsc-back-darts.pfs';
     } else { 
       var pfsFile = 'bsc-back-darts-long.pfs';
     }
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Deep Darts'){
     if(bottomCutActive == 'Tuck In + Out'){
       var pfsFile = 'bsc-back-deep-long.pfs';
     } else { 
       var pfsFile = 'bsc-back-deep-darts-long.pfs';
     }
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Tuck In'){
     
     if(backActive == 'No Pleats'){
       var pfsFile = 'bsc-back-no-pleats-long.pfs';
     }else if(backActive == 'Box Pleats'){
       var pfsFile = 'bsc-back-box-pleats-long.pfs';
     }else if(backActive == 'Side Pleats'){
       var pfsFile = 'bsc-back-side-pleats-long.pfs';
     }else if(backActive == 'Darts'){
       var pfsFile = 'bsc-back-darts-long.pfs';
     }else if(backActive == 'Deep Darts'){
       var pfsFile = 'bsc-back-deep-darts-long.pfs';
     }
     
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } else if(iconalt == 'Tuck In + Out'){
     
     if(backActive == 'No Pleats'){
       var pfsFile = 'bsc-back-no-pleats.pfs';
     }else if(backActive == 'Box Pleats'){
       var pfsFile = 'bsc-back-box-pleats.pfs';
     }else if(backActive == 'Side Pleats'){
       var pfsFile = 'bsc-back-side-pleats.pfs';
     }else if(backActive == 'Darts'){
       var pfsFile = 'bsc-back-darts.pfs';
     }else if(backActive == 'Deep Darts'){
       var pfsFile = 'bsc-back-deep-long.pfs';
     }
     
     var query = '&p.tn='+designCode+'.jpg&p.tr=True';
     customBackBottomBtn = picarioxpo + pfsFile + shirtWidth + query;
     $('.customise-popup[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',customBackBottomBtn);
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',customBackBottomBtn);
   } 
   
 });
 
 
 /*-- Contrast  --*/
 $('.cp.back-btn').click(function(){
   $(this).closest('.contrast-fabrics-list').removeClass('show');
   $(this).closest('.contrast-fabrics-list').siblings('.content-box-wrapper').removeClass('hide');
   
   $(this).closest('.contrast-fabrics-list').siblings('.content-box-wrapper').find('.nav-item').removeClass('hide');
   
   var activeattr = $(this).closest('.common-editable-box').find('.common-head-box .nav-item a.active').attr('data-tag');
   if(activeattr){
     $('#'+activeattr).removeClass('hide');
   } else {
     $(this).closest('.common-editable-box').find('.content-box.tab-wrap.first .tab-pane').removeClass('hide');
   }
   
 });
 
 $('.customise-popup[data-custom="contrast-collar-btn"] .icons .icon').click(function(){
   console.log('cont col btn')
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);
   
   if(attributeObj[13]['values'][0] == "None" || attributeObj[13]['values'][0] == ""){
     contrastPlacketTwillTape = "";
   } else {
     contrastPlacketTwillTape = attributeObj[13]['values'][0] + '.jpg';
   }

   if(attributeObj[14]['values'][0] == "None" || attributeObj[14]['values'][0] == ""){
     contrastPlacketBtn = "";
   } else {
     contrastPlacketBtn = attributeObj[14]['values'] + '.jpg';
   }
   
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'No Contrast'){

     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') != 'Placement Collar'){
       monogramText = '';
     } 
        
     $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active').removeClass('active');
     
     contrastCollarQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
   
     if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
       contrastCollarOutQuery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
     } else {
       contrastCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
     }
     contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
     
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',CollarFabriclist);

     console.log("contrastCollarOutFabriclist",contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',contrastCollarOutFabriclist);
   }
   
   
   if(iconalt == 'No Piping'){
     contrastCollarPipingBtn = '';
     console.log('No Piping')
     if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){

       if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
        var contrastCollarBtnNew = designCode;
        } else {
       var contrastCollarBtnNew = attributeObj[4]['values'];
       }
       
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtnNew+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     } else if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     }
     contrastCollarPipingFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarPipingQuery;
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',contrastCollarPipingFabriclist);
     
     if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
       contrastCollarOutQuery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
     }else if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       var newdesignCode = $('.contrast-fabrics-list[data-sublist="collar-contrast-fabriclist"] .icons .Grid__Cell.active').find(".icon").attr("data-code");
         contrastCollarOutQuery = '&p.tn='+newdesignCode+'.jpg&p.tr=True,True,True,True,True';
     } else {
       contrastCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
     }
     contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',contrastCollarOutFabriclist);
     
   }
   
   
   if(iconalt == 'Inside' || iconalt == 'Outside'){
     var activeCode = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active').find('.icon').attr('data-code');
     if(activeCode){
       contrastCollarBtn = activeCode;
       if(iconalt == 'Inside'){
         contrastCollarQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
           CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
         
         if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
           contrastCollarOutQuery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
         } else {
           contrastCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
         }
     contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
         
       } else {
           contrastCollarQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
           CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
      if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
             contrastCollarOutQuery = '&p.tn='+contrastCollarBtn+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';  
           } else {
             contrastCollarOutQuery = '&p.tn='+contrastCollarBtn+'.jpg&p.tr=True,True,True,True,True';
           }
           
           contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
       }
       $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
       $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
       $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',CollarFabriclist);
   $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',CollarFabriclist);
       
       $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
       $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
       $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
       $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',contrastCollarOutFabriclist);
     }
     
     
     var tabId = $(this).closest('.tab-pane').attr('id');
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').find('[data-tag="all-fabrics"]').click();
   } 
   
   if(iconalt == 'Fabric'){
     var tabId = $(this).closest('.tab-pane').attr('id');
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').find('[data-tag="all-fabrics1"]').click();
   }
   
   if(iconalt == 'Twill Tape'){
     var tabId = $(this).closest('.tab-pane').attr('id');
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="collar-twill-tape-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="collar-twill-tape-fabriclist"]').find('[data-tag="all-fabrics9"]').click();
   }
   
 });
 
 $('.customise-popup[data-custom="contrast-placket-btn"] .icons .icon').click(function(){
   var iconalt = $(this).attr('data-alt');
   if(iconalt == 'No Contrast'){
     $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     $('[data-sublist="placket-fabriclist"] .Grid__Cell.active').removeClass('active');
     $('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active').removeClass('active');
     
     contrastPlacketBtn = '';
     contrastPlacketTwillTape = '';
     
     if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
       var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
       var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else {
       var colrTwillTape = '';
     }
     console.log('collarConstrastColor123');
     if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Outside'){
      if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+collarConstrastColor+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Inside'){
       if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     }

     placketFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastPlacketQuery;
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',placketFabriclist);
     
   }
   
   if(iconalt == 'Fabric'){
     $(this).closest('.Grid__Cell').addClass('active');
     $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').removeClass('active');
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"]').find('[data-tag="all-fabrics2"]').click();
   } 
   
   if(iconalt == 'Twill Tape'){
     $(this).closest('.Grid__Cell').addClass('active');
     $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').removeClass('active');
     
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"]').find('[data-tag="all-fabrics3"]').click();
   }
   
 });
 
 $('.customise-popup[data-custom="contrast-cuff-btn"] .icons .icon').click(function(){
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'No Contrast'){
     $('[data-sublist="contrast-cuff-fabriclist"] .Grid__Cell.active').removeClass('active');
     
     contrastCuffBtn = designCode;
     
     var selectedCuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
     if(selectedCuffStyle == 'Single Button Cuff' || selectedCuffStyle == 'Single Button' || selectedCuffStyle == 'Double Button Cuff' || selectedCuffStyle == 'Double Button'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
       
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(selectedCuffStyle == 'French Cuff' || selectedCuffStyle == 'French cuff'){
       
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(selectedCuffStyle == 'Neapolitan Cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
     }
     
     cuffFabriclist = picarioxpo + pfsZoomcuff + shirtWidth + contrastCuffQuery;
     $('.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2,.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').attr('src',cuffFabriclist);
     
   }
   
   if(iconalt == 'Inside' || iconalt == 'Full' || iconalt == 'Full Cuff'){
     var tabId = $(this).closest('.tab-pane').attr('id');
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="'+tabId+'-fabriclist"]').find('[data-tag="all-fabrics4"]').click(); 
   }
   
 });
 
 $('.customise-popup[data-custom="elbow-patch-btn"] .icons .icon').click(function(){
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'No Elbow Patch'){
     $('[data-sublist="elbow-patch-fabriclist"] .Grid__Cell.active').removeClass('active');
     $('[data-sublist="elbow-patch-suede-fabriclist"] .Grid__Cell.active').removeClass('active');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').addClass('hide');
   }
   
   
   if(iconalt == 'Fabric'){
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="elbow-patch-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="elbow-patch-fabriclist"]').find('[data-tag="all-fabrics5"]').click();
   } else if(iconalt == 'Suede'){
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="elbow-patch-suede-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="elbow-patch-suede-fabriclist"]').find('[data-tag="all-fabrics6"]').click();
   } 
   
 });
 
 $('.customise-popup[data-custom="gusset-btn"] .icons .icon').click(function(){
   var iconalt = $(this).attr('data-alt');
   $(this).closest('.tab-pane').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   
   if(iconalt == 'No Gusset'){
     $('[data-sublist="gusset-fabriclist"] .Grid__Cell.active').removeClass('active');
     $('[data-sublist="gusset-suede-fabriclist"] .Grid__Cell.active').removeClass('active');
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').addClass('hide');
   }
   
   if(iconalt == 'Fabric'){
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="gusset-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="gusset-fabriclist"]').find('[data-tag="all-fabrics7"]').click();
   } else if(iconalt == 'Suede'){
     $(this).closest('.content-box-wrapper').addClass('hide');
     $(this).closest('.common-editable-box').find('[data-sublist="gusset-suede-fabriclist"]').addClass('show');
     $(this).closest('.common-editable-box').find('[data-sublist="gusset-suede-fabriclist"]').find('[data-tag="all-fabrics8"]').click();
   }
   
 });
 
 
 function fabricBoxes(){
   
   $('[data-sublist="collar-contrast-fabriclist"] .icons .icon').click(function(){
     console.log('hellllo')
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastCollarBtn = $(this).attr('data-code');
     
     if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       contrastCollarQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
       
       contrastCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
       contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
       console.log('contrastCollarOutFabriclist--',contrastCollarOutFabriclist);
     } else if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       contrastCollarQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
       
       contrastCollarOutQuery = '&p.tn='+contrastCollarBtn+'.jpg&p.tr=True,True,True,True,True';
       contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
       console.log('contrastCollarOutFabriclist==>',contrastCollarOutFabriclist);
     }
     
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',CollarFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',CollarFabriclist);
     
     
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollarOutFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',contrastCollarOutFabriclist);
     
   });  
   
   $('[data-sublist="collar-piping-fabriclist"] .icons .icon,[data-sublist="collar-twill-tape-fabriclist"] .icons .icon').click(function(){
     
     if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
       $('[data-sublist="collar-piping-fabriclist"] .Grid__Cell.active').removeClass('active');
     } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
       $('[data-sublist="collar-twill-tape-fabriclist"] .Grid__Cell.active').removeClass('active');
     }

     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');

     contrastCollarPipingBtn = $(this).attr('data-code') + '.jpg';
     
     if($('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active').length == 0){
       contrastCollarBtn = designCode;
     }
     
     
     if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     } else if($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       contrastCollarPipingQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     }
     
     contrastCollarPipingFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarPipingQuery;
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',contrastCollarPipingFabriclist);
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',contrastCollarPipingFabriclist);
     
   });  
   
   $('[data-sublist="placket-fabriclist"] .icons .icon').click(function(){
     console.log("yetttttt");
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastPlacketBtn = $(this).attr('data-code') + '.jpg';
     
     if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
   var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
   var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else {
   var colrTwillTape = '';
     }
     
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     }
     
     //contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     placketFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastPlacketQuery;
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',placketFabriclist);
     console.log("placketFabriclist",placketFabriclist);
     
   });  
   
    $('[data-sublist="placket-twill-tape-fabriclist"] .icons .icon').click(function(){
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastPlacketTwillTape = $(this).attr('data-code') + '.jpg';
     
     if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
   var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
   var colrTwillTape = attributeObj[7]['values'] + '.jpg';
     } else {
   var colrTwillTape = '';
     }
     
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';  
     }
     
     placketFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastPlacketQuery;
     $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',placketFabriclist);
   
   });  
   
   $('[data-sublist="contrast-cuff-fabriclist"] .icons .icon').click(function(){
     console.log('nnn');
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastCuffBtn = $(this).attr('data-code');
     console.log('contrastCuffBtn',contrastCuffBtn);
     var selectedCuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
     if(selectedCuffStyle == 'Single Button Cuff' || selectedCuffStyle == 'Single Button' || selectedCuffStyle == 'Double Button Cuff' || selectedCuffStyle == 'Double Button'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
       
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(selectedCuffStyle == 'French Cuff' || selectedCuffStyle == 'French cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(selectedCuffStyle == 'Neapolitan Cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
     }
     
     cuffFabriclist = picarioxpo + pfsZoomcuff + shirtWidth + contrastCuffQuery;
     $('.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2,.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').attr('src',cuffFabriclist);
     
   });
   
   $('[data-sublist="elbow-patch-fabriclist"] .icons .icon').click(function(){
     $('[data-sublist="elbow-patch-suede-fabriclist"] .Grid__Cell.active').removeClass('active');
     
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     
     contrastElbowPatchBtn = $(this).attr('data-code') + '.jpg';
     contrastElbowPatchQuery = '&p.tn='+contrastElbowPatchBtn+'&p.tr=True';
     ElbowPatchFabriclist = picarioxpo + pfsZoomBackElbowPatches + shirtWidth + contrastElbowPatchQuery;
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').removeClass('hide').attr('src',ElbowPatchFabriclist);
     
   });
   
   $('[data-sublist="elbow-patch-suede-fabriclist"] .icons .icon').click(function(){
     $('[data-sublist="elbow-patch-fabriclist"] .Grid__Cell.active').removeClass('active');
     
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastElbowPatchBtn = $(this).attr('data-code') + '.jpg';
     contrastElbowPatchQuery = '&p.tn='+contrastElbowPatchBtn+'&p.tr=True';
     ElbowPatchFabriclist = picarioxpo + pfsZoomBackElbowPatches + shirtWidth + contrastElbowPatchQuery;
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').removeClass('hide').attr('src',ElbowPatchFabriclist);
   });
   
   $('[data-sublist="gusset-fabriclist"] .icons .icon').click(function(){
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastGussetBtn = $(this).attr('data-code') + '.jpg';
     contrastGussetQuery = '&p.tn='+contrastGussetBtn+'&p.tr=True';
     GussetFabriclist = picarioxpo + pfsZoomGussets + shirtWidth + contrastGussetQuery;
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').removeClass('hide').attr('src',GussetFabriclist);
     
   });
   
   $('[data-sublist="gusset-suede-fabriclist"] .icons .icon').click(function(){
     $(this).closest('.Grid').find('.Grid__Cell').removeClass('active');
     $(this).closest('.Grid__Cell').addClass('active');
     contrastGussetBtn = $(this).attr('data-code') + '.jpg';
     contrastGussetQuery = '&p.tn='+contrastGussetBtn+'&p.tr=True';
     GussetFabriclist = picarioxpo + pfsZoomGussets + shirtWidth + contrastGussetQuery;
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').removeClass('hide').attr('src',GussetFabriclist);
     
   });
   
    $(".icons .icon").click(function(){
     $('.customise-editor:visible .render-img-box .render img').removeClass('added');
     var notinclud = $(this).attr('data-alt');
     if(notinclud == 'Soft'|| notinclud == 'Stiff' || notinclud == 'Bandhgala' || notinclud == 'No Pocket' || notinclud == 'Short Sleeves' || notinclud == 'No Piping'  || notinclud == 'No Contrast' || notinclud == 'No Elbow Patch' || notinclud == 'No Gusset'){
       return false;
     }
     else{
       $(this).find('.loader-icon').show();
       $(this).addClass('loadimg');
       loaderImagesiconbtn();
     }
   });
   
 }
 
 /*-- Personalise  --*/
 $('.customise-popup[data-custom="personalise-collar-btn"] .icons .icon').click(function(){
   var personaliseAlt = $(this).attr('data-alt');
   $(this).closest('.Placement__Grid').find('.Grid__Cell').removeClass('active');
   $(this).closest('.Grid__Cell').addClass('active');
   personalizeMonogram();
 });
 
 $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col').click(function(){
   var personaliseStyle = $(this).attr('data-style');
   $(this).closest('.style-row').find('.style-col').removeClass('active');
   $(this).addClass('active');
   personalizeMonogram();
 });
 
 $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box').click(function(){
   var personaliseColor = $(this).attr('data-color');
   $(this).closest('.thread-color').find('.color-list-outer-box').removeClass('active');
   $(this).addClass('active');
   personalizeMonogram();
 });
 
 function limitText(field, maxChar){
   var ref = $(field),
       val = ref.val();
   if ( val.length >= maxChar ){
     ref.val(function() {
       return val.substr(0, maxChar);       
     });
   }
 }

 $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').keyup(function(){
   limitText(this, 3)
   
   $(this).val($(this).val().toUpperCase()); 
   if (this.value.match(/[^a-zA-Z0-9 ]/g)){
     this.value = this.value.replace(/[^a-zA-Z0-9 ]/g, '');
    }
   
   // if($(this).val() == ''){
   //   $('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').removeClass('hide');
   // } else {
   //   $('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').addClass('hide');
   // }
   personalizeMonogram();
 });
 function personalizeMonogram(){
   console.log('IN mono');
   btncolor = getParameterByName('imageValue',attributeObj[15]['values']);
   btnthreadcolor = getParameterByName('imageValue',attributeObj[16]['values']);

     if(attributeObj[21]['values'] == "None" || attributeObj[21]['values'] == ""){
       var cuffContrastMono = designCode;
     } else {
       var cuffContrastMono = attributeObj[21]['values'][0];
     }
   
   personaliseAlt = $('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt');
   personaliseStyle = $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style');
   personaliseColor = $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box.active').attr('data-color');
   monogramText = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();

   if(personaliseStyle == 'Italic'){
     fontStyle = 'Monotype Corsiva';
   } else {
     fontStyle = 'Bell%20MT';
   }
     
   if(personaliseAlt == 'Placement Rib'){
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').removeClass('hide');  
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');

     if(attributeObj[13]['values'] == "None" || attributeObj[13]['values'] == ""){
       var ArrPlacketContrastMaterial = "";
     } else {
       var ArrPlacketContrastMaterial = attributeObj[13]['values'] + '.jpg';
     }
  
     if(attributeObj[14]['values'] == "None" || attributeObj[14]['values'] == ""){
       var ArrPlacketContrastMaterialName = "";
     } else {
       var ArrPlacketContrastMaterialName = attributeObj[14]['values'] + '.jpg';
     }

     if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
     var ArrCollarContrast = "";
     console.log(attributeObj,"-----attributeObj-----");
   } else {
     var ArrCollarContrast = attributeObj[4]['values'] + '.jpg';
   }
     
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+ArrCollarContrast+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     }  else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     }else{
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     }
     //var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+attributeObj[4]['values'][0]+'.jpg,'+attributeObj[4]['values'][0]+'.jpg,'+attributeObj[14]['values'][0]+'.jpg,'+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     personaliseMonogram = picarioxpo + pfsBottomCollar + shirtWidth + personaliseQuery;
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt1').attr('src',personaliseMonogram);
     
     if(getParameterByName('imageTitle',attributeObj[18]['values']) == 'French cuff' || getParameterByName('imageTitle',attributeObj[18]['values']) == 'French Cuff'){
       //var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
        if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
         var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
         var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+cuffContrastMono+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(getParameterByName('imageTitle',attributeObj[18]['values']) == 'Neapolitan Cuff'){
       var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
     }else {
       if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
         var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
         var hideMonogramCuff = '&p.tn='+cuffContrastMono+'.jpg,'+cuffContrastMono+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       } else {
         var hideMonogramCuff = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       }
     }
     var hidecuffmonogram = picarioxpo + pfscuff + shirtWidth + hideMonogramCuff;
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt4').attr('src',hidecuffmonogram);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
     
   } else if(personaliseAlt == 'Placement Collar'){
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');

       if(attributeObj[13]['values'][0] == "None" || attributeObj[13]['values'][0] == ""){
         contrastPlacketTwillTape = "";
       } else {
         contrastPlacketTwillTape = attributeObj[13]['values'][0] + '.jpg';
       }
        if(attributeObj[7]['values'][0] == "None" || attributeObj[7]['values'][0] == ""){
         contrastCollarPipingBtn = "";
       } else {
         contrastCollarPipingBtn = attributeObj[7]['values'][0] + '.jpg';
       }
     
     if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Inside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
        var contrastCollarBtnNew = designCode;
        } else {
         var contrastCollarBtnNew = attributeObj[4]['values'];
        }
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtnNew+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       
     } else if(getParameterByName('imageTitle',attributeObj[3]['values']) == 'Outside' || getParameterByName('imageTitle',attributeObj[3]['values']) == 'Full Collar'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
        var contrastCollarBtnNew = designCode;
        } else {
         var contrastCollarBtnNew = attributeObj[4]['values'];
        }
      
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtnNew+'.jpg,'+contrastCollarBtnNew+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     } else {
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       console.log("no contrast query",personaliseQuery);
       console.log("contrastPlacketBtn",contrastPlacketBtn);
       console.log("contrastPlacketTwillTape",contrastPlacketTwillTape);
       console.log("contrastCollarPipingBtn",contrastCollarPipingBtn);
       
    
     }
     personaliseMonogram = picarioxpo + pfszoomBottomCollar + shirtWidth + personaliseQuery;
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1,.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src',personaliseMonogram);
    $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
   } else if(personaliseAlt == 'Placement Cuff'){
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').removeClass('hide');  
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');
     if(getParameterByName('imageTitle',attributeObj[18]['values']) == 'French cuff' || getParameterByName('imageTitle',attributeObj[18]['values']) == 'French Cuff'){
       //var personaliseQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+cuffContrastMono+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
         var personaliseQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
         var personaliseQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+cuffContrastMono+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
     } else if(getParameterByName('imageTitle',attributeObj[18]['values']) == 'Neapolitan Cuff'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
     }else {
       if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Inside'){
         var personaliseQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastMono+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       } else if(getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full' || getParameterByName('imageTitle',attributeObj[20]['values']) == 'Full Cuff') {
         var personaliseQuery = '&p.tn='+cuffContrastMono+'.jpg,'+cuffContrastMono+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       } else {
         var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       }
     }
     
     var personaliseCuffMonogram = picarioxpo + pfscuff + shirtWidth + personaliseQuery;
     
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt4').attr('src',personaliseCuffMonogram);

     if(attributeObj[13]['values'] == "None" || attributeObj[13]['values'] == ""){
       var ArrPlacketContrastMaterial = "";
     } else {
       var ArrPlacketContrastMaterial = attributeObj[13]['values'] + '.jpg';
     }
  
     if(attributeObj[14]['values'] == "None" || attributeObj[14]['values'] == ""){
       var ArrPlacketContrastMaterialName = "";
     } else {
       var ArrPlacketContrastMaterialName = attributeObj[14]['values'] + '.jpg';
     }

    if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
     var ArrCollarContrast = "";
   } else {
     var ArrCollarContrast = attributeObj[4]['values'] + '.jpg';
   }
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       var hideMonogramQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+ArrCollarContrast+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       var hideMonogramQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     
     }else{
       var hideMonogramQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+contrastCollarPipingBtn+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     }
     //var hideMonogramQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     var hidemonogram = picarioxpo + pfsBottomCollar + shirtWidth + hideMonogramQuery;
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt1').attr('src',hidemonogram);
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
     
   } else if(personaliseAlt == 'Placement Pocket'){
     
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
  $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide');
     
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide'); 
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').removeClass('hide');
     
     if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket with Flap'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
     } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Double Pocket with Flap'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
     } 
     
     if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'No Pocket'){
       $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1')
     }
     
     var personalisePocketMonogram = picarioxpo + pfsZoomPocket + shirtWidth + personaliseQuery;
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket .personalise-pocket3').attr('src',personalisePocketMonogram);
   } else if(personaliseAlt == 'Placement Chest'){
     
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
  $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
  $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').addClass('hide');
     
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide'); 
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').removeClass('hide');
     
     if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Single Pocket with Flap'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
     } else if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'Double Pocket with Flap'){
       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
     } 
     
     if(getParameterByName('imageTitle',attributeObj[10]['values']) == 'No Pocket'){
       $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1')
     }
     
     var personalisePocketMonogram = picarioxpo + pfsZoomPocket + shirtWidth + personaliseQuery;
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket .personalise-pocket3').attr('src',personalisePocketMonogram);
   } 
   console.log('personaliseAlt',personaliseAlt);
 }
}

function refreshMainshirt(){
  //   if($('body').hasClass('temp_webview')){ 
  //  if($('.common-btn-edit.added').length > 0){
  //    $('[href="#Exit_Popup"]').removeClass();
  //    $('[href="#Exit_Popup"]').addClass('Exit_Popup');
  //  }else{
  //     $('[href="#Exit_Popup"]').addClass('close_webview');
  //  }
  // }
  if(JSON.stringify(attributeObj) === JSON.stringify(customObjnewDefault)){ 
  } else {
    var differenceArrObj = {};
    var differenceArrObjA = [];

    console.log("attributeObj___",attributeObj);
    // console.log("customObjnewDefault",customObjnewDefault);
    
    
    $.each(attributeObj, function(index, value) {

      // console.log("value__111",value);
      var isLastElement = index == attributeObj.length -1;
      // console.log("index",index,"attributeObj[index]",attributeObj[index],"customObjnewDefault[index]",customObjnewDefault[index]);
      console.log(attributeObj[index]['values'],"attributeObj[index]['values']");
      
      if(attributeObj[index]['values'][0] != customObjnewDefault[index]['values'][0]){
        var imgattrDif = attributeObj[index].values;
        // console.log("imgattrDif",imgattrDif);
       // differenceArrObjA[index] = {"attributeName": attributeObj[index]['attributeName'],"values": [imgattrDif[0]]};
        differenceArrObjA[index] = {"attributeName": attributeObj[index]['attributeName'],"values": [imgattrDif[0],imgattrDif[1],imgattrDif[2],imgattrDif[3]]};
      }

       if (isLastElement) {
         differenceArrObj["attributes"] = differenceArrObjA;

        //  console.log('differenceArrObj',differenceArrObj);
         if(differenceArrObj.attributes.length > 0 ){
           
          //  console.log('diff1',differenceArrObj);
           $('[name="properties[_customized_attributes]"]').val(JSON.stringify(differenceArrObj));
         }else{
          //  console.log('diff0',differenceArrObj);
           $('[name="properties[_customized_attributes]"]').val('');
         }      
       }
    });
  }
  // console.log(attributeObj);
  
   var NewDesignCode = designCode + '.jpg';

   var ArrCollar = getParameterByName('imageTitle',attributeObj[3]['values']);

   if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
     var ArrCollarContrast = "";
   } else {
     var ArrCollarContrast = attributeObj[4]['values'] + '.jpg';
   }

   if(attributeObj[7]['values'] == "None" || attributeObj[7]['values'] == ""){
     var ArrCollarInsidePiping = "";
   } else {
     var ArrCollarInsidePiping = attributeObj[7]['values'] + '.jpg';
   }

   if(attributeObj[13]['values'] == "None" || attributeObj[13]['values'] == ""){
     var ArrPlacketContrastMaterial = "";
   } else {
     var ArrPlacketContrastMaterial = attributeObj[13]['values'] + '.jpg';
   }

   if(attributeObj[14]['values'] == "None" || attributeObj[14]['values'] == ""){
     var ArrPlacketContrastMaterialName = "";
   } else {
     var ArrPlacketContrastMaterialName = attributeObj[14]['values'] + '.jpg';
   }

   var MonogramStyle = attributeObj[28]['values'][0];
   //var MonogramFont  = attributeObj[28]['values'][1];
   var MonogramText  = attributeObj[28]['values'][2];
   var MonogramColor  = attributeObj[28]['values'][3];
   //console.log('MonogramColor',MonogramColor);
   if(attributeObj[28]['values'][3] == 'self'){
     var MonogramColor = 'C4C4C4';
   } else {
      var MonogramColor  = attributeObj[28]['values'][3];
   }
   if(attributeObj[28]['values'][1] == 'Italic'){
     var MonogramFont = 'Monotype%20Corsiva';
   } else {
     var MonogramFont = 'Bell%20MT';
   }


   var ArrCollarTopButton = getParameterByName('imageTitle',attributeObj[2]['values']);
   var ArrButtons = getParameterByName('imageValue',attributeObj[15]['values']);
   var ArrButtonThreadColor = getParameterByName('imageValue',attributeObj[16]['values']);
   var ArrCollarStyle = getParameterByName('imageTitle',attributeObj[0]['values']);


   var ArrPocket = getParameterByName('imageTitle',attributeObj[10]['values']);
   var ArrPlacket = getParameterByName('imageTitle',attributeObj[11]['values']);

   var ArrBack = getParameterByName('imageTitle',attributeObj[22]['values']);
   var ArrBottomCut = getParameterByName('imageTitle',attributeObj[23]['values']);

   var ArrSleeves = getParameterByName('imageValue',attributeObj[17]['values']);
   var ArrElbowPatch = getParameterByName('imageTitle',attributeObj[24]['values']);
   if(attributeObj[25]['values'] == "None" || attributeObj[25]['values'] == ""){
     var ArrElbowPatchMaterial = "";
   } else {
     var ArrElbowPatchMaterial = attributeObj[25]['values']+'.jpg';
   }

   if(attributeObj[27]['values'] == "None" || attributeObj[27]['values'] == ""){
     var ArrGussetMaterial = "";
   } else {
     var ArrGussetMaterial = attributeObj[27]['values']+'.jpg';
   }

   var ArrCuffStyle = getParameterByName('imageTitle',attributeObj[18]['values']);
   console.log('ArrCuffStyle',ArrCuffStyle);
   if(ArrCuffStyle == 'Neapolitan Cuff' ){
     $('.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
     //$('[data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('hide');
   }
   var ArrCuffContrast = getParameterByName('imageTitle',attributeObj[20]['values']);
   if(attributeObj[21]['values'] == "None" || attributeObj[21]['values'] == ""){
     var ArrCuffContrastMaterial = designCode + '.jpg';
   } else {
     var ArrCuffContrastMaterial = attributeObj[21]['values']+'.jpg';
   }  

   $('#style .style2,#contrast .contrast2,#personalise .personalise2,[data-custom="personalise-collar-btn"] .personalise-shirt2').removeClass("hide");


   if(ArrCollarStyle == 'Polo'){
     pfsZoomFileCollar = 'bsc-zoom-collar-polo.pfs';
     pfsFileCollar = 'bsc-collar-polo.pfs';
   } else if(ArrCollarStyle == 'Prince Charlie'){
     pfsZoomFileCollar = 'bsc-zoom-collar-prince-charlie.pfs';
     pfsFileCollar = 'bsc-collar-prince-charile.pfs';
   } else if(ArrCollarStyle == 'Spread Collar'){
     pfsZoomFileCollar = 'bsc-zoom-collar-spread-eagle.pfs';
     pfsFileCollar = 'bsc-collar-spread-eagle.pfs';
   } else if(ArrCollarStyle == 'Madmen' || ArrCollarStyle == 'Madmen Collar'){
     pfsZoomFileCollar = 'bsc-zoom-collar-madmen.pfs';
     pfsFileCollar = 'bsc-collar-madmen.pfs';
   } else if(ArrCollarStyle == 'Bandhgala'){
     pfsZoomFileCollar = '';
     pfsFileCollar = '';
     $('#style .style2,#contrast .contrast2,#personalise .personalise2,[data-custom="personalise-collar-btn"] .personalise-shirt2,[data-custom="cuff-sleeve-btn"] .cuff-short-sleeve2').addClass("hide");
   } else if(ArrCollarStyle == 'Hipster'){
     pfsZoomFileCollar = 'bsc-zoom-collar-hipster.pfs';
     pfsFileCollar = 'bsc-collar-hipster.pfs';
   } else if(ArrCollarStyle == 'Hipster Rounded'){
     pfsZoomFileCollar = 'bsc-zoom-collar-hipster-rounded.pfs';
     pfsFileCollar = 'bsc-collar-hipster-rounded.pfs';
   } else if(ArrCollarStyle == 'Concealed'){
     pfsZoomFileCollar = 'bsc-zoom-collar-concealed-polo.pfs';
     pfsFileCollar = 'bsc-collar-concealed-polo.pfs';
   } else if(ArrCollarStyle == 'Club Collar'){
     pfsZoomFileCollar = 'bsc-zoom-collar-club.pfs';
     pfsFileCollar = 'bsc-collar-club.pfs';
   } else if(ArrCollarStyle == 'Ozwald Boateng'){
     pfsZoomFileCollar = 'bsc-zoom-collar-boateng.pfs';
     pfsFileCollar = 'bsc-collar-boateng.pfs';
   } else if(ArrCollarStyle == 'Tuxedo Collar' || ArrCollarStyle == 'Wing Collar'){
     pfsZoomFileCollar = 'bsc-zoom-collar-wing-tuxedo.pfs';
     pfsFileCollar = 'bsc-collar-wing-tuxedo.pfs';
   } 


   if(ArrPlacket == 'Regular Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-regular.pfs';  
     pfsPlacket = 'bsc-placket-regular.pfs';
     pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-regular.pfs';
   } else if(ArrPlacket == 'French Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-french.pfs';    
     pfsPlacket = 'bsc-placket-french.pfs';
     pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-french.pfs';

   } else if(ArrPlacket == 'Concealed Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-concealed.pfs';
     pfsPlacket = 'bsc-placket-concealed.pfs';
     pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-concealed.pfs';

   } else if(ArrPlacket == 'Skinny Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-skinny.pfs';
     pfsPlacket = 'bsc-placket-skinny.pfs';
     pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-skinny.pfs';

   } else if(ArrPlacket == 'Tuxedo Placket'){
     pfsZoomPlacket = 'bsc-zoom-placket-tuxedo.pfs';
     pfsPlacket = 'bsc-placket-tuxedo.pfs';
     pfsZoomCollarPlacket = 'bsc-zoom-collar-placket-tuxedo.pfs';
   }

   if(MonogramStyle == "Collar" || $('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
     var MonogramCollar = MonogramText;
   } else {
     var MonogramCollar = "";
   }

   if(ArrCollar == "Outside"){
     var collar1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrCollarContrast+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+MonogramCollar+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     if(ArrCollarStyle == 'Polo' || ArrCollarStyle == 'Concealed'){
       var collar2 = '&p.tn='+ArrCollarContrast+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
     } else {
       var collar2 = '&p.tn='+ArrCollarContrast+'&p.tr=True,True,True,True,True';
     }

     
     console.log("collar1",collar1);
   } else if(ArrCollar == "Inside"){
     var collar1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+MonogramCollar+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     if(ArrCollarStyle == 'Polo' || ArrCollarStyle == 'Concealed'){
       var collar2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
     } else {
       var collar2 = '&p.tn='+NewDesignCode+'&p.tr=True,True,True,True,True';
     }
   } else {
     var collar1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+MonogramCollar+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
     if(ArrCollarStyle == 'Polo' || ArrCollarStyle == 'Concealed'){
       var collar2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
     } else {
       var collar2 = '&p.tn='+NewDesignCode+'&p.tr=True,True,True,True,True';
     }
   }
 
   if(ArrCollarTopButton == 'Single Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-single-button.pfs';
     pfsFileButton = 'bsc-collar-base-single-button.pfs';
     var collar3 = '&p.tn='+ArrButtons+'.jpg&p.c=,'+ArrButtonThreadColor+',ffffff&p.tr=True,True';
   } else if(ArrCollarTopButton == 'Double Button'){
     pfsZoomFileButton = 'bsc-zoom-collar-bottom-double-button.pfs';
     pfsFileButton = 'bsc-collar-base-double-button.pfs';
     var collar3 = '&p.tn=,'+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True';
   }
   var collar4 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True';
  
     /*-- Collar Style, Collar Stiffness, Collar Top Button - Popup Image --*/
  if($('.customise-popup.customise-editor[data-custom="collar-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="contrast-collar-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="contrast-placket-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="personalise-collar-btn"]:not(.hide)').length > 0){
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500'+collar1);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500'+collar2);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500'+collar3);
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn4,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500'+collar4);
   }

    console.log("ArrPlacket",ArrPlacket);
   if(ArrPocket == 'Single Pocket'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';
     pfsPocket = 'bsc-pocket-single-angled.pfs';
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').removeClass('hide')
      $('.common-btn-edit.persolise-chest').addClass('hide');
     $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
   } else if(ArrPocket == 'Single Pocket with Flap'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-single-flap.pfs';
     pfsPocket = 'bsc-pocket-single-flap.pfs';
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').removeClass('hide')
      $('.common-btn-edit.persolise-chest').addClass('hide');
     $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
   } else if(ArrPocket == 'Double Pocket with Flap'){
     pfsZoomPocket = 'bsc-zoom-placket-pocket-double-flap.pfs';
     pfsPocket = 'bsc-pocket-double-flap.pfs';
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').removeClass('hide')
      $('.common-btn-edit.persolise-chest').addClass('hide');
     $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
   } else if(ArrPocket == 'No Pocket'){
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').addClass('hide')
     if(ArrPlacket == 'Tuxedo Placket'){
       $('.common-btn-edit.persolise-chest').addClass('hide');
       $('.common-btn-edit.pocket-btn').addClass('hide');
     }else{
       $('.common-btn-edit.persolise-chest').removeClass('hide');
       $('.common-btn-edit.pocket-btn').removeClass('hide');
     } 
      $('.common-btn-edit.persolise-pocket').addClass('hide');
     $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
   } else {
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').addClass('hide')
     $('.common-btn-edit.persolise-pocket').addClass('hide');
     $('.common-btn-edit.persolise-chest').addClass('hide');
     $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
     $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
   }
 
   if(MonogramStyle == "Pocket"){
     var MonogramPocket = MonogramText;
   } else {
     var MonogramPocket = "";
   }
   if(MonogramStyle == "Chest"){
     var MonogramChest = MonogramText;
   } else {
     var MonogramChest = "";
   }
 
   if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
    var pocket1 = '&p.tn='+NewDesignCode+',,,,&p.trt=,,,90&p.text=,'+MonogramPocket+'&p.tpy=,,,,,,,0&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1';
   } else if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Chest'){
     console.log("MonogramText",MonogramText);
    var pocket1 = '&p.tn='+NewDesignCode+',,,,&p.trt=,,,90&p.text=,'+MonogramChest+'&p.tpy=,,,,,,,0&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1';
   } else  {
    var pocket1 = '&p.tn='+NewDesignCode+',,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1';
   }
   
   if(ArrPlacket == 'French Placket'){
     var pocket2 = '&p.tn='+ArrButtons+'.jpg&p.c=,'+ArrButtonThreadColor+',ffffff&p.tr=True';
   } else {
     var pocket2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True';
   }
 
 
   // if(ArrPocket == 'Single Pocket'){
   //   if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
   //    var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';
   //   } else {
   //    var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';
   //   }
   // } else if(ArrPocket == 'Single Pocket with Flap'){
   //   var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';
   // } else if(ArrPocket == 'Double Pocket with Flap'){
   //   var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';
   // } else {
   //   if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
   //    var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';  
   //   } else {
   //    var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1';  
   //   }
   // }

  if(ArrPocket == 'Single Pocket'){
     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
      var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     } else {
      var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
     }
   } else if(ArrPocket == 'Single Pocket with Flap'){
     var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
   } else if(ArrPocket == 'Double Pocket with Flap'){
     var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
   } else {
     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
      var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';  
     } else {
      var pocket3 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';  
     }
   }
  
     /*-- Pocket,placket,Thread - Popup Image --*/
  if($('.customise-popup.customise-editor[data-custom="pocket-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="personalise-collar-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="placket-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="thread-btn"]:not(.hide)').length > 0){
    console.log("pocket1",pocket1);
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1,.customise-editor[data-custom="placket-btn"] .customise-left .placket1,.customise-editor[data-custom="thread-btn"] .customise-left .thread1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500'+pocket1);
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket2,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket2,.customise-editor[data-custom="placket-btn"] .customise-left .placket2,.customise-editor[data-custom="thread-btn"] .customise-left .thread2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500'+pocket2);
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket3,.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3,.customise-editor[data-custom="placket-btn"] .customise-left .placket3,.customise-editor[data-custom="thread-btn"] .customise-left .thread3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500'+pocket3);
   }
  

   if(ArrSleeves == 'Short Sleeves' || ArrSleeves == 'Short Sleeve'|| ArrSleeves == 'Short'){
     var pfsbacksleeves = 'bsc-back-sleeves-half.pfs'; 
     pfssleeves = 'bsc-sleeve-half.pfs';
       $('.common-btn-edit.cuff-sleeve-btn').addClass('half');
       $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
       $('[data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('hide');
       $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide');
   } else if(ArrSleeves == 'Long Sleeves' || ArrSleeves == 'Long Sleeve' || ArrSleeves == 'Long'){
     var pfsbacksleeves = 'bsc-back-sleeves-long-regular.pfs';
   }
   if(ArrBack == 'No Pleats'){
     if(ArrBottomCut == 'Tuck In + Out'){
       pfsBottomCut = 'bsc-back-no-pleats.pfs';
     } else { 
       pfsBottomCut = 'bsc-back-no-pleats-long.pfs';
     }  
   } else if(ArrBack == 'Box Pleats'){
     if(ArrBottomCut == 'Tuck In + Out'){
       pfsBottomCut = 'bsc-back-box-pleats.pfs';
     } else { 
       pfsBottomCut = 'bsc-back-box-pleats-long.pfs';
     }
   } else if(ArrBack == 'Side Pleats'){
     if(ArrBottomCut == 'Tuck In + Out'){
       pfsBottomCut = 'bsc-back-side-pleats.pfs';
     } else { 
       pfsBottomCut = 'bsc-back-side-pleats-long.pfs';
     } 
   } else if(ArrBack == 'Darts'){
     if(ArrBottomCut == 'Tuck In + Out'){
       pfsBottomCut = 'bsc-back-darts.pfs';
     } else { 
       pfsBottomCut = 'bsc-back-darts-long.pfs';
     }
   } else if(ArrBack == 'Deep Darts'){
     if(ArrBottomCut == 'Tuck In + Out'){
       pfsBottomCut = 'bsc-back-deep-long.pfs';
     } else { 
       pfsBottomCut = 'bsc-back-deep-darts-long.pfs';
     }
   } 

  if($('.customise-popup.customise-editor[data-custom="back-bottom-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="elbow-patch-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="gusset-btn"]:not(.hide)').length > 0){
     /*-- Back Bottom - Popup Image --*/
     $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
     $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+'&p.tr=True&p.trt=,,45,135');
     $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom3').attr('src',picarioxpo+'bsc-back-collar-polo.pfs?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
     $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom4').attr('src',picarioxpo+pfsbacksleeves+'?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
  
     /*-- elbow-patch - Popup Image --*/
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+'&p.tr=True&p.trt=,,45,135');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch3').attr('src',picarioxpo+'bsc-back-collar-polo.pfs?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch4').attr('src',picarioxpo+pfsbacksleeves+'?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').attr('src',picarioxpo+'bsc-back-elbow-patches.pfs?1=1&width=500&p.tn='+ArrElbowPatchMaterial+'&p.tr=True');
  
     /*-- elbow-patch - Popup Image --*/
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn1').attr('src',picarioxpo+'bsc-gussets-bottom.pfs?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+'&p.trt=,45,135');
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').attr('src',picarioxpo+'bsc-gussets-gussets.pfs?1=1&width=500&p.tn='+ArrGussetMaterial+'&p.tr=True');
   }

   
   if(ArrCuffStyle == 'Single Button Cuff' || ArrCuffStyle == 'Single Button'){
     pfscuff = 'bsc-cuff-single-button.pfs';
     pfsZoomcuff = 'bsc-zoom-cuff-single-button.pfs';
   } else if(ArrCuffStyle == 'Double Button Cuff' || ArrCuffStyle == 'Double Button'){
     pfscuff = 'bsc-cuff-double-button.pfs';
     pfsZoomcuff = 'bsc-zoom-cuff-double-button.pfs';
   } else if(ArrCuffStyle == 'Neapolitan Cuff'){
     pfscuff = 'bsc-cuff-neopolitan.pfs';
     pfsZoomcuff = 'bsc-zoom-cuff-neopolitan.pfs';
   } else if(ArrCuffStyle == 'French Cuff' || ArrCuffStyle == 'French cuff'){
     pfscuff = 'bsc-sleeve-long-cuff-french.pfs';
     pfsZoomcuff = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';
   }
  
  if($('.customise-popup.customise-editor[data-custom="cuff-sleeve-btn"]:not(.hide)').length > 0 || $('.customise-popup.customise-editor[data-custom="contrast-cuff-btn"]:not(.hide)').length > 0){
     /*-- Sleeves - Popup Image --*/
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve1,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve1').attr('src',picarioxpo+'bsc-zoom-cuff-bottom.pfs?1=1&width=500&p.tn='+NewDesignCode);
     if(ArrCuffStyle == 'French Cuff' || ArrCuffStyle == 'French cuff'){
       if(ArrCuffContrast == 'Inside'){
         $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,,#Buttons#,'+ArrButtonThreadColor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+MonogramText+'&p.text.color=,,,,,,,'+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
       } else {
         $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+ArrCuffContrastMaterial+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,,#Buttons#,'+ArrButtonThreadColor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+MonogramText+'&p.text.color=,,,,,,,'+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
       }
     } else if(ArrCuffStyle == 'Neapolitan Cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramText+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
     } else {
       if(ArrCuffContrast == 'Inside'){
         $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramText+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
       } else {
         $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+ArrCuffContrastMaterial+','+ArrCuffContrastMaterial+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramText+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
       }
     }
  
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').attr('src',picarioxpo+pfsZoomsleeves+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
  } 

  setTimeout(function(){
   if($('.customise-popup.customise-editor:not(.hide)').length == 0){
     //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve1').attr('src',picarioxpo+'bsc-bottom.pfs?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+',,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+MonogramColor+','+MonogramColor+','+MonogramColor+'&p.text.font=,,,,,,,,'+MonogramFont+','+MonogramFont+','+MonogramFont+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1');
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve2').attr('src',picarioxpo+pfsFileCollar+'?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True,True,True,True,True');
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve3').attr('src',picarioxpo+pfsFileButton+'?1=1&width=500&p.tn='+ArrButtons+'.jpg&p.c=,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
   } 

    if($('.customise-popup.customise-editor:not(.hide)').length == 0){
     if(ArrPlacket == 'French Placket'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve4').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True');
     } else {
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve4').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True');
     }
     //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve5').attr('src',picarioxpo+'bsc-sleeve-half.pfs?1=1&width=500&p.tn='+NewDesignCode+'&p.tr=True');
   
     if(ArrPocket == 'Single Pocket'){
       if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
        $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,Self&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
       } else {
        $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,Self&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
       }
     } else{
       //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve6').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,Self&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
     }
   }
  },1000)


   
   
   console.log("MonogramStyle",MonogramStyle);
   if(MonogramStyle == "Collar" || $('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
     var personalizeMonogramMain = ',,,,,,,,'+MonogramText+',,,';
     var personalizeMonogramColorMain = ',,,,,,,,'+MonogramColor+',,,';
   } else if(MonogramStyle == "Rib"){
     var personalizeMonogramMain = ',,,,,,,,,'+MonogramText+',,';
     var personalizeMonogramColorMain = ',,,,,,,,,'+MonogramColor+',,';
   } else if(MonogramStyle == "Pocket"){
     var personalizeMonogramMain = ',,,,,,,,,,'+MonogramText+',';
     var personalizeMonogramColorMain = ',,,,,,,,,,'+MonogramColor+',';
   } else if(MonogramStyle == "Chest"){
     var personalizeMonogramMain = ',,,,,,,,,,'+MonogramText;
     var personalizeMonogramColorMain = ',,,,,,,,,,'+MonogramColor;
   } else {
     var personalizeMonogramMain = ',,,,,,,,,,';
     var personalizeMonogramColorMain = ',,,,,,,,,,';
   }
   
   if(ArrCollar == "Outside"){
     var main1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrCollarContrast+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text='+personalizeMonogramMain+'&p.text.color='+personalizeMonogramColorMain+'&p.text.font=,,,,,,,,'+MonogramFont+','+MonogramFont+','+MonogramFont+'&p.text.size=,,,,,,,,250,80,80&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     var main2 = '&p.tn='+ArrCollarContrast+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
      console.log("main1 variant 1");
     var collar2 = '&p.tn='+ArrCollarContrast+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
   } else if(ArrCollar == "Inside"){
     var main1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+ArrCollarContrast+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text='+personalizeMonogramMain+'&p.text.color='+personalizeMonogramColorMain+'&p.text.font=,,,,,,,,'+MonogramFont+','+MonogramFont+','+MonogramFont+'&p.text.size=,,,,,,,,250,80,80&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     var main2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
    console.log("main1 variant 2");

     var collar2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
   } else {
     var main1 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+NewDesignCode+','+ArrPlacketContrastMaterialName+','+ArrPlacketContrastMaterial+',,'+ArrCollarInsidePiping+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text='+personalizeMonogramMain+'&p.text.color='+personalizeMonogramColorMain+'&p.text.font=,,,,,,,,'+MonogramFont+','+MonogramFont+','+MonogramFont+'&p.text.size=,,,,,,,,250,80,80&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
     var main2 = '&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True,True,True,True';
    console.log("main1 variant 3");
    console.log(ArrPlacketContrastMaterialName,"ArrPlacketContrastMaterialName",ArrPlacketContrastMaterial,"ArrPlacketContrastMaterial");
   }
  console.log("ArrCollar",ArrCollar);

   if(ArrCollarTopButton == 'Single Button'){
     var main3 = '&p.tn='+ArrButtons+'.jpg&p.c=,'+ArrButtonThreadColor+',ffffff&p.tr=True,True';
   } else if(ArrCollarTopButton == 'Double Button'){
     var main3 = '&p.tn='+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True';
   }
 setTimeout(function(){
   if($('.customise-popup.customise-editor:not(.hide)').length == 0){
     console.log("main1",main1);
    $('#style .style1,#contrast .contrast1,#personalise .personalise1,[data-custom="personalise-collar-btn"] .personalise-shirt1').attr('src',picarioxpo+'bsc-bottom.pfs?1=1&width=500'+main1);
    console.log("yes found"); 
    $('#style .style2,#contrast .contrast2,#personalise .personalise2,[data-custom="personalise-collar-btn"] .personalise-shirt2').attr('src',picarioxpo+pfsFileCollar+'?1=1&width=500'+main2);
    $('#style .style3,#contrast .contrast3,#personalise .personalise3,[data-custom="personalise-collar-btn"] .personalise-shirt3').attr('src',picarioxpo+pfsFileButton+'?1=1&width=500'+main3);
   }
 },1000)
   if(MonogramStyle == "LEFTCUFF"){
     var MonogramCuff = MonogramText;
   } else {
     var MonogramCuff = "";
   }
    setTimeout(function(){
     if($('.customise-popup.customise-editor:not(.hide)').length == 0){
     if(ArrCuffStyle == 'French Cuff' || ArrCuffStyle == 'French cuff'){
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
       if(ArrCuffContrast == 'Inside'){
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,,#Buttons#,'+ArrButtonThreadColor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');  
       } else {
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+ArrCuffContrastMaterial+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,,#Buttons#,'+ArrButtonThreadColor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+MonogramFont+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
       }
     } else if(ArrCuffStyle == 'Neapolitan Cuff'){
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramCuff+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
     } else {
       if(ArrCuffContrast == 'Inside'){
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrCuffContrastMaterial+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramCuff+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
       } else {
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+ArrCuffContrastMaterial+','+ArrCuffContrastMaterial+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff,&p.tr=True,True&p.text=,,,,,'+MonogramCuff+'&p.text.color=,,,,,'+MonogramColor+'&p.text.font=,,,,,'+MonogramFont+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
       }
     }
  
     if(ArrPlacket == 'French Placket'){
       $('#style .style5,#contrast .contrast5,#personalise .personalise5,[data-custom="personalise-collar-btn"] .personalise-shirt5').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+ArrButtons+'.jpg&p.c=,'+ArrButtonThreadColor+',ffffff&p.tr=True');
     } else {
       $('#style .style5,#contrast .contrast5,#personalise .personalise5,[data-custom="personalise-collar-btn"] .personalise-shirt5').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,'+ArrButtonThreadColor+',ffffff&p.tr=True');
     }
  
     $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo+pfssleeves+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
     if(ArrPocket == 'Single Pocket'){
       console.log("Single Pocket")

       if($('.customise-btn .persolise-pocket').hasClass('added')){
         console.log("ONE");
        var pocket7 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,'+MonogramText+'&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.57&p.text.py=,0.487&p.text.align=,1';
        $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500'+pocket7);
       } else {
         console.log("TWO");
        var pocket7 = '&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+'&p.tr=True&p.text=,&p.text.color=,'+MonogramColor+'&p.text.font=,'+MonogramFont+'&p.text.size=,70&p.text.px=,0.57&p.text.py=,0.487&p.text.align=,1';
        $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
       }
       // $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500'+pocket7);
       
       // $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
     } else{
         console.log("TREE");
       $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+NewDesignCode+','+ArrButtons+'.jpg&p.c=,,,'+ArrButtonThreadColor+',ffffff&p.tr=True,True');
     }

     console.log("ArrPocket",ArrPocket);
     console.log("ArrPlacket",ArrPlacket);  
       
    if(ArrPocket == 'No Pocket'){
      $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').addClass('hide');
      if(ArrPlacket == 'Tuxedo Placket') {
         $('.common-btn-edit.pocket-btn').addClass('hide');
         $('.common-btn-edit.persolise-chest').addClass('hide');
         $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
      }else{
         $('.common-btn-edit.pocket-btn').removeClass('hide');
         $('.common-btn-edit.persolise-chest').removeClass('hide');
         $('[data-alt="Placement Chest"]').closest('.Grid__Cell').removeClass('hide');
      }  
    } else {
      //$('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide');
      if(ArrPlacket != 'Tuxedo Placket') {
        $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide');
        if(ArrPocket == 'Single Pocket'){            
            $('.common-btn-edit.persolise-pocket').removeClass('hide');
            $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
        }else{
          
            $('.common-btn-edit.persolise-pocket').addClass('hide');
            $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
        }
      } else {
          $('.common-btn-edit.persolise-pocket').addClass('hide'); 
          $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
      }

    }
     
   }
     if(ArrSleeves == 'Short Sleeves' || ArrSleeves == 'Short Sleeve'|| ArrSleeves == 'Short'){
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
      
      }
    },1000)

 }


function loaderImages(){
  var activeTabdd = $('.customise-tab-wrap .tab-pane.active').attr('id');
  $('.'+activeTabdd+'1').on('load',function(){$(this).addClass('added');ddtest();});
  //$('.'+activeTabdd+'2').addClass('added');
  $('.'+activeTabdd+'3').on('load',function(){$(this).addClass('added');ddtest();});
  $('.'+activeTabdd+'4').on('load',function(){$(this).addClass('added');ddtest();});
  $('.'+activeTabdd+'5').on('load',function(){$(this).addClass('added');ddtest();});
  $('.'+activeTabdd+'6').on('load',function(){$(this).addClass('added');ddtest();});
  $('.'+activeTabdd+'7').on('load',function(){$(this).addClass('added');ddtest();});
  //var imglength = $('.tab-pane.active .img-btn-wrapper .img-container img').length;
  function ddtest(){
    var addedLength = $('.tab-pane.active .img-btn-wrapper .img-container img.added').length;
    if(addedLength == 6){
      $('.Image__Loader').hide();
      $('.img-btn-wrapper').removeClass('loadimg');
    }
  }
}

   setTimeout(function(){
     refreshMainshirt();
   },200);
 
   $(this).closest('.ProductMeta__Size').addClass('hide');
  $(this).closest('.product-handle-button').addClass('full-btn-atc');
   $('.Customize-Your-Item').addClass('hide');
   // if (window.innerWidth < 768) {
   //   //document.querySelector('#addtocart-handle')?.classList.add('custom-direct-addto-cart');
   // }
   setTimeout(() => {
     if(!document.body.classList.contains("product-quickview")){
       console.log("4156--------------");
       $("html, body").animate({ scrollTop: 0 }, 200);
     }
   }, 400);
   
   $('header').addClass('no-brands');
   $('.header_brand_icon.hidden-tablet-and-up').addClass('hide');
   $('.overlay_cart').addClass('hide');
   $('html').removeClass('overlay_scroll');
   $('.customise-box').removeClass('hide');

  // $(".customise-head .Heading").text(picarioxpo+'bsc-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1');
   $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',picarioxpo+'bsc-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1');
   $('#style .style2,#contrast .contrast2,#personalise .personalise2').attr('src',picarioxpo+pfsFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   $('#style .style3,#contrast .contrast3,#personalise .personalise3').attr('src',picarioxpo+pfsFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   
   if(cuffVar == 'french'){
     $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
   } else {
     $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
   }
   
   $('#style .style5,#contrast .contrast5,#personalise .personalise5').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   $('#style .style6,#contrast .contrast6,#personalise .personalise6').attr('src',picarioxpo+pfssleeves+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
   $('#style .style7,#contrast .contrast7,#personalise .personalise7').attr('src',picarioxpo+pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
 
 
   /*-- Collar Style, Collar Stiffness, Collar Top Button - Popup Image --*/
   // $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   //$('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   //$('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   //$('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
 
   // $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   // $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   // $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   // $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');  
   
   /*-- Pocket - Popup Image --*/
   //$('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
   // $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   //$('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
   
   //$('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
   //$('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   //$('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
   
   
   /*-- placket - Popup Image --*/
   //$('.customise-editor[data-custom="placket-btn"] .customise-left .placket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
   //$('.customise-editor[data-custom="placket-btn"] .customise-left .placket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   //$('.customise-editor[data-custom="placket-btn"] .customise-left .placket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
   
   /*-- Thread - Popup Image --*/
   //$('.customise-editor[data-custom="thread-btn"] .customise-left .thread1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
   //$('.customise-editor[data-custom="thread-btn"] .customise-left .thread2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   //$('.customise-editor[data-custom="thread-btn"] .customise-left .thread3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
   
   
   /*-- Sleeves - Popup Image --*/
   // $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve1,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve1').attr('src',picarioxpo+'bsc-zoom-cuff-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg');
   // if(cuffVar == 'french'){
   //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
   //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
   // } else {
   //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
   // }
   
   //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').attr('src',picarioxpo+pfsZoomsleeves+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
   
   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve1').attr('src',picarioxpo+'bsc-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1');
   //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve2').attr('src',picarioxpo+pfsFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True');
   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve3').attr('src',picarioxpo+pfsFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve4').attr('src',picarioxpo+pfsPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-short-sleeve5').attr('src',picarioxpo+'bsc-sleeve-half.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   
   
   /*-- Back Bottom - Popup Image --*/
   // $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   // $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.tr=True&p.trt=,,45,135');
   // $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom3').attr('src',picarioxpo+'bsc-back-collar-polo.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   // $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom4').attr('src',picarioxpo+'bsc-back-sleeves-long-regular.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   
   /*-- elbow-patch - Popup Image --*/
   //$('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   //$('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.tr=True&p.trt=,,45,135');
   // $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch3').attr('src',picarioxpo+'bsc-back-collar-prince-charlie.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   //$('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch4').attr('src',picarioxpo+'bsc-back-sleeves-long-regular.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').attr('src',picarioxpo+'bsc-back-elbow-patches.pfs?1=1&width=500&p.tn='+elbowPatchDefault+'.jpg&p.tr=True');
   
   /*-- elbow-patch - Popup Image --*/
   // $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn1').attr('src',picarioxpo+'bsc-gussets-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.trt=,45,135');
   
   
 $('.customise-close').click(function(){
       $('#main').removeClass('customiseBox--open');
   $('.customise-box').addClass('hide');
 });

 $('.tgl').click(function() {
   if($(this).is(":checked")) {
     $('.common-btn-edit').addClass('hide');
   } else {
     $('.common-btn-edit').removeClass('hide');
     var ArrSleevesBtn = getParameterByName('imageValue',attributeObj[17]['values']);
     if(ArrSleevesBtn == 'Short' || ArrSleevesBtn == 'Short Sleeve' || ArrSleevesBtn == 'Short Sleeves'){
       $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
     }
     var ArrContrasBtn = getParameterByName('imageValue',attributeObj[3]['values']);
     var ArrTwill = getParameterByName('imageValue',attributeObj[6]['values']);
     console.log("ArrTwill",ArrTwill);
     // if(ArrContrasBtn == 'No Contrast' ){
      if(ArrTwill == 'Twill Tape' ){
         $('.common-btn-edit.persolise-collar').addClass('hide');
      }else{
          $('.common-btn-edit.persolise-collar').removeClass('hide');
      } 
     // }else{
     //   // $('.common-btn-edit.persolise-collar').addClass('hide');
     // }
      
     
     var ArrPocket = getParameterByName('imageValue',attributeObj[10]['values']);
     if(ArrPocket == 'Single Pocket' ){
       $('.common-btn-edit.persolise-pocket').removeClass('hide');
     }else{
       $('.common-btn-edit.persolise-pocket').addClass('hide');
     }
   var ArrCuffStyle = getParameterByName('imageTitle',attributeObj[18]['values']);
   if( ArrCuffStyle == 'Neapolitan Cuff' ){
     $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
     //$('[data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('hide');
   }

    var ArrPlacket = getParameterByName('imageValue',attributeObj[11]['values']);
     console.log("ArrPlacket",ArrPlacket);
     if(ArrPlacket == 'Tuxedo Placket' ){
          $('.common-btn-edit.persolise-pocket').addClass('hide');
          $('.common-btn-edit.persolise-chest').addClass('hide');
          $('.common-btn-edit.pocket-btn').addClass('hide');
          $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
          $('.common-btn-edit.contrast-front-btn').addClass('hide');
     }else{
        if(ArrPocket == 'Single Pocket' ){
          $('.common-btn-edit.persolise-pocket').removeClass('hide');
          $('.common-btn-edit.persolise-chest').addClass('hide');
          $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
        } else if(ArrPocket == 'No Pocket' ){
          $('.common-btn-edit.persolise-pocket').addClass('hide');
          $('.common-btn-edit.persolise-chest').removeClass('hide');
          $('[data-alt="Placement Chest"]').closest('.Grid__Cell').removeClass('hide');
        }else{
            $('.common-btn-edit.persolise-pocket').addClass('hide');
            $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
            
        }
       //$('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide');
       $('.common-btn-edit.pocket-btn').removeClass('hide');
     }
   }
 });
 
 $('.common-btn.cancle').click(function(){
   document.body.classList.remove("customizationOpen");
   //$(this).closest('.common-editable-box').find('.Grid__Cell.active').removeClass('active');
   //$('.fitsmart-button.view-log').removeClass('hide');
   $(this).closest('.customise-popup').addClass('hide');
   if ($( "#Filter_As_Modal" ).hasClass("by-common-btn")) {
     $('#Filter_As_Modal').removeClass('by-common-btn');
     $('.get-size-button').click();
   }
   $('html').removeClass('no-scroll');
   if (window.innerWidth < 768) {
     $('.addtocart-container').show();
   }
 })

 $('.common-btn.apply').click(function(e){
   // document.body.classList.remove("customizationOpen");
   if (window.innerWidth < 768) {
     $('.addtocart-container').show();
   }
   $('html').removeClass('no-scroll');
   var customEdit = $(this).closest('.customise-popup').attr('data-custom');
   console.log('customEdit',customEdit);
   if(customEdit == 'collar-btn'){
     var collarStyle = $('#collar-style .Grid__Cell.active .icon').attr('data-alt');
     var collarBtn = $('#collar-top-button .Grid__Cell.active .icon').attr('data-alt');
     
     var flag = 1;
     if(collarStyle == 'Polo'){
       pfsFileCollar = 'bsc-collar-polo.pfs';
     } else if(collarStyle == 'Prince Charlie') {
       pfsFileCollar = 'bsc-collar-prince-charile.pfs';
     } else if(collarStyle == 'Spread Collar') {
       pfsFileCollar = 'bsc-collar-spread-eagle.pfs';
     } else if(collarStyle == 'Madmen' || collarStyle == 'Madmen Collar'){
   pfsFileCollar = 'bsc-collar-madmen.pfs';
     } else if(collarStyle == 'Hipster'){
       pfsFileCollar = 'bsc-collar-hipster.pfs';
     } else if(collarStyle == 'Hipster Rounded'){
       pfsFileCollar = 'bsc-collar-hipster-rounded.pfs';
     } else if(collarStyle == 'Concealed'){
       pfsFileCollar = 'bsc-collar-concealed-polo.pfs';
     } else if(collarStyle == 'Club Collar'){
       pfsFileCollar = 'bsc-collar-club.pfs';
     } else if(collarStyle == 'Ozwald Boateng'){
       pfsFileCollar = 'bsc-collar-boateng.pfs';
     } else if(collarStyle == 'Tuxedo Collar' || collarStyle == 'Wing Collar'){
       pfsFileCollar = 'bsc-collar-wing-tuxedo.pfs';
     } else if(collarStyle == 'Bandhgala'){
       var flag = 0;
     }
     
     if(collarBtn == 'Single Button'){
       pfsFileButton = 'bsc-collar-base-single-button.pfs';
     } else if(collarBtn == 'Double Button'){
       pfsFileButton = 'bsc-collar-base-double-button.pfs';
     }

    
     if($('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       if(contrastCollarBtn2 == ''){
         contrastCollarBtn2 = collarContrastDefault;
       } else {
         contrastCollarBtn2 = contrastCollarBtn2;
       }
     } else if($('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       contrastCollarBtn2 = designCode;
     } else {
       contrastCollarBtn2 = designCode;
     }
     
     if(flag == 1){
       $('#style .style2,#contrast .contrast2,#personalise .personalise2,[data-custom="personalise-collar-btn"] .personalise-shirt2').removeClass('hide').attr('src',picarioxpo + pfsFileCollar+'?1=1&width=500&p.tn='+contrastCollarBtn2+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     } else {
       $('#style .style2,#contrast .contrast2,#personalise .personalise2,[data-custom="personalise-collar-btn"] .personalise-shirt2').addClass('hide');
     }
     
     $('#style .style3,#contrast .contrast3,#personalise .personalise3,[data-custom="personalise-collar-btn"] .personalise-shirt3').attr('src',picarioxpo + pfsFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.collar-btn').addClass('added');
     
     
     attributeObj[0]['values'][0] =  $('[id="collar-style"] .Grid__Cell.active img').attr('src');
     attributeObj[1]['values'][0] =  $('[id="collar-stiffness"] .Grid__Cell.active img').attr('src');
   attributeObj[2]['values'][0] =  $('[id="collar-top-button"] .Grid__Cell.active img').attr('src');
     
   } else if(customEdit == 'pocket-btn') {
     var pocket = $('#pocket .Grid__Cell.active .icon').attr('data-alt');
     
     var flag = 1;
     if(pocket == 'Single Pocket'){
       pfsZoomPocket = 'bsc-zoom-placket-pocket-single-angled.pfs';
       pfsPocket = 'bsc-pocket-single-angled.pfs';
       btnpockercolor = '';
       $('.common-btn-edit.persolise-pocket').removeClass('hide');
       
       $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').removeClass('hide');
       $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
       
       if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
        var cpquery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
       } else {
        var cpquery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,100&p.text.px=,0.63&p.text.py=,0.47&p.text.align=,1';
       }
       customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
       
     } else if(pocket == 'Single Pocket with Flap'){
       console.log('pocketData');
       pfsZoomPocket = 'bsc-zoom-placket-pocket-single-flap.pfs';
       pfsPocket = 'bsc-pocket-single-flap.pfs';
       btnpockercolor = btncolor+'.jpg';
       $('.common-btn-edit.persolise-pocket').addClass('hide');
       $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
       $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
       
       var cpquery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
       customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
       
     } else if(pocket == 'Double Pocket with Flap'){
       pfsZoomPocket = 'bsc-zoom-placket-pocket-double-flap.pfs';
       pfsPocket = 'bsc-pocket-double-flap.pfs';
       btnpockercolor = btncolor+'.jpg';
       $('.common-btn-edit.persolise-pocket').addClass('hide');
       $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
       $('[data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('hide');
       
       var cpquery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True';
       customPocket = picarioxpo + pfsZoomPocket + shirtWidth + cpquery;
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').removeClass('hide').attr('src',customPocket);
       
     } else if (pocket == 'No Pocket'){
       flag = 0;
       pfsPocket = 'bsc-bottom.pfs';
       $('.common-btn-edit.persolise-pocket').addClass('hide');
       $('[data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('hide');
       $('[data-alt="Placement Chest"]').closest('.Grid__Cell').removeClass('hide');
       
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3,.customise-popup[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').addClass('hide');
     }
     
     if(flag == 1){
       if(btnpockercolor == ''){
         if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
          $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide').attr('src',picarioxpo + pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,50&p.text.px=,0.52&p.text.py=,0.5&p.text.align=,1');
         } else {
          $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide').attr('src',picarioxpo + pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True&p.text=,&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,50&p.text.px=,0.52&p.text.py=,0.5&p.text.align=,1');
         }
       } else {
         $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide').attr('src',picarioxpo + pfsPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btnpockercolor+'&p.c=,,#Buttons#,'+btnthreadcolor+'&p.tr=True');
       }
     } else {
       $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').addClass('hide');
     }
     //12345
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.pocket-btn').addClass('added');
     
     attributeObj[10]['values'][0] =  $('[id="pocket"] .Grid__Cell.active img').attr('src');
     
     /*-- Monogram Update --*/
     var pocketStyleMonogram = getParameterByName('imageValue',attributeObj[10]['values'][0]);
     console.log('pocketStyleMonogram',pocketStyleMonogram);
     // without pocket cheat monoproma
     // if(pocketStyleMonogram == 'Single Pocket with Flap' || pocketStyleMonogram == 'Double Pocket with Flap' || pocketStyleMonogram == 'No Pocket'){
      if(pocketStyleMonogram == 'Single Pocket with Flap' || pocketStyleMonogram == 'Double Pocket with Flap'){
       attributeObj[28]['values'][0] = '';
       attributeObj[28]['values'][2] = '';
     } else if (pocketStyleMonogram == 'No Pocket') {
        if ($(".common-btn-edit.persolise-chest").hasClass("added")) {
          console.log("monogram_update", 'true');
          attributeObj[28]['values'][2] = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
        }else{
          attributeObj[28]['values'][2] = '';
          console.log("monogram_update", 'false');
        }
         if($('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt') == 'Placement Chest'){
         attributeObj[28]['values'][0] = "Chest";
       }else{
         attributeObj[28]['values'][0] = "";
       }
     } else if (pocketStyleMonogram == 'Single Pocket') {
       if($('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
         attributeObj[28]['values'][0] = "Pocket";
         attributeObj[28]['values'][2] = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
       }else{
          attributeObj[28]['values'][0] = "";
       }
       
     }
     
   } else if(customEdit == 'placket-btn' || customEdit == 'thread-btn') {
     var placket = $('#placket .Grid__Cell.active .icon').attr('data-alt');
     
     btncolor = $('#buttons .Grid__Cell.active .icon').attr('data-imagevalue');
     btnthreadcolor = $('#button-thread-color .Grid__Cell.active .icon').attr('data-imagevalue');
     
     if($('#pocket .Grid__Cell.active .icon').attr('data-alt') != 'No Pocket'){
       $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').removeClass('hide');
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').removeClass('hide');
     } else {
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').addClass('hide');
     }
     
     var flag = 1;
     if(placket == 'Regular Placket'){
       pfsPlacket = 'bsc-placket-regular.pfs';
       pfsZoomPlacket = 'bsc-zoom-placket-regular.pfs';
       $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
     } else if(placket == 'French Placket'){
       pfsPlacket = 'bsc-placket-french.pfs';
       pfsZoomPlacket = 'bsc-zoom-placket-french.pfs';
       flag = 0;
       $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
     } else if(placket == 'Concealed Placket'){
       pfsPlacket = 'bsc-placket-concealed.pfs';
       pfsZoomPlacket = 'bsc-zoom-placket-concealed.pfs';
       $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
     } else if (placket == 'Skinny Placket'){
       pfsPlacket = 'bsc-placket-skinny.pfs';
       pfsZoomPlacket = 'bsc-zoom-placket-skinny.pfs';
       $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').removeClass('hide');
     } else if (placket == 'Tuxedo Placket'){
       $('.common-btn-edit.pocket-btn,.common-btn-edit.contrast-front-btn').addClass('hide'); 
       $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket3,.customise-popup[data-custom="placket-btn"] .customise-left .placket3,.customise-popup[data-custom="thread-btn"] .customise-left .thread3').addClass('hide');
       pfsPlacket = 'bsc-placket-tuxedo.pfs';
       pfsZoomPlacket = 'bsc-zoom-placket-tuxedo.pfs';
       
       $('#style .style7,#contrast .contrast7,#personalise .personalise7,[data-custom="personalise-collar-btn"] .personalise-shirt7').addClass('hide');
       console.log("Monogram_Update",placket);
       var getDeafultPocket = getParameterByName('imageTitle',attributeObj[10]['values']);
       console.log("getDeafultPocket",getDeafultPocket);
       if ($(".common-btn-edit.persolise-chest").hasClass("added")) {
          console.log("monogram_update", 'true');
          attributeObj[28]['values'][2] = '';
          attributeObj[28]['values'][0] = '';
        }
       if (getDeafultPocket != 'No Pocket') {
         console.log("other pockets");
         attributeObj[10]['values'][0] = 'https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/79692fc8-b114-2cc4-fffa-b44666476158_Pocket-none.svg?imageTitle=No Pocket?imageValue=No Pocket';
        if ($(".common-btn-edit.persolise-pocket").hasClass("added")) {
          console.log("pocket monogram_update", 'true');
          attributeObj[28]['values'][2] = '';
          attributeObj[28]['values'][0] = '';
        }
       }else{
         console.log("no pockets");
       }
     }
     
     
     var placektZoomquery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True';
     var zoomcustomPlacket = picarioxpo + pfsZoomPlacket + shirtWidth + placektZoomquery;
     $('.customise-popup[data-custom="placket-btn"] .customise-left .placket2').removeClass('hide').attr('src',zoomcustomPlacket);
     $('.customise-popup[data-custom="thread-btn"] .customise-left .thread2').removeClass('hide').attr('src',zoomcustomPlacket);
     $('.customise-popup[data-custom="pocket-btn"] .customise-left .pocket2').removeClass('hide').attr('src',zoomcustomPlacket);
     
     
     var selectedCuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
     if(selectedCuffStyle == 'Single Button Cuff' || selectedCuffStyle == 'Single Button' || selectedCuffStyle == 'Double Button Cuff' || selectedCuffStyle == 'Double Button'){
       
       if(contrastCuffBtn == ''){
         contrastCuffBtn = designCode;
       } 
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
       cuffFabriclist = picarioxpo + pfsZoomcuff + shirtWidth + contrastCuffQuery;
       $('.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2,.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').attr('src',cuffFabriclist);
 
     }

     
     if(flag == 1){
       $('#style .style5,#contrast .contrast5,#personalise .personalise5,[data-custom="personalise-collar-btn"] .personalise-shirt5').removeClass('hide').attr('src',picarioxpo + pfsPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
     } else {
       $('#style .style5,#contrast .contrast5,#personalise .personalise5,[data-custom="personalise-collar-btn"] .personalise-shirt5').removeClass('hide').attr('src',picarioxpo + pfsPlacket+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True');
     }
     
     $('#style .style3,#contrast .contrast3,#personalise .personalise3,[data-custom="personalise-collar-btn"] .personalise-shirt3').attr('src',picarioxpo + pfsFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     
     if($('#cuff-style .Grid__Cell.active .icon').attr('data-alt') == 'French cuff' || $('#cuff-style .Grid__Cell.active .icon').attr('data-alt') == 'French Cuff'){
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         //cuffContrastDefault = $('[data-sublist="contrast-cuff-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');  
       } else if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff') {
         //cuffContrastDefault = $('[data-sublist="contrast-cuff-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
       } else {
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
       }
       
     } else {
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo+pfscuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
     }

     
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       if(collarConstrastColor == undefined){
         collarConstrastColor = designCode;
       } 
       if($('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Polo' || $('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Concealed'){
         var contrastCollarOut = '&p.tn='+collarConstrastColor+'.jpg,'+btncolor+'.jpg&p.tr=True,True,True,True,True';  

         var contrastCollaruk = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOut;
         var contrastCollardefault = picarioxpo + pfsFileCollar + shirtWidth + contrastCollarOut;

         $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('#style .style2,#contrast .contrast2,#personalise .personalise2').attr('src',contrastCollardefault);
       } 

     } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
       var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       if($('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Polo' || $('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Concealed'){
         var contrastCollarOut = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.tr=True,True,True,True,True';  
         var contrastCollaruk = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOut;
         var contrastCollardefault = picarioxpo + pfsFileCollar + shirtWidth + contrastCollarOut;

         $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('#style .style2,#contrast .contrast2,#personalise .personalise2').attr('src',contrastCollardefault);
       }
     } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'No Contrast'){
       var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       if(collarConstrastColor == undefined){
         collarConstrastColor = designCode;
       } 
       if($('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Polo' || $('#collar-style .Grid__Cell.active .icon').attr('data-alt') == 'Concealed'){
         var contrastCollarOut = '&p.tn='+collarConstrastColor+'.jpg,'+btncolor+'.jpg&p.tr=True,True,True,True,True';  

         var contrastCollaruk = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOut;
         var contrastCollardefault = picarioxpo + pfsFileCollar + shirtWidth + contrastCollarOut;

         $('.customise-popup[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('.customise-popup[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src',contrastCollaruk);
         $('#style .style2,#contrast .contrast2,#personalise .personalise2').attr('src',contrastCollardefault);
       } 
     }
     
     
     if(customEdit == 'thread-btn'){
       $(this).closest('.customise-popup').addClass('hide');
       $('.common-btn-edit.thread-btn').addClass('added');
       attributeObj[15]['values'][0] =  $('[id="buttons"] .Grid__Cell.active img').attr('src');
       attributeObj[16]['values'][0] =  $('[id="button-thread-color"] .Grid__Cell.active img').attr('src');
     } else {
       $(this).closest('.customise-popup').addClass('hide');
       $('.common-btn-edit.front-btn').addClass('added');
       attributeObj[11]['values'][0] =  $('[id="placket"] .Grid__Cell.active img').attr('src');
     }
     
   } else if(customEdit == 'cuff-sleeve-btn') {
     var sleeves = $('#sleeves .Grid__Cell.active .icon').attr('data-imagevalue');
     var cuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
     
     var sleevesQuery = ''; 
     var cuffQuery = ''; 
     
     if(sleeves == 'Long' || sleeves == 'Long Sleeve' || sleeves == 'Long Sleeves'){
       pfssleeves = 'bsc-sleeve-long-regular.pfs';
       $('.common-btn-edit.cuff-sleeve-btn').removeClass('half');
       $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
       $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').removeClass('hide');
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
       
       
       if(cuffStyle == 'Single Button Cuff' || cuffStyle == 'Single Button'){
         if(sleeves == 'Long' || sleeves == 'Long Sleeve' || sleeves == 'Long Sleeves'){
           $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
         }

         pfscuff = 'bsc-cuff-single-button.pfs';
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide'); 
         
         if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
           cuffQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff&p.tr=True,True';
         } else if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff') {
           cuffQuery = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff&p.tr=True,True';
         } else {
           cuffQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         }
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo + pfscuff+'?1=1&width=500'+cuffQuery);
         
         
         pfssleeves = 'bsc-sleeve-long-regular.pfs';
         sleevesQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True';
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo + pfssleeves+'?1=1&width=500'+sleevesQuery); 
         
         pfsZoomcuff = 'bsc-zoom-cuff-single-button.pfs';
         var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
         customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
         
       } else if(cuffStyle == 'Double Button Cuff' || cuffStyle == 'Double Button'){
         if(sleeves == 'Long' || sleeves == 'Long Sleeve' || sleeves == 'Long Sleeves'){
           $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
         }
         pfscuff = 'bsc-cuff-double-button.pfs';
         
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide'); 
         
         if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
           cuffQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff&p.tr=True,True';
         } else if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff') {
           cuffQuery = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff&p.tr=True,True';
         } else {
           cuffQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         }
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo + pfscuff+'?1=1&width=500'+cuffQuery);
         
         pfssleeves = 'bsc-sleeve-long-regular.pfs';
         sleevesQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True';
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo + pfssleeves+'?1=1&width=500'+sleevesQuery); 
         
         
         pfsZoomcuff = 'bsc-zoom-cuff-double-button.pfs';
         var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
         customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');


       } else if(cuffStyle == 'Neapolitan Cuff'){
         $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
         pfscuff = 'bsc-cuff-neopolitan.pfs';
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide'); 
         
         cuffQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,389&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo + pfscuff+'?1=1&width=500'+cuffQuery);
         
         pfssleeves = 'bsc-sleeve-long-regular.pfs';
         sleevesQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True';
         $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo + pfssleeves+'?1=1&width=500'+sleevesQuery); 
         
         pfsZoomcuff = 'bsc-zoom-cuff-neopolitan.pfs';
         var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,500&p.text.px=,,,,,0.6&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
         customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
          
       } else if(cuffStyle == 'French Cuff' || cuffStyle == 'French cuff'){
         $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
         //$('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
         
         pfscuff = 'bsc-sleeve-long-cuff-french.pfs';
     $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').addClass('hide'); 
       
         if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
           cuffQuery = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         } else if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff') {
           cuffQuery = '&p.tn='+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         } else {
           cuffQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         }
         $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo + pfscuff+'?1=1&width=500'+cuffQuery);
       
         
         pfsZoomcuff = 'bsc-zoom-cuff-sleeve-long-cuff-french.pfs';
         if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
           var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         } else if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff') {
           var query = '&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         } else {
           var query = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
         }
         customSleeve = picarioxpo + pfsZoomcuff + shirtWidth + query;
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').removeClass('hide').attr('src',customSleeve);
         $('.customise-popup[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-popup[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
       
       }
       
     } else if(sleeves == 'Short' || sleeves == 'Short Sleeve' || sleeves == 'Short Sleeves'){
       console.log('short sleeve')
       pfssleeves = 'bsc-sleeve-half.pfs';
       $('.common-btn-edit.cuff-sleeve-btn').addClass('half');
       $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
       $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide');
       sleevesQuery = '&p.tn='+designCode+'.jpg&p.tr=True';
       //cuffQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,#Buttons#,'+btnthreadcolor+',ffffff&p.tr=True,True';

       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo + pfssleeves+'?1=1&width=500'+sleevesQuery);
   //$('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',picarioxpo + pfscuff+'?1=1&width=500'+sleevesQuery);

       
     } else if(sleeves == 'French'){
       pfssleeves = 'bsc-sleeve-long-cuff-french.pfs';
       $('.common-btn-edit.cuff-sleeve-btn').removeClass('half');
       $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
       $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').removeClass('hide');
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
       sleevesQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',picarioxpo + pfssleeves+'?1=1&width=500'+sleevesQuery);
     }
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.cuff-sleeve-btn').addClass('added');
     
     attributeObj[17]['values'][0] =  $('[id="sleeves"] .Grid__Cell.active img').attr('src');
     attributeObj[18]['values'][0] =  $('[id="cuff-style"] .Grid__Cell.active img').attr('src');
     attributeObj[19]['values'][0] =  $('[id="cuff-stiffness"] .Grid__Cell.active img').attr('src');
     
     /*-- Monogram Update --*/
     var sleevesStyleMonogram = getParameterByName('imageValue',attributeObj[17]['values'][0]);
     if(sleevesStyleMonogram == 'Short' || sleevesStyleMonogram == 'Short Sleeve' || sleevesStyleMonogram == 'Short Sleeves'){
       if(attributeObj[28]['values'][0]=='LEFTCUFF'){
       attributeObj[28]['values'][0] = '';
       attributeObj[28]['values'][2] = '';
       }
     } else {
       if($('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt') == 'Placement Cuff'){
         attributeObj[28]['values'][0] = "LEFTCUFF";
       }
       attributeObj[28]['values'][2] = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
     }
   } else if(customEdit == 'back-bottom-btn') {
     var back = $('#back .Grid__Cell.active .icon').attr('data-alt');
     var bottomCut = $('#bottom-cut .Grid__Cell.active .icon').attr('data-alt');
     var shirtLength = $('#shirt-length .Grid__Cell.active .icon').attr('data-alt');
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.back-bottom-btn').addClass('added');
     
     attributeObj[22]['values'][0] =  $('[id="back"] .Grid__Cell.active img').attr('src');
     attributeObj[23]['values'][0] =  $('[id="bottom-cut"] .Grid__Cell.active img').attr('src');
     attributeObj[29]['values'][0] =  $('[id="shirt-length"] .Grid__Cell.active img').attr('src');
     
   } else if(customEdit == 'personalise-collar-btn'){
     console.log('1244');
     personaliseAlt = $('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt');
     personaliseStyle = $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style');
     personaliseColor = $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box.active').attr('data-color');
     monogramText = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
     
     // if(monogramText == ''){
     //   // $('.customise-popup[data-custom="personalise-collar-btn"]').find('.enter-initial-input').focus();
     //   // $('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').removeClass('hide');
     //   attributeObj[28]['values'][0] = '';
     //   attributeObj[28]['values'][2] = '';
     //   $('[id="personalise"] .common-btn-edit').removeClass('added');
       
     //   return false;
     // } else {
     //   //$('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').addClass('hide');
     // }
     
     $(this).closest('.customise-popup').addClass('hide');
     $('#personalise .customise-btn .common-btn-edit').removeClass('added');
     
     if(personaliseStyle == 'Italic'){
       fontStyle = 'Monotype%20Corsiva';
     } else {
       fontStyle = 'Bell%20MT';
     }
     
     if(personaliseAlt == 'Placement Rib'){
       $('.common-btn-edit.persolise-rib').addClass('added');

       var personaliseEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       personaliseEditMonogram = picarioxpo + pfsBottomCollar + shirtWidth + personaliseEditQuery;      
       $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',personaliseEditMonogram);


       var hideEditMonogramCuff = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       var hideEditcuffmonogram = picarioxpo + pfscuff + shirtWidth + hideEditMonogramCuff;
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',hideEditcuffmonogram);

     } else if(personaliseAlt == 'Placement Collar'){
       $('.common-btn-edit.persolise-collar').addClass('added');

       if($('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){ 
         contrastCollarBtn =  collarContrastDefault;
         var personaliseEdirQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else if($('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
         contrastCollarBtn =  collarContrastDefault;
         var personaliseEdirQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         var personaliseEdirQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }

       
       personaliseEditMonogram = picarioxpo + pfsBottomCollar + shirtWidth + personaliseEdirQuery;
       $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',personaliseEditMonogram);

     } else if(personaliseAlt == 'Placement Cuff'){
       $('.common-btn-edit.persolise-cuff').addClass('added');

       var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,250&p.text.px=,,,,,0.5&p.text.py=,,,,,0.5&p.text.align=,,,,,1';
       var personaliseCuffMonogram = picarioxpo + pfscuff + shirtWidth + personaliseQuery;
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',personaliseCuffMonogram);

       var hideEditMonogramQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       var hideEditmonogram = picarioxpo + pfsBottomCollar + shirtWidth + hideEditMonogramQuery;
       $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',hideEditmonogram);

       console.log("hideEditmonogram",hideEditmonogram);

     } else if(personaliseAlt == 'Placement Pocket'){
       $('.common-btn-edit.persolise-pocket').addClass('added');

       // var personaliseQuery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,50&p.text.px=,0.52&p.text.py=,0.5&p.text.align=,1';
       var personaliseQuery = '&p.tn='+designCode+'.jpg&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.57&p.text.py=,0.487&p.text.align=,1';
       var personalisePocketMonogram = picarioxpo + pfsPocket + shirtWidth + personaliseQuery;
        console.log("personalisePocketMonogram",personalisePocketMonogram)
         $('#style .style7,#contrast .contrast7,#personalise .personalise7').attr('src',personalisePocketMonogram);
     } else if(personaliseAlt == 'Placement Chest'){
         $('.common-btn-edit.persolise-chest').addClass('added');
  
          var personaliseQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,80&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
          var personaliseChestMonogram = picarioxpo + pfsBottomCollar + shirtWidth + personaliseQuery;
          console.log('hideEditmonogram',personaliseChestMonogram);
          $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',personaliseChestMonogram);
     }
       
     console.log("personaliseAlt",personaliseAlt);
     if($('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style') == 'Italic'){
       var fontStyleJson = 'Monotype Corsiva';
     } else {
       var fontStyleJson = 'Bell MT';
     }
     
     var personaliseAltJson = $('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt');
     if(personaliseAltJson == 'Placement Rib'){
   var pStyleJson = "Rib";
     } else if(personaliseAltJson == 'Placement Collar'){
   var pStyleJson = "Collar";
     } else if(personaliseAltJson == 'Placement Cuff'){
   var pStyleJson = "LEFTCUFF";
     } else if(personaliseAltJson == 'Placement Pocket'){
   var pStyleJson = "Pocket";
     } else if(personaliseAltJson == 'Placement Chest'){
   var pStyleJson = "Chest";
     } else {
       var pStyleJson = "";
     }
     
      if(monogramText == ''){
       // $('.customise-popup[data-custom="personalise-collar-btn"]').find('.enter-initial-input').focus();
       // $('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').removeClass('hide');
       attributeObj[28]['values'][0] = '';
       attributeObj[28]['values'][1] = 'Monotype Corsiva';
       attributeObj[28]['values'][2] = '';
       attributeObj[28]['values'][3] = 'DD2D28';
       $('[id="personalise"] .common-btn-edit').removeClass('added');
     } else {
      attributeObj[28]['values'][0] = pStyleJson;
      attributeObj[28]['values'][1] = $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active').attr('data-style');
      attributeObj[28]['values'][2] = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
      attributeObj[28]['values'][3] = $('.color-list-outer-box.active').attr('data-color');
      if(attributeObj[28]['values'][3] == 'C4C4C4'){
        attributeObj[28]['values'][3] = 'self';
      }
       //$('.customise-popup[data-custom="personalise-collar-btn"]').find('.intial-error').addClass('hide');
     }
     

   } else if(customEdit == 'contrast-collar-btn'){
     var activeCollarSide = $(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt');
     var activeCollarPiping = $(this).closest('.common-editable-box').find('#collar-piping .Grid__Cell.active .icon').attr('data-alt');
     
     attributeObj[3]['values'][0] =  $('[id="collar-contrast"] .Grid__Cell.active img').attr('src');
     attributeObj[6]['values'][0] =  $('[id="collar-piping"] .Grid__Cell.active img').attr('src');
     
    // if($('[data-custom="contrast-collar-btn"] .nav-item a.active').attr('data-tag') == "collar-contrast"){
       if(activeCollarSide == 'Inside' || activeCollarSide == 'Outside'){
         var activeContrastFabric = $(this).closest('.common-editable-box').find('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active').length;

         if(activeContrastFabric == 0){
           alert("Please select a contrast/piping fabric");
           return false;
         }
         collarContrastDefault = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         var collarContrastDefaultValue = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-alt')
         
         attributeObj[4]['values'][0] =  collarContrastDefault;
         attributeObj[5]['values'][0] =  collarContrastDefaultValue;
       } else {
         collarContrastDefault = designCode;
         
         attributeObj[4]['values'][0] =  "None";
         attributeObj[5]['values'][0] =  "None";
       }
       
    // } 
     
    // if($('[data-custom="contrast-collar-btn"] .nav-item a.active').attr('data-tag') == "collar-piping"){
       if(activeCollarPiping == "Fabric"){
         var activePipingFabric = $(this).closest('.common-editable-box').find('[data-sublist="collar-piping-fabriclist"] .Grid__Cell.active').length;
         if(activePipingFabric == 0){
           alert("Please select a fabric");
           return false;
         } 
     $('.common-btn-edit.persolise-collar').removeClass('hide');
         $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
         pipingContrastDefault = $('[data-sublist="collar-piping-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         attributeObj[7]['values'][0] =  pipingContrastDefault;
         attributeObj[8]['values'][0] =  "None";
         attributeObj[9]['values'][0] =  "None";
         
       } else if(activeCollarPiping == "Twill Tape"){
         var activePipingFabric = $(this).closest('.common-editable-box').find('[data-sublist="collar-twill-tape-fabriclist"] .Grid__Cell.active').length;
         if(activePipingFabric == 0){
           alert("Please select a twill tape");
           return false;
         } 
         $('.common-btn-edit.persolise-collar').addClass('hide');
         $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
         pipingContrastDefault = $('[data-sublist="collar-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         attributeObj[7]['values'][0] =  pipingContrastDefault;
         attributeObj[8]['values'][0] =  "None";
         attributeObj[9]['values'][0] =  "None";
       } else if(activeCollarPiping == "No Piping"){
         $('.common-btn-edit.persolise-collar').removeClass('hide');
         $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
         attributeObj[7]['values'][0] =  "None";
         attributeObj[8]['values'][0] =  "None";
         attributeObj[9]['values'][0] =  "None";
       }
       
    // }

     if (activeCollarPiping == "Twill Tape") {
       $('.common-btn-edit.persolise-collar').addClass('hide');
       $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
     }else{
       $('.common-btn-edit.persolise-collar').removeClass('hide');
       $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
     }
     // if(activeCollarSide == 'Inside' || activeCollarSide == 'Outside'){
     //   $('.common-btn-edit.persolise-collar').addClass('hide');
     //   $('[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('hide');
     // } else{
     //   $('.common-btn-edit.persolise-collar').removeClass('hide');
     //   $('[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass('hide');
     // }
     
     if(activeCollarSide == 'Inside'){
       var contrastCollarEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       contrastCollarEditQuery = picarioxpo + pfsBottomCollar + shirtWidth + contrastCollarEditQuery;
       
       var contrastEditCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
       contrastEditCollarOutQuery = picarioxpo + pfsFileCollar + shirtWidth + contrastEditCollarOutQuery;
       
     } else if(activeCollarSide == 'Outside'){
       var contrastCollarEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastCollarBtn+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       contrastCollarEditQuery = picarioxpo + pfsBottomCollar + shirtWidth + contrastCollarEditQuery;
       
       var contrastEditCollarOutQuery = '&p.tn='+contrastCollarBtn+'.jpg&p.tr=True,True,True,True,True';
       contrastEditCollarOutQuery = picarioxpo + pfsFileCollar + shirtWidth + contrastEditCollarOutQuery;
     } else {
       var contrastCollarEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+contrastCollarPipingBtn+'&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       contrastCollarEditQuery = picarioxpo + pfsBottomCollar + shirtWidth + contrastCollarEditQuery;
       
       var contrastEditCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
       contrastEditCollarOutQuery = picarioxpo + pfsFileCollar + shirtWidth + contrastEditCollarOutQuery;
     }
     
     $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',contrastCollarEditQuery);
     $('#style .style2,#contrast .contrast2,#personalise .personalise2').attr('src',contrastEditCollarOutQuery);
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.contrast-collar-btn').addClass('added');
     
     /*update mono*/
     var collorContrastMon = getParameterByName('imageValue',attributeObj[3]['values'][0]);
     console.log('collorContrastMon--',collorContrastMon);

     var collorPipingMon = getParameterByName('imageValue',attributeObj[6]['values'][0]);
     console.log('collorPipingMon--',collorPipingMon);

    // if(collorContrastMon == 'Inside' || collorContrastMon == 'Full Collar' || collorPipingMon == 'Fabric' || collorPipingMon == 'Twill Tape'){
     if(collorPipingMon == 'Twill Tape'){
       if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
        // if ($(".common-btn-edit.persolise-collar").hasClass("added")) {
        attributeObj[28]['values'][0] = '';
        attributeObj[28]['values'][2] = '';
       }
     } else {
       if($('.customise-popup[data-custom="personalise-collar-btn"] .Placement__Grid .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
         attributeObj[28]['values'][0] = "Collar";
       }
       attributeObj[28]['values'][2] = $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val();
     }
     
   } else if(customEdit == 'contrast-placket-btn'){
     
     if($('#contrast-placket .Grid__Cell.active .icon').attr('data-alt') == 'No Contrast'){
       contrastPlacketBtn = '';
       contrastPlacketTwillTape = '';
       
       if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
         var colrTwillTape = $('[data-sublist="collar-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code') + '.jpg';
       } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
         var colrTwillTape = $('[data-sublist="collar-piping-fabriclist"] .Grid__Cell.active .icon').attr('data-code') + '.jpg';
       } else {
         var colrTwillTape = '';
       }

       if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
         
       } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
        if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       } else {
         var collarConstrastColor = attributeObj[4]['values'];
       }
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       } else {
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       }
       
       attributeObj[13]['values'][0] =  "";
       attributeObj[14]['values'][0] =  "";
       
     } else {
       if($('#contrast-placket .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape' || $('#contrast-placket .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
         
         if($('#contrast-placket .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
           var activePlacketFabric = $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"] .Grid__Cell.active').length;
           if(activePlacketFabric == 0){
             if($('#contrast-placket .Grid__Cell.active .icon').length == 0){
               $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').addClass('active');
             }
             alert("Contrast fabric for Placket not selected");
             return false;
           } else {
             contrastPlacketBtn = $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"] .Grid__Cell.active .icon').attr('data-code') + '.jpg';
             attributeObj[14]['values'][0] =  $('[data-sublist="placket-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
           }
         } 
         
         if($('#contrast-placket .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
           var activePlacketTwillTape = $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active').length;
           if(activePlacketTwillTape == 0){
             if($('#contrast-placket .Grid__Cell.active .icon').length == 0){
               $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').addClass('active');
             }
             //$('[id="contrast-placket"] [data-alt="Twill Tape"]').closest('.Grid__Cell').removeClass('active');
             alert("Please select a twill tape");
             return false;
           } else {
             contrastPlacketTwillTape = $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code')+ '.jpg';
             attributeObj[13]['values'][0] =  $('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
           }
         }
         
         if($('[data-sublist="placket-fabriclist"]').hasClass('show')){
           var activePlacketFabric = $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"] .Grid__Cell.active').length;
           if(activePlacketFabric == 0){
             if($('#contrast-placket .Grid__Cell.active .icon').length == 0){
               $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').addClass('active');
             }
             //$('[id="contrast-placket"] [data-alt="Fabric"]').closest('.Grid__Cell').removeClass('active');
             alert("Contrast fabric for Placket not selected");
             return false;
           } else {
             contrastPlacketBtn = $(this).closest('.common-editable-box').find('[data-sublist="placket-fabriclist"] .Grid__Cell.active .icon').attr('data-code') + '.jpg';
             attributeObj[14]['values'][0] =  $('[data-sublist="placket-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
           }
         }
         
         if($('[data-sublist="placket-twill-tape-fabriclist"]').hasClass('show')){
           var activePlacketTwillTape = $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active').length;
           if(activePlacketTwillTape == 0){
             
             if($('#contrast-placket .Grid__Cell.active .icon').length == 0){
               $('[id="contrast-placket"] [data-alt="No Contrast"]').closest('.Grid__Cell').addClass('active');
             }
             
             $('[id="contrast-placket"] [data-alt="Twill Tape"]').closest('.Grid__Cell').removeClass('active');
             alert("Please select a twill tape");
             return false;
           } else {
             contrastPlacketTwillTape = $(this).closest('.common-editable-box').find('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code')+ '.jpg';
           }
           attributeObj[13]['values'][0] =  $('[data-sublist="placket-twill-tape-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         }
       }
       
       
       if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape'){
         var colrTwillTape = attributeObj[7]['values'] + '.jpg';
       } else if($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric'){
         var colrTwillTape = attributeObj[7]['values'] + '.jpg';
       } else {
         var colrTwillTape = '';
       }

       if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
         if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
         var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         } else {
           var collarConstrastColor = attributeObj[4]['values'];
         }
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
         
       } else if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
           var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
         } else {
           var collarConstrastColor = attributeObj[4]['values'];
         }
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+collarConstrastColor+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       } else {
         var contrastPlacketEditQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,'+colrTwillTape+'&p.c=,,,,,,&p.tr=True,True,True,True,True,True,True,True&p.tr=True,True,True&p.trt=,,,,,90,90,90&p.text=,,,,,,,,,'+monogramText+',&p.text.color=,,,,,,,,'+personaliseColor+','+personaliseColor+','+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+','+fontStyle+','+fontStyle+'&p.text.size=,,,,,,,,250,80,50&p.text.px=,,,,,,,,0.5,0.48,0.60&p.text.py=,,,,,,,,0.3,0.5,0.49&p.text.align=,,,,,,,,1,1,1';
       }
     }
     
     contrastPlacketEditQuery = picarioxpo + pfsBottomCollar + shirtWidth + contrastPlacketEditQuery;      
     $('#style .style1,#contrast .contrast1,#personalise .personalise1').attr('src',contrastPlacketEditQuery);
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.contrast-front-btn').addClass('added');
     
     console.log($('[id="contrast-placket"] .Grid__Cell.active img').attr('src'));
     
     attributeObj[12]['values'][0] =  $('[id="contrast-placket"] .Grid__Cell.active img').attr('src');
     
     
   } else if(customEdit == 'contrast-cuff-btn'){
     cuffContrastDefault = contrastCuffBtn;
     var selectedCuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
     
     if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Full Cuff' || $('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       var activeContrastCuffFabric = $('[data-sublist="contrast-cuff-fabriclist"] .Grid__Cell.active').length;

       if(activeContrastCuffFabric == 0){
         alert("Contrast fabric for Cuff not selected");
         return false;
       }
       cuffContrastDefault = $('[data-sublist="contrast-cuff-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       attributeObj[21]['values'][0] =  cuffContrastDefault;
     } else {
       attributeObj[21]['values'][0] =  "None";
     }

     if(selectedCuffStyle == 'Single Button Cuff' || selectedCuffStyle == 'Single Button' || selectedCuffStyle == 'Double Button Cuff' || selectedCuffStyle == 'Double Button'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
       
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide');
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').removeClass('hide');
       
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
       contrastCuffEditQuery = picarioxpo + pfscuff + shirtWidth + contrastCuffQuery;      
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').attr('src',contrastCuffEditQuery);
     
     } else if(selectedCuffStyle == 'French Cuff' || selectedCuffStyle == 'French cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
       
       if($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside'){
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       } else {
         contrastCuffQuery = '&p.tn='+designCode+'.jpg,'+contrastCuffBtn+'.jpg,'+contrastCuffBtn+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
       }
   pfscuff = 'bsc-sleeve-long-cuff-french.pfs';
       contrastCuffEditQuery = picarioxpo + pfscuff + shirtWidth + contrastCuffQuery; 
       $('#style .style4,#contrast .contrast4,#personalise .personalise4,[data-custom="personalise-collar-btn"] .personalise-shirt4').addClass('hide');
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').removeClass('hide');
       $('#style .style6,#contrast .contrast6,#personalise .personalise6,[data-custom="personalise-collar-btn"] .personalise-shirt6').attr('src',contrastCuffEditQuery);
     } else if(selectedCuffStyle == 'Neapolitan Cuff'){
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
     }
     
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.contrast-cuff-btn').addClass('added');
     
     attributeObj[20]['values'][0] =  $('[id="contrast-cuff"] .Grid__Cell.active img').attr('src');

     
   } else if(customEdit == 'elbow-patch-btn'){
     
     var activeElbow = $(this).closest('.common-editable-box').find('#elbow-patch .Grid__Cell.active .icon').attr('data-alt');
     
     if(activeElbow == 'Fabric'){
       var subFabricActive = $('[data-sublist="elbow-patch-fabriclist"] .Grid__Cell.active').length;
       if(subFabricActive == 0){
         alert("Fabric/Suede not selected for elbow patch");
           return false;
       }
       elbowPatchDefault = $('[data-custom="elbow-patch-btn"] .contrast-fabrics-list .Grid__Cell.active .icon').attr('data-code');
       attributeObj[25]['values'][0] =  elbowPatchDefault;
     } else if (activeElbow == 'Suede'){
       var subFabricActive = $('[data-sublist="elbow-patch-suede-fabriclist"] .Grid__Cell.active').length;
       if(subFabricActive == 0){
         alert("Fabric/Suede not selected for elbow patch");
           return false;
       }
       elbowPatchDefault = $('[data-custom="elbow-patch-btn"] .contrast-fabrics-list .Grid__Cell.active .icon').attr('data-code');
       attributeObj[25]['values'][0] =  elbowPatchDefault;
     } else if (activeElbow == 'No Elbow Patch'){
       elbowPatchDefault = "";
       attributeObj[25]['values'][0] =  "None";
     }
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.contrast-elbow-btn').addClass('added');
     attributeObj[24]['values'][0] =  $('[id="elbow-patch"] .Grid__Cell.active img').attr('src');
     
   } else if(customEdit == 'gusset-btn'){
     
     var activeGusset = $(this).closest('.common-editable-box').find('#gusset .Grid__Cell.active .icon').attr('data-alt');
     if(activeGusset == 'Fabric'){
       var subGussetActive = $('[data-sublist="gusset-fabriclist"] .Grid__Cell.active').length;
       if(subGussetActive == 0){
         alert("Contrast Fabric for Gusset not selected");
           return false;
       }
       gussetDefault = $('[data-custom="gusset-btn"] .contrast-fabrics-list[data-sublist="gusset-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       attributeObj[27]['values'][0] =  gussetDefault;
     } else if (activeGusset == 'Suede'){
       var subGussetActive = $('[data-sublist="gusset-suede-fabriclist"] .Grid__Cell.active').length;
       if(subGussetActive == 0){
         alert("Please select a Suede");
           return false;
       }
       gussetDefault = $('[data-custom="gusset-btn"] .contrast-fabrics-list[data-sublist="gusset-suede-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
       attributeObj[27]['values'][0] =  gussetDefault;
     } else if (activeGusset == 'No Gusset'){
       gussetDefault = "";
       attributeObj[27]['values'][0] =  "None";
     }
     
     $(this).closest('.customise-popup').addClass('hide');
     $('.common-btn-edit.contrast-gusset-btn').addClass('added');
     attributeObj[26]['values'][0] =  $('[id="gusset"] .Grid__Cell.active img').attr('src');
   }
   
   attrObj(attributeObj);
     loaderImages();


   //Recently Used

   var activegridtape = $('.contrast-fabrics-list.show[data-sublist="placket-twill-tape-fabriclist"] .tab-pane .Grid__Cell.active');

   var  activegridelbowpatch = $('.contrast-fabrics-list.show[data-sublist="elbow-patch-suede-fabriclist"] .tab-pane .Grid__Cell.active'); 

   var  activegridegusset = $('.contrast-fabrics-list.show[data-sublist="gusset-suede-fabriclist"] .tab-pane .Grid__Cell.active'); 

 var  activegridtwill = $('.contrast-fabrics-list.show[data-sublist="collar-twill-tape-fabriclist"] .tab-pane .Grid__Cell.active'); 

   var activegrid = $('.contrast-fabrics-list.show[data-sublist!="collar-piping-fabriclist"] .tab-pane .Grid__Cell.active');

   var activegridpiping = $('.contrast-fabrics-list.show[data-sublist="collar-piping-fabriclist"] .tab-pane .Grid__Cell.active');
   
       
   if(activegridtape.length > 0){
   
     var fetchtext = $(activegridtape).prop('outerHTML');
     localStorage.setItem("htmlrenderttape", fetchtext);
          
     var datacode = $(activegridtape).find('.icon').data('code');
     var flag = 0 ;
     $('.recentlyusedtwill .Grid__Cell').each(function() {
       var finddd = $(this).find('.icon').data('code');         
       if (datacode === finddd){
         flag = 1;
         return false;
       }
     });
     if(!flag){
       $('.recentlyusedtwill .icons').append(localStorage.getItem("htmlrenderttape"));
     }        
     fabricBoxes();
     $('.recentlyusedtwill .fab-detail').removeClass('active');
     
   }
   else if(activegridelbowpatch.length > 0){
  
     return false
   }
   else if(activegridegusset.length > 0){

     return false
   }
   else if(activegridtwill.length > 0 ){
   
     var fetchtext = $(activegridtwill).prop('outerHTML');
     localStorage.setItem("htmlrendertwill", fetchtext);
     
     
     var datacode = $(activegridtwill).find('.icon').data('code');
     var flag = 0 ;
     $('.recentlyusedtwill .Grid__Cell').each(function() {
       var finddd = $(this).find('.icon').data('code');         
       if (datacode === finddd){
         flag = 1;
         return false;
       }
     });
     if(!flag){
       $('.recentlyusedtwill .icons').append(localStorage.getItem("htmlrendertwill"));
     }        
     fabricBoxes();
     $('.recentlyusedtwill .fab-detail').removeClass('active');
     
   }
   else if(activegrid.length > 0){
    
     var fetchtext = $(activegrid).prop('outerHTML');
     localStorage.setItem("htmlrender", fetchtext);

     var datacode = $(activegrid).find('.icon').data('code');
     var flag = 0 ;
     $('.recentlyused .Grid__Cell').each(function() {
       var finddd = $(this).find('.icon').data('code');         
       if (datacode === finddd){
         flag = 1;
         return false;
       }
     });
     if(!flag){
       $('.recentlyused .icons').append(localStorage.getItem("htmlrender"));
     }        
     fabricBoxes();
     $('.recentlyused .fab-detail').removeClass('active');

   }
   else if(activegridpiping.length > 0){
    
     var fetchtext = $(activegridpiping).prop('outerHTML');
     localStorage.setItem("htmlrenderpiping", fetchtext);

     var datacode = $(activegridpiping).find('.icon').data('code');
     var flag = 0 ;
     $('.recentlyusedpiping .Grid__Cell').each(function() {
       var finddd = $(this).find('.icon').data('code');         
       if (datacode === finddd){
         flag = 1;
         return false;
       }
     });
     if(!flag){
       $('.recentlyusedpiping .icons').append(localStorage.getItem("htmlrenderpiping"));
     }        
     fabricBoxes();
     $('.recentlyusedpiping .fab-detail').removeClass('active');

   }
   // if (window.innerWidth < 768) {
   //   $('.addtocart-container').show();
   // }
   
   if ($( "#Filter_As_Modal" ).hasClass("by-common-btn")) {
     $('#Filter_As_Modal').removeClass('by-common-btn');
     $('.get-size-button').click();
   }

   let customiseEditor = e.target.closest('.customise-popup.customise-editor')
   if (customiseEditor) {
     let dataCustom = customiseEditor.dataset.custom;
     let tabPane = customiseEditor.querySelectorAll('.tab-pane');
     if (tabPane) {
       tabPane.forEach(tab=>{
         let activeComoon = tab.querySelector('.comoon-col-space.active .icon');
         if (activeComoon) {
           let dataSet = activeComoon.dataset.alt;
           let id = tab.id;
           if (window.customiseUpdate) {
             window.customiseUpdate.forEach((item,index) => {
               if (id == item.id) {
                 window.customiseUpdate.splice(index, 1); 
               }
             });
           }
           if (dataSet && id && dataCustom) {
             let tabArr = {
               dataCustom,
               id,
               dataSet
             };
             window.customiseUpdate.push(tabArr);
           }
         }
       })
     }
   }
   document.body.classList.remove("customizationOpen");
 });
 
 $('.content-box .tab-pane .icons .Grid__Cell').on("click",function(){
     var findlength = $(this).parents('.common-editable-box').find('.contrast-fabrics-list.show .tab-content .recentlycontent .Grid__Cell').length;
       
   if (findlength != 0){
     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .nav-tabs .nav-item:nth-child(3) a').removeClass('active');
     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .nav-tabs .nav-item .recently').addClass('active');

     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .tab-content>div').removeClass('active');
     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .tab-content .recentlycontent').addClass('active');
     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .tab-content .recentlycontent').removeClass('hide');

     $(this).parents('.common-editable-box').find('.contrast-fabrics-list .tab-content>div:nth-child(2)').addClass('hide');

   }
   else{
    
   }
 });
 
 $('.customise-btn .common-btn-edit').on("click",function(){
   $('.contrast-fabrics-list').removeClass('show');
   if (window.innerWidth < 768) {
     $('.addtocart-container').hide();
   }
 });
 

 const acitveCustomStyle = ()=>{
   console.log('11',window);
    console.log('22',window.customiseUpdate);
   if (window.customiseUpdate) {
     window.customiseUpdate.forEach((item) => {
       let activeDataAlt = $(`[data-custom="${item.dataCustom}"] #${item.id} [data-alt="${item.dataSet}"]`);
       if (!activeDataAlt.closest('comoon-col-space').hasClass('active')) {
         activeDataAlt.click();
       }
     });
   }
 }
 
 $('.common-btn-edit').click(function(){
   //$('.fitsmart-button.view-log').addClass('hide');
   $('#shopify-section-header').removeClass('head-up');
   $('body').addClass('customizationOpen');
   if ($( "#Filter_As_Modal" ).hasClass("open")) {
     $('#Filter_As_Modal').removeClass('open');
     $('#Filter_As_Modal').addClass('by-common-btn');
   }
   
   refreshMainshirt();
   
   //$('.customise-popup.customise-editor .nav-tabs .nav-item').first().find('a').click();
   
   var EditCollarStyle = getParameterByName('imageTitle',attributeObj[0]['values']);
   var EditCollarStiffness = getParameterByName('imageTitle',attributeObj[1]['values']);
   var EditCollarTopButton = getParameterByName('imageTitle',attributeObj[2]['values']);
   
   var EditPocket = getParameterByName('imageTitle',attributeObj[10]['values']);
   var EditPlacket = getParameterByName('imageTitle',attributeObj[11]['values']);
   
   var EditButtons = getParameterByName('imageTitle',attributeObj[15]['values']);
   var EditButtonThreadColor = getParameterByName('imageTitle',attributeObj[16]['values']);
   
   var EditBack = getParameterByName('imageTitle',attributeObj[22]['values']);
   var EditBottomCut = getParameterByName('imageTitle',attributeObj[23]['values']);
   var EditShirtLength = null;
   if(attributeObj[29] != undefined) EditShirtLength = getParameterByName('imageTitle',attributeObj[29]['values']);
   
   var EditSleeves = getParameterByName('imageValue',attributeObj[17]['values']);
   var EditCuffStyle = getParameterByName('imageTitle',attributeObj[18]['values']);
   var EditCuffStiffness = getParameterByName('imageTitle',attributeObj[19]['values']);
   
   var EditCollarContrst = getParameterByName('imageTitle',attributeObj[3]['values']);
   if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
     var EditCollarContrstFabric = "";
   } else {
     var EditCollarContrstFabric = attributeObj[4]['values'];
   }
   console.log("EditCollarContrstFabric___",EditCollarContrstFabric);
   
   var EditCollarPiping = getParameterByName('imageTitle',attributeObj[6]['values']);
   if(attributeObj[7]['values'] == "None" || attributeObj[7]['values'] == ""){
     var EditCollarInsidePiping = "";
   } else {
     var EditCollarInsidePiping = attributeObj[7]['values'];
   }
   console.log("EditCollarInsidePiping__",EditCollarInsidePiping);
   
   
   var EditPlacketContrast = getParameterByName('imageTitle',attributeObj[12]['values']);
   
   if(attributeObj[13]['values'] == "None" || attributeObj[13]['values'] == ""){
     var EditPlacketContrastTwillTape = "";
   } else {
     var EditPlacketContrastTwillTape = attributeObj[13]['values'];
   }

   if(attributeObj[14]['values'] == "None" || attributeObj[14]['values'] == ""){
     var EditPlacketContrastFabric = "";
   } else {
     var EditPlacketContrastFabric = attributeObj[14]['values'];
   }
   
   
   var EditCuffContrast = getParameterByName('imageTitle',attributeObj[20]['values']);
   if(attributeObj[21]['values'] == "None" || attributeObj[21]['values'] == ""){
     var EditCuffContrastMaterial = "";
   } else {
     var EditCuffContrastMaterial = attributeObj[21]['values'];
   }  

   var EditElbowPatch = getParameterByName('imageTitle',attributeObj[24]['values']);
   if(attributeObj[25]['values'] == "None" || attributeObj[25]['values'] == ""){
     var EditElbowPatchMaterial = "";
   } else {
     var EditElbowPatchMaterial = attributeObj[25]['values'];
   }
   
   var EditGusset = getParameterByName('imageTitle',attributeObj[26]['values']);
   if(attributeObj[27]['values'] == "None" || attributeObj[27]['values'] == ""){
     var EditGussetMaterial = "";
   } else {
     var EditGussetMaterial = attributeObj[27]['values'];
   }
   
   if(!document.body.classList.contains("product-quickview")) $('html').addClass('no-scroll');
   $('.customise-popup.customise-editor').addClass('hide');
   
   if($(this).hasClass('collar-btn')) {
    //  $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
    //  $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
    // $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
      $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
     } else {
      $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;'); 
     
      // $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+EditCollarContrstFabric+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;'); 
       
       console.log("yes we found",designCode);
     }

     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

     
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

   //   $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   // $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');  
   
     var lazyImgCollar = document.querySelectorAll("img.lazyimg_collar");  
     console.log('lazyImgCollar',lazyImgCollar);

    lazyImgCollar.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_collar');            
    });

     $('.customise-editor[data-custom="collar-btn"] .nav-tabs .nav-item').first().find('a').click();
     
     $('.customise-editor[data-custom="collar-btn"]').removeClass('hide');
     $('#collar-style [data-alt="'+EditCollarStyle+'"]').click();
     $('#collar-stiffness [data-alt="'+EditCollarStiffness+'"]').click();
     $('#collar-top-button [data-alt="'+EditCollarTopButton+'"]').click();
     // acitveCustomStyle('collar-btn');

     if(EditCollarContrst == 'No Contrast'){
       $('#collar-contrast [data-alt="'+EditCollarContrst+'"]').click();
     } else {
       $('#collar-contrast .Grid__Cell').removeClass('active');
       $('#collar-contrast [data-alt="'+EditCollarContrst+'"]').closest('.Grid__Cell').addClass('active');  
        $('[id="all-fabrics"] [data-code="'+EditCollarContrstFabric[0]+'"]').click();

       console.log("EditCollarContrst",EditCollarContrst);
       
     }
       
     if(EditCollarPiping == 'No Piping'){
       $('#collar-piping [data-alt="'+EditCollarPiping+'"]').click();
     } else {
       $('#collar-piping .Grid__Cell').removeClass('active');
       $('#collar-piping [data-alt="'+EditCollarPiping+'"]').closest('.Grid__Cell').addClass('active');
       if(EditCollarPiping == 'Fabric'){
         $('[id="all-fabrics1"] [data-code="'+EditCollarInsidePiping[0]+'"]').click();
       } else if(EditCollarPiping == 'Twill Tape'){
         $('[id="all-fabrics9"] [data-code="'+EditCollarInsidePiping[0]+'"]').click();
       }
       console.log("EditCollarPiping",EditCollarPiping);
       
     }
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+attributeObj[4]['values']+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     
     }else{
       $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     
     }
      var guidePopup = '';

guidePopup += '<div id="collarGuideLink" class="Popup Popup__Small collarGuideLinkPopup mfp-hide">';
guidePopup += '<div class="modal-header">';
guidePopup += '<h4 class="Heading">COLLAR GUIDE</h4>';
guidePopup += '<a class="Popup__Dismiss collarGuideLinkDismiss" href="javascript:void(0);"><img src="https://cdn.shopify.com/s/files/1/0522/4238/3010/files/close.svg" /></a>';
guidePopup += '</div>';
guidePopup += '<div class="modal-body">';
guidePopup += '<div class="collarGuide-list">';

guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/2eb20aaf-8c30-46c6-8a1f-79c531cee4dc_Collars-PrinceCharlie.svg?imageTitle=Prince Charlie?imageValue=Prince Charlie" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += '<h5>Prince Charlie</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>Classic straight collar is based pair with a suit and tie. It was made famous by British royalty.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/d504cd3f-5027-ac05-2a0b-2561fd8583ec_Collars-Polo.svg?imageTitle=Polo?imageValue=Polo%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += '<h5>The Polo</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>Better known as Button Down collar, it is ideally paired with sports jacket and loafers, but goes well with less dressy suits.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/a7ae42eb-1956-cf82-38bd-8d49c228ef19_Collars-Concealed-Polo.svg?imageTitle=Concealed?imageValue=Concealed" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += '<h5>Concealed Polo</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>A concealed polo collar features the button down on the inside.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/1870cb02-8e16-a928-efa3-b43be04a5e0d_Collars-Madmen.svg?imageTitle=Madmen?imageValue=Madmen%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>The Madmen</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>The Cutaway collar can be worn with a tie to work or without a tie for after work drinks. While wearing a tie, we recommend you use a Windsor knot. </p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/9f92375a-951e-eabe-fd1b-8bb468fd239a_Collars-SpreadEagle.svg?imageTitle=Spread%20Collar?imageValue=Spread%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>The Spread</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>The Spread collar remains a classic men’s staple like the pocket square, hat and custom suit. </p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/5196b551-0a40-ae8f-4758-203209dbc733_Collars-Ozwald%20Boateng.svg?imageTitle=Ozwald%20Boateng?imageValue=Ozwald%20Boateng" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>Ozwald Boateng</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>Designed by its namesake, perhaps the classiest of all our collar offerings.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/14bc5bdb-2089-fff6-c4b6-12878003b513_Collars-Club.svg?imageTitle=Club%20Collar?imageValue=Club%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>Club</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>Made famous by NBA coach Pat Riley, the Rounded or Club collar goes well with bespoke shirts and dressy suits.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/e234a66f-43a7-6389-671e-5d2854487833_Collars-Bandhgala.svg?imageTitle=Bandhgala?imageValue=Bandhgala" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>Bandhgala</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>The traditional Bandh Gala for all the old school folks out there.</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/d7e9a691-56b4-e6d8-b893-2efc56d53271_Collars-Wing.svg?imageTitle=Wing%20Collar?imageValue=Tuxedo%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>Wing collar</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>Our old school Wing Collar is best worn with a tuxedo. Slap on a cool bow tie and transport yourself to the early 1900’s</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-item">';
guidePopup += '<div class="collarGuide-img">';
guidePopup += '<img src="https://bsc-admin-productimagemaster-master.s3.ap-south-1.amazonaws.com/public/attributes/d471034f-e354-3036-dd1a-a0a6605384bd_cuban.svg?imageTitle=Cuban%20Collar?imageValue=Cuban%20Collar" alt="" />';
guidePopup += '</div>';
guidePopup += '<div class="collarGuide-text">';
guidePopup += ' <h5>Cuban Collar</h5>';
guidePopup += '<div class="Rte">';
guidePopup += '<p>The Cuban collar is a more open collar, relaxed style, that sits flat against the body. The collar is wider, its buttons sit lower down on the chest and it has a more relaxed style. It goes well with casual shirts</p>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';
guidePopup += '</div>';

guidePopup += '</div>';
guidePopup += '</div>';
 
 $('.collar_guide').html(guidePopup);
 } else if($(this).hasClass('front-btn')) {

    if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
      $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');

      $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
    } else {

      $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');

      $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');

    }
     

     $('.customise-editor[data-custom="placket-btn"] .customise-left .placket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
     //$('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
     //$('.customise-editor[data-custom="placket-btn"] .customise-left .placket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
    $('.customise-editor[data-custom="placket-btn"] .customise-left .placket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

    var lazyImgPlacket = document.querySelectorAll("img.lazyimg_placket");  
    lazyImgPlacket.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_placket');            
    });
     
     $('.customise-editor[data-custom="placket-btn"]').removeClass('hide');
     $('#placket [data-alt="'+EditPlacket+'"]').click();
     // acitveCustomStyle('front-btn');
   } else if($(this).hasClass('pocket-btn')) {

    var lazyImgPocket = document.querySelectorAll("img.lazyimg_pocket");  
    lazyImgPocket.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_pocket');            
    }); 
     
    if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Pocket'){
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
    } else {
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');

    }
     
   if(getParameterByName('imageTitle',attributeObj[11]['values']) == 'French Placket'){
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   } else {
     $('.customise-editor[data-custom="pocket-btn"] .customise-left .pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
   }
 
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,'+monogramText+'&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .personalise-pocket2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
     
     $('.customise-editor[data-custom="pocket-btn"]').removeClass('hide');
     $('#pocket [data-alt="'+EditPocket+'"]').click();
     // acitveCustomStyle('pocket-btn');
   } else if($(this).hasClass('thread-btn')) {
     $('.customise-editor[data-custom="thread-btn"] .customise-left .thread1').attr('src',picarioxpo+'bsc-zoom-placket-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,,,,&p.trt=,,,90&p.text=,&p.tpy=,,,,,,,0&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,110&p.text.px=,0.7&p.text.py=,0.08&p.text.align=,1');
     $('.customise-editor[data-custom="thread-btn"] .customise-left .thread3').attr('src',picarioxpo+pfsZoomPocket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+'&p.tr=True&p.text=,'+monogramText+'&p.text.color=,'+personaliseColor+'&p.text.font=,'+fontStyle+'&p.text.size=,70&p.text.px=,0.45&p.text.py=,0.5&p.text.align=,1');
     $('.customise-editor[data-custom="thread-btn"] .customise-left .thread2').attr('src',picarioxpo+pfsZoomPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');
     $('.customise-editor[data-custom="thread-btn"] .nav-tabs .nav-item').first().find('a').click();

     var lazyImgThread = document.querySelectorAll("img.lazyimg_btnThread");  
     console.log('lazyImgThread',lazyImgThread);

    lazyImgThread.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_btnThread');            
    });
     
     $('.customise-editor[data-custom="thread-btn"]').removeClass('hide');
     $('#buttons [data-alt="'+EditButtons+'"]').click();
     $('#button-thread-color [data-alt="'+EditButtonThreadColor+'"]').click();
     // acitveCustomStyle('thread-btn');
   } else if($(this).hasClass('cuff-sleeve-btn')) {
     var ArrCuffStyle1 = getParameterByName('imageTitle',attributeObj[18]['values']);
     //  if(cuffVar == 'french'){
     //    console.log('562')
     //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
     //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
     //    $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
     // } else {
     //   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
     // }
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve1,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve1').attr('src',picarioxpo+'bsc-zoom-cuff-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg');
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').attr('src',picarioxpo+pfsZoomsleeves+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');

     var lazyImgCuff = document.querySelectorAll("img.lazyimg_cuffSlBtn");  
    lazyImgCuff.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_cuffSlBtn');            
    });
     
     $('.customise-editor[data-custom="cuff-sleeve-btn"] .nav-tabs .nav-item').first().find('a').click();
     $('.customise-editor[data-custom="cuff-sleeve-btn"]').removeClass('hide'); 

     $('#sleeves [data-alt="'+EditSleeves+'"]').click();
     $('#cuff-style [data-alt="'+EditCuffStyle+'"]').click();
     $('#cuff-stiffness [data-alt="'+EditCuffStiffness+'"]').click();
     // setTimeout(function(){
     if(cuffVar == 'french'){
       $('.common-btn-edit.contrast-cuff-btn').addClass('hide');
     }
     // },500)
    console.log('cuffVar',ArrCuffStyle1);
    if(ArrCuffStyle1 == 'French Cuff'){
        console.log('562')
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
       $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+cuffContrastDefault+'.jpg,'+cuffContrastDefault+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,,#Buttons#,'+btnthreadcolor+',ffffff,#Buttons#&p.tr=True,True,True&p.text=,,,,,,,,'+monogramText+'&p.text.color=,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1');
        $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
     } else {
      $('.common-btn-edit.contrast-cuff-btn').removeClass('hide');
       //$('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2').attr('src',picarioxpo+pfsZoomcuff+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff,&p.tr=True,True&p.text=,,,,,'+monogramText+'&p.text.color=,,,,,'+personaliseColor+'&p.text.font=,,,,,'+fontStyle+'&p.text.size=,,,,,550&p.text.px=,,,,,0.7&p.text.py=,,,,,0.5&p.text.align=,,,,,1');
     }
    //  $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve1,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve1').attr('src',picarioxpo+'bsc-zoom-cuff-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg');
    //  $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').attr('src',picarioxpo+pfsZoomsleeves+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');

     // acitveCustomStyle('cuff-sleeve-btn');
   } else if($(this).hasClass('back-bottom-btn')) {
   $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.tr=True&p.trt=,,45,135');
   $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom3').attr('src',picarioxpo+'bsc-back-collar-polo.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   $('.customise-editor[data-custom="back-bottom-btn"] .customise-left .cuff-back-bottom4').attr('src',picarioxpo+'bsc-back-sleeves-long-regular.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');

    var lazyImgBack = document.querySelectorAll("img.lazyimg_backbtn");  
    lazyImgBack.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_backbtn');            
    });
     
  $('.customise-editor[data-custom="back-bottom-btn"] .nav-tabs .nav-item').first().find('a').click();
   $('.customise-editor[data-custom="back-bottom-btn"]').removeClass('hide');
     $('#back [data-alt="'+EditBack+'"]').click();
     $('#bottom-cut [data-alt="'+EditBottomCut+'"]').click();
     $('#shirt-length [data-alt="'+EditShirtLength+'"]').click();
     // acitveCustomStyle('back-bottom-btn');
   } else if($(this).hasClass('contrast-collar-btn')) {
    
    monogramText = attributeObj[28]['values'][2];
    if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
      $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
    } else {
      $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
    }
     
    $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
    
     //$('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');

     
      btnthreadcolor = $('#button-thread-color .Grid__Cell.active .icon').attr('data-imagevalue');
     if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Single Button'){
        $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     } else if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Double Button'){
       $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn=,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+'&p.tr=True,True');
     }
     
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');  
   
     $('.customise-editor[data-custom="contrast-collar-btn"] .nav-tabs .nav-item').first().find('a').click();
     
     $('[data-custom="contrast-collar-btn"] [data-tag="collar-contrast"]').click();
     
     if(EditCollarContrst == 'No Contrast'){
       $('#collar-contrast [data-alt="'+EditCollarContrst+'"]').click();
     } else {
       $('#collar-contrast .Grid__Cell').removeClass('active');
       $('#collar-contrast [data-alt="'+EditCollarContrst+'"]').closest('.Grid__Cell').addClass('active');  
       setTimeout(function(){$('[id="all-fabrics"] [data-code="'+EditCollarContrstFabric[0]+'"]').click();},500)
     }
       
     if(EditCollarPiping == 'No Piping'){
       $('#collar-piping [data-alt="'+EditCollarPiping+'"]').click();
     } else {
       $('#collar-piping .Grid__Cell').removeClass('active');
       $('#collar-piping [data-alt="'+EditCollarPiping+'"]').closest('.Grid__Cell').addClass('active');
       if(EditCollarPiping == 'Fabric'){
         $('[id="all-fabrics1"] [data-code="'+EditCollarInsidePiping[0]+'"]').click();
       } else if(EditCollarPiping == 'Twill Tape'){
         $('[id="all-fabrics9"] [data-code="'+EditCollarInsidePiping[0]+'"]').click();
       }
     } 
     
     $('.customise-editor[data-custom="contrast-collar-btn"]').removeClass('hide');
     // acitveCustomStyle('contrast-collar-btn');
 } else if($(this).hasClass('contrast-front-btn')) {
     if($('#personalise-placement .Grid__Cell.active .icon').attr('data-alt') == 'Placement Collar'){
      $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
    } else {
      $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
    }
     
   //$('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   //$('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');

     btnthreadcolor = $('#button-thread-color .Grid__Cell.active .icon').attr('data-imagevalue');
     if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Single Button'){
        $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
     } else if(getParameterByName('imageTitle',attributeObj[2]['values']) == 'Double Button'){
       $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn3,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn=,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+'&p.tr=True,True');
     }
     
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn4,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');  
   
     $('[data-custom="contrast-placket-btn"] [data-tag="contrast-placket"]').click();
     
     if(EditPlacketContrast == 'No Contrast'){
       $('#contrast-placket [data-alt="'+EditPlacketContrast+'"]').click();
     } else {
       $('#contrast-placket .Grid__Cell').removeClass('active');
       if(EditPlacketContrastTwillTape != "" && EditPlacketContrastTwillTape != "None"){
         $('#contrast-placket [data-alt="Twill Tape"]').closest('.Grid__Cell').addClass('active');
         console.log('EditPlacketContrastTwillTape',EditPlacketContrastTwillTape[0]);
         $('[id="all-fabrics3"] [data-code="'+EditPlacketContrastTwillTape[0]+'"]').click();
       }
       
       if(EditPlacketContrastFabric != "" && EditPlacketContrastFabric != "None"){
         $('#contrast-placket [data-alt="Fabric"]').closest('.Grid__Cell').addClass('active');
         $('[id="all-fabrics2"] [data-code="'+EditPlacketContrastFabric[0]+'"]').click();
       }
     }
     
     $('.customise-editor[data-custom="contrast-placket-btn"]').removeClass('hide');  
     // acitveCustomStyle('contrast-front-btn');
     if($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside'){
       
       $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+attributeObj[4]['values']+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     }else{
       
     $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2,.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
     }
   } else if($(this).hasClass('contrast-cuff-btn')) {
      $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve1,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve1').attr('src',picarioxpo+'bsc-zoom-cuff-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg');
   $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').attr('src',picarioxpo+pfsZoomsleeves+'?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,,'+btnthreadcolor+',ffffff&p.tr=True,True');
   
     $('[data-custom="contrast-cuff-btn"] [data-tag="contrast-cuff"]').click();
     
     if(EditCuffContrast == 'No Contrast'){
       $('#contrast-cuff [data-alt="'+EditCuffContrast+'"]').click();
     } else {
       $('#contrast-cuff .Grid__Cell').removeClass('active');
       $('#contrast-cuff [data-alt="'+EditCuffContrast+'"]').closest('.Grid__Cell').addClass('active');
       
        $('[id="all-fabrics4"] [data-code="'+EditCuffContrastMaterial[0]+'"]').click();
     }
     
     $('.customise-editor[data-custom="contrast-cuff-btn"]').removeClass('hide');  
     // acitveCustomStyle('contrast-cuff-btn');
   } else if($(this).hasClass('contrast-elbow-btn')) {

     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch4').attr('src',picarioxpo+'bsc-back-sleeves-long-regular.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
     //$('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn1').attr('src',picarioxpo+'bsc-gussets-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.trt=,45,135');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch3').attr('src',picarioxpo+'bsc-back-collar-prince-charlie.pfs?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
     $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch1').attr('src',picarioxpo+pfsBottomCut+'?1=1&width=500&p.tn='+designCode+'.jpg&p.tr=True');
   $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch2').attr('src',picarioxpo+'bsc-back-base.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.tr=True&p.trt=,,45,135');

     
     $('[data-custom="elbow-patch-btn"] [data-tag="elbow-patch"]').click();
     
     if(EditElbowPatch == 'No Elbow Patch'){
       $('#elbow-patch [data-alt="'+EditElbowPatch+'"]').click();
     } else {
       $('#elbow-patch .Grid__Cell').removeClass('active');
       $('#elbow-patch [data-alt="'+EditElbowPatch+'"]').closest('.Grid__Cell').addClass('active');
       if(EditElbowPatch == 'Fabric'){
         $('[id="all-fabrics5"] [data-code="'+EditElbowPatchMaterial[0]+'"]').click();
       } else if(EditElbowPatch == 'Suede'){
         $('[id="all-fabrics6"] [data-code="'+EditElbowPatchMaterial[0]+'"]').click();
       }
     }
     
     $('.customise-editor[data-custom="elbow-patch-btn"]').removeClass('hide'); 
     // acitveCustomStyle('contrast-elbow-btn'); 
   } else if($(this).hasClass('contrast-gusset-btn')) {
     $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn1').attr('src',picarioxpo+'bsc-gussets-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg&p.trt=,45,135');
     
     $('[data-custom="gusset-btn"] [data-tag="gusset"]').click();
     
     if(EditGusset == 'No Gusset'){
       $('#gusset [data-alt="'+EditGusset+'"]').click();
     } else {
       $('#gusset .Grid__Cell').removeClass('active');
       $('#gusset [data-alt="'+EditGusset+'"]').closest('.Grid__Cell').addClass('active');
       
       if(EditGusset == 'Fabric'){
         $('[id="all-fabrics7"] [data-code="'+EditGussetMaterial[0]+'"]').click();
       } else if(EditGusset == 'Suede'){
         $('[id="all-fabrics8"] [data-code="'+EditGussetMaterial[0]+'"]').click();
       }
     }
     
   $('.customise-editor[data-custom="gusset-btn"]').removeClass('hide');  
   // acitveCustomStyle('contrast-gusset-btn');
   } else if($(this).hasClass('persolise-collar')) {

   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

     
     if(attributeObj[28]['values'][3] == 'self'){
       attributeObj[28]['values'][3] = 'C4C4C4';
     }
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').removeClass('hide');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');
     
     
     $('.customise-editor[data-custom="personalise-collar-btn"]').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"]').find('.Grid__Cell').removeClass('active');
     $('.customise-editor[data-custom="personalise-collar-btn"] [data-alt="Placement Collar"]').closest('.Grid__Cell').addClass('active');
     
     $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(attributeObj[28]['values'][2]);
     $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active[data-style="'+attributeObj[28]['values'][1]+'"]').click();
     $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box[data-color="'+attributeObj[28]['values'][3]+'"]').click();
     // acitveCustomStyle('persolise-collar');
     personalizeMonogram();
   } else if($(this).hasClass('persolise-cuff')) {
     if(attributeObj[28]['values'][3] == 'self'){
       attributeObj[28]['values'][3] = 'C4C4C4';
     }
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');
     
   $('.customise-editor[data-custom="personalise-collar-btn"]').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"]').find('.Grid__Cell').removeClass('active');
     $('.customise-editor[data-custom="personalise-collar-btn"] [data-alt="Placement Cuff"]').closest('.Grid__Cell').addClass('active');
     
     $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(attributeObj[28]['values'][2]);
     $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active[data-style="'+attributeObj[28]['values'][1]+'"]').click();
     $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box[data-color="'+attributeObj[28]['values'][3]+'"]').click();
     // acitveCustomStyle('persolise-cuff');
     personalizeMonogram();
   } else if($(this).hasClass('persolise-rib')) {
     if(attributeObj[28]['values'][3] == 'self'){
       attributeObj[28]['values'][3] = 'C4C4C4';
     }
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').addClass('hide');
     
     $('.customise-editor[data-custom="personalise-collar-btn"]').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"]').find('.Grid__Cell').removeClass('active');
     $('.customise-editor[data-custom="personalise-collar-btn"] [data-alt="Placement Rib"]').closest('.Grid__Cell').addClass('active');
     
     $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(attributeObj[28]['values'][2]);
     $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active[data-style="'+attributeObj[28]['values'][1]+'"]').click();
     $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box[data-color="'+attributeObj[28]['values'][3]+'"]').click();
     // acitveCustomStyle('persolise-rib');
   personalizeMonogram();
   } else if($(this).hasClass('persolise-pocket')) {
     if(attributeObj[28]['values'][3] == 'self'){
       attributeObj[28]['values'][3] = 'C4C4C4';
     }
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').removeClass('hide');
     
   $('.customise-editor[data-custom="personalise-collar-btn"]').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"]').find('.Grid__Cell').removeClass('active');
     $('.customise-editor[data-custom="personalise-collar-btn"] [data-alt="Placement Pocket"]').closest('.Grid__Cell').addClass('active');
     
     $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(attributeObj[28]['values'][2]);
     $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active[data-style="'+attributeObj[28]['values'][1]+'"]').click();
     $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box[data-color="'+attributeObj[28]['values'][3]+'"]').click();
     // acitveCustomStyle('persolise-pocket');
     personalizeMonogram();
   } else if($(this).hasClass('persolise-chest')) {
     if(attributeObj[28]['values'][3] == 'self'){
       attributeObj[28]['values'][3] = 'C4C4C4';
     }
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .pshirt').addClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .ppocket').removeClass('hide');
     
   $('.customise-editor[data-custom="personalise-collar-btn"]').removeClass('hide');
     $('.customise-editor[data-custom="personalise-collar-btn"]').find('.Grid__Cell').removeClass('active');
     $('.customise-editor[data-custom="personalise-collar-btn"] [data-alt="Placement Chest"]').closest('.Grid__Cell').addClass('active');
     
     $('.customise-popup[data-custom="personalise-collar-btn"] .enter-initial-input').val(attributeObj[28]['values'][2]);
     $('.customise-popup[data-custom="personalise-collar-btn"] .style-row .style-col.active[data-style="'+attributeObj[28]['values'][1]+'"]').click();
     $('.customise-popup[data-custom="personalise-collar-btn"] .thread-color .color-list-outer-box[data-color="'+attributeObj[28]['values'][3]+'"]').click();
     // acitveCustomStyle('persolise-pocket');
     personalizeMonogram();
   } 
   // acitveCustomStyle('placket-btn');
   // acitveCustomStyle('elbow-patch-btn');
   //acitveCustomStyle();
   if($(this).hasClass('persolise-pocket')) {
   // }else if($(this).hasClass('pocket-btn')){
   } else if($(this).hasClass('persolise-chest')) {
   }else{
     refreshMainshirt();
   }

   // quickviewSliders();
   
 });
   
 $(document).ready(function(){
   $('.nav-item a').click(function(){
     console.log("customise tab a clicked");
     if($(this).closest('.nav-tabs').hasClass('first')){
       var datatabId = $(this).attr('data-tag');
       $(this).closest('.common-editable-box').find('.contrast-fabrics-list').removeClass('show');
       $(this).closest('.common-editable-box').find('.content-box-wrapper').removeClass('hide');
     }

     $(this).closest('.nav-tabs').find('.nav-item a').removeClass('active');
     $(this).addClass('active');
     var tagid = $(this).data('tag');
     console.log("tagid",tagid);
     $(this).closest('.nav-tabs').siblings('.tab-wrap').find('.tab-pane').removeClass('active').addClass('hide');
     $(this).closest('.nav-tabs').siblings('.tab-wrap').find('#'+tagid).addClass('active').removeClass('hide');
     var getcurrntCont = $(".customise-tab-wrap #contrast").find(".common-btn-edit.added").length;

     // if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
     //   $('.customise-btn').find(".common-btn-edit.persolise-collar").removeClass("hide");
     //   $('#personalise-placement').find('.icon[data-alt="Placement Collar"]').closest('.Grid__Cell').removeClass("hide");
       
     // } else {
     //  // $('.customise-btn').find(".common-btn-edit.persolise-collar").addClass("hide");
     //  // $('#personalise-placement').find('.icon[data-alt="Placement Collar"]').closest('.Grid__Cell').addClass("hide");
     // }
     
     console.log("yessss");
     
     // if (getcurrntCont > 0) {
     //   $('.customise-btn').find(".common-btn-edit.persolise-collar").addClass("hide");
     // }else{
     //   $('.customise-btn').find(".common-btn-edit.persolise-collar").removeClass("hide");
     // }

     // quickviewSliders();

     // if pocket selected then monogram will applied only on pocket, not on chest
     if($(`.tab-pane#style .pocket-btn.added`).length > 0 && $(`.customise-editor[data-custom="pocket-btn"] .Grid__Cell.active .icon`).attr("data-imagevalue") != "No Pocket"){
       $(`.tab-pane#personalise .persolise-chest`).addClass("hide");
     }else if($(`.tab-pane#style .pocket-btn.added`).length > 0 && location.href.includes("editCustomisations") == true){
       $(`.tab-pane#personalise .persolise-chest`).addClass("hide");
     }
   });
     $(".guidetab").find(".collarGuideLink").click(function(){
       $(this).closest('.common-editable-box').find('.nav-item a[data-tag="collar-style"]').addClass('active');
    });
   // $('.ProductForm__SizeContent .nav-item a').click(function(){
   //   if($(this).attr('data-tag') == 'two'){
   //     $('.ProductSize__PreferredFit,button.ProductForm__AddToCart').addClass('hide');
   //   } else {
   //     $('.ProductSize__PreferredFit,button.ProductForm__AddToCart').removeClass('hide');
   //   }
   // });

 });

setTimeout(function(){
 $('.icons .icon img').addClass('Image--lazyLoading').after('<span class="Image__Loader loader-icon" style="display:none"></span>');
  console.log('hi');
},1000);

function loaderImagesiconbtn(){
 var imgs = $('.customise-editor:visible .render-img-box .render img:visible'),
   len = imgs.length,
   counter = 0;

[].forEach.call( imgs, function( img ) {
   if(img.complete)
     incrementCounter();
   else
     img.addEventListener( 'load', incrementCounter, false );
} );

function incrementCounter() {
   counter++;
   if ( counter === len ) {
       $('.loader-icon').hide();
  
     $('.icon').removeClass('loadimg');
   }
} 
}

$('.img-btn-wrapper').prepend('<span class="Image__Loader" style="display:none"></span>');

$(document).on('click', '.footer-box .apply' , function() {
 $('.tab-pane.active .img-btn-wrapper').find('.Image__Loader').show();
 $('.tab-pane.active .img-btn-wrapper').addClass('loadimg');
 $('.tab-pane.active .img-btn-wrapper .img-container img').removeClass('added');  
});
 


 $('.collarGuideLink').magnificPopup({
   type: 'inline',
   preloader: false,
   focus: '#username',
   modal: false,
   callbacks: {
     open: function() {
       CustomOpenModalEvent();
       $('html').addClass('Popup_Open'); 
     },
     close: function(){
       CustomCloseModalEvent();
       $('html').removeClass('Popup_Open');
     }
   }
 });

 $(document).on('click', '.collarGuideLinkDismiss', function (e) {
   e.preventDefault();
   $('html').removeClass('no-scroll');
   $.magnificPopup.close();
 });
  var fabricdd = 1;
  // debugger;
 $('[data-tag="contrast"]').click(function(){
    
    var lazyImgContrast = document.querySelectorAll("img.lazyimg_contrast");  
    lazyImgContrast.forEach(function(img) {
      img.src = img.dataset.picario;
      img.classList.remove('lazyimg_contrast');            
    });

        var ArrSleevesBtn2 = getParameterByName('imageValue',attributeObj[17]['values']);
     if(ArrSleevesBtn2 == 'Short' || ArrSleevesBtn2 == 'Short Sleeve' || ArrSleevesBtn2 == 'Short Sleeves'){
     $('.common-btn-edit.persolise-cuff,.common-btn-edit.contrast-elbow-btn,.common-btn-edit.contrast-cuff-btn').addClass('hide');
     }
   
  //var designCode = $('.customizePDP').attr('data-pdp-code');
      function loaderImagesiconbtn() {
        var imgs = $('.customise-editor:visible .render-img-box .render img:visible'),
            len = imgs.length,
            counter = 0;

        [].forEach.call(imgs, function(img) {
            if (img.complete)
                incrementCounter();
            else
                img.addEventListener('load', incrementCounter, false);
        });

        function incrementCounter() {
            counter++;
            if (counter === len) {
                $('.loader-icon').hide();
                $('.icon').removeClass('loadimg');
            }
        }
    }
        function fabricBoxes() {
            
            $('[data-sublist="collar-contrast-fabriclist"] .icons .icon').click(function() {
              console.log('fab box')

                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastCollarBtn = $(this).attr('data-code');
                var newdesignCode = $(this).attr('data-code');

                if ($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                    if ($(".common-btn-edit.persolise-collar").hasClass("added")) {
                      personaliseColor = attributeObj[28]['values'][3];
                    }else{
                      personaliseColor = 'transparent';
                    }
                    console.log("personaliseColor",personaliseColor);
                    contrastCollarQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + contrastCollarPipingBtn + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;

                 if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
                  contrastCollarOutQuery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
                  } else {
                  contrastCollarOutQuery = '&p.tn='+designCode+'.jpg&p.tr=True,True,True,True,True';
                  }
                    contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
                    console.log('contrastCollarInFabriclist',contrastCollarOutFabriclist);
                  
                  } else if ($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside') {
                  if ($(".common-btn-edit.persolise-collar").hasClass("added")) {
                    personaliseColor = attributeObj[28]['values'][3];
                  }else{
                    personaliseColor = 'transparent';
                  } 
                    console.log("personaliseColor",personaliseColor);
                  
                  console.log("newdesignCode",newdesignCode)
                    contrastCollarQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + contrastCollarPipingBtn + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    CollarFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarQuery;
                  
                         if(getParameterByName('imageTitle',attributeObj[0]['values']) == 'Polo' || getParameterByName('imageTitle',attributeObj[0]['values']) == 'Concealed'){
                  contrastCollarOutQuery = '&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True';
                  } else {
                  contrastCollarOutQuery = '&p.tn='+newdesignCode+'.jpg&p.tr=True,True,True,True,True';
                  }
                    contrastCollarOutFabriclist = picarioxpo + pfsZoomFileCollar + shirtWidth + contrastCollarOutQuery;
                   console.log('contrastCollarOutFabriclist',contrastCollarOutFabriclist);
                }

                $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src', CollarFabriclist);
                $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src', CollarFabriclist);
                $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src', CollarFabriclist);
                $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src', CollarFabriclist);


                $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn2').attr('src', contrastCollarOutFabriclist);
                $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn2').attr('src', contrastCollarOutFabriclist);
                $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src', contrastCollarOutFabriclist);
                $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn2').attr('src', contrastCollarOutFabriclist);
            });

            $('[data-sublist="collar-piping-fabriclist"] .icons .icon,[data-sublist="collar-twill-tape-fabriclist"] .icons .icon').click(function() {

                if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape') {
                    $('[data-sublist="collar-piping-fabriclist"] .Grid__Cell.active').removeClass('active');
                } else if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric') {
                    $('[data-sublist="collar-twill-tape-fabriclist"] .Grid__Cell.active').removeClass('active');
                }

                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');

                contrastCollarPipingBtn = $(this).attr('data-code') + '.jpg';

                if ($('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active').length == 0) {
                    contrastCollarBtn = designCode;
                }


                if ($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                    contrastCollarPipingQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + contrastCollarPipingBtn + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else if ($(this).closest('.common-editable-box').find('#collar-contrast .Grid__Cell.active .icon').attr('data-alt') == 'Outside') {
                    contrastCollarPipingQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastCollarBtn + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + contrastCollarPipingBtn + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else {
                    contrastCollarPipingQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + contrastCollarPipingBtn + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                }

                contrastCollarPipingFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastCollarPipingQuery;
                $('.customise-editor[data-custom="contrast-collar-btn"] .customise-left .collar-btn1').attr('src', contrastCollarPipingFabriclist);
                $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .render.collar .collar-btn1').attr('src', contrastCollarPipingFabriclist);
                $('.customise-editor[data-custom="collar-btn"] .customise-left .collar-btn1').attr('src', contrastCollarPipingFabriclist);
                $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src', contrastCollarPipingFabriclist);

            });

            $('[data-sublist="placket-fabriclist"] .icons .icon').click(function() {
                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastPlacketBtn = $(this).attr('data-code') + '.jpg';
                console.log("contrastPlacketBtn",contrastPlacketBtn = $(this).attr('data-code') + '.jpg');

                if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape') {
                    var colrTwillTape = attributeObj[7]['values'] + '.jpg';
                } else if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric') {
                    var colrTwillTape = attributeObj[7]['values'] + '.jpg';
                } else {
                    var colrTwillTape = '';
                }

                if ($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside') {
                  console.log("one");
                    if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
                       var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
                     } else {
                       var collarConstrastColor = attributeObj[4]['values'];
                     }
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + collarConstrastColor + '.jpg,' + collarConstrastColor + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else if ($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                  console.log("two");

                  if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
                   var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
                   } else {
                     var collarConstrastColor = attributeObj[4]['values'];
                   }
                  console.log("collarConstrastColor",collarConstrastColor);
                  console.log("contrastPlacketBtn",contrastPlacketBtn);
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + collarConstrastColor + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else {
                  console.log("treee");
                    
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                }

                //contrastPlacketQuery = '&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+contrastPlacketBtn+','+contrastPlacketTwillTape+',,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                placketFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastPlacketQuery;
                $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src', placketFabriclist);

            });

            $('[data-sublist="placket-twill-tape-fabriclist"] .icons .icon').click(function() {
                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastPlacketTwillTape = $(this).attr('data-code') + '.jpg';

                if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Twill Tape') {
                    var colrTwillTape = attributeObj[7]['values'] + '.jpg';
                } else if ($('[id="collar-piping"] .Grid__Cell.active .icon').attr('data-alt') == 'Fabric') {
                    var colrTwillTape = attributeObj[7]['values'] + '.jpg';
                } else {
                    var colrTwillTape = '';
                }

                if ($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Outside') {
                    if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
                   var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
                   } else {
                     var collarConstrastColor = attributeObj[4]['values'];
                   }
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + collarConstrastColor + '.jpg,' + collarConstrastColor + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else if ($('[id="collar-contrast"] .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                    if(attributeObj[4]['values'] == "None" || attributeObj[4]['values'] == ""){
                   var collarConstrastColor = $('[data-sublist="collar-contrast-fabriclist"] .Grid__Cell.active .icon').attr('data-code');
                   } else {
                     var collarConstrastColor = attributeObj[4]['values'];
                   }
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + collarConstrastColor + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                } else {
                    contrastPlacketQuery = '&p.tn=' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + contrastPlacketBtn + ',' + contrastPlacketTwillTape + ',,' + colrTwillTape + '&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,' + monogramText + '&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,' + personaliseColor + '&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                }

                placketFabriclist = picarioxpo + pfszoomBottomCollar + shirtWidth + contrastPlacketQuery;
                $('.customise-editor[data-custom="contrast-placket-btn"] .customise-left .contrast-placket-btn1').attr('src', placketFabriclist);

            });

            $('[data-sublist="contrast-cuff-fabriclist"] .icons .icon').click(function() {
                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastCuffBtn = $(this).attr('data-code');

                var selectedCuffStyle = $('#cuff-style .Grid__Cell.active .icon').attr('data-alt');
                if (selectedCuffStyle == 'Single Button Cuff' || selectedCuffStyle == 'Single Button' || selectedCuffStyle == 'Double Button Cuff' || selectedCuffStyle == 'Double Button') {
                    $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');

                    if ($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                        contrastCuffQuery = '&p.tn=' + designCode + '.jpg,' + contrastCuffBtn + '.jpg,' + btncolor + '.jpg&p.c=,,,' + btnthreadcolor + ',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    } else {
                        contrastCuffQuery = '&p.tn=' + contrastCuffBtn + '.jpg,' + contrastCuffBtn + '.jpg,' + btncolor + '.jpg&p.c=,,,' + btnthreadcolor + ',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    }
                } else if (selectedCuffStyle == 'French Cuff' || selectedCuffStyle == 'French cuff') {
                    $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').addClass('hide');
                    if ($('#contrast-cuff .Grid__Cell.active .icon').attr('data-alt') == 'Inside') {
                        contrastCuffQuery = '&p.tn=' + designCode + '.jpg,' + contrastCuffBtn + '.jpg,' + designCode + '.jpg,' + designCode + '.jpg,' + btncolor + '.jpg&p.c=,,,,,' + btnthreadcolor + ',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    } else {
                        contrastCuffQuery = '&p.tn=' + designCode + '.jpg,' + contrastCuffBtn + '.jpg,' + contrastCuffBtn + '.jpg,' + designCode + '.jpg,' + btncolor + '.jpg&p.c=,,,,,' + btnthreadcolor + ',ffffff,&p.tr=True,True,True&p.text=,,,,,,,,&p.text.color=,,,,,,,transparent&p.text.font=,,,,,,,,' + fontStyle + '&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1';
                    }
                } else if (selectedCuffStyle == 'Neapolitan Cuff') {
                    $('.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve3,.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve3').removeClass('hide');
                }

                cuffFabriclist = picarioxpo + pfsZoomcuff + shirtWidth + contrastCuffQuery;
                $('.customise-editor[data-custom="contrast-cuff-btn"] .customise-left .contrast-cuff-sleeve2,.customise-editor[data-custom="cuff-sleeve-btn"] .customise-left .cuff-sleeve2').attr('src', cuffFabriclist);

            });

            $('[data-sublist="elbow-patch-fabriclist"] .icons .icon').click(function() {
                $('[data-sublist="elbow-patch-suede-fabriclist"] .Grid__Cell.active').removeClass('active');

                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');

                contrastElbowPatchBtn = $(this).attr('data-code') + '.jpg';
                contrastElbowPatchQuery = '&p.tn=' + contrastElbowPatchBtn + '&p.tr=True';
                ElbowPatchFabriclist = picarioxpo + pfsZoomBackElbowPatches + shirtWidth + contrastElbowPatchQuery;
                $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').removeClass('hide').attr('src', ElbowPatchFabriclist);

            });

            $('[data-sublist="elbow-patch-suede-fabriclist"] .icons .icon').click(function() {
                $('[data-sublist="elbow-patch-fabriclist"] .Grid__Cell.active').removeClass('active');

                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastElbowPatchBtn = $(this).attr('data-code') + '.jpg';
                contrastElbowPatchQuery = '&p.tn=' + contrastElbowPatchBtn + '&p.tr=True';
                ElbowPatchFabriclist = picarioxpo + pfsZoomBackElbowPatches + shirtWidth + contrastElbowPatchQuery;
                $('.customise-editor[data-custom="elbow-patch-btn"] .customise-left .elbow-patch5').removeClass('hide').attr('src', ElbowPatchFabriclist);
            });

            $('[data-sublist="gusset-fabriclist"] .icons .icon').click(function() {
                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastGussetBtn = $(this).attr('data-code') + '.jpg';
                contrastGussetQuery = '&p.tn=' + contrastGussetBtn + '&p.tr=True';
                GussetFabriclist = picarioxpo + pfsZoomGussets + shirtWidth + contrastGussetQuery;
                $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').removeClass('hide').attr('src', GussetFabriclist);

            });

            $('[data-sublist="gusset-suede-fabriclist"] .icons .icon').click(function() {
                $(this).closest('.tab-content').find('.Grid__Cell').removeClass('active');
                $(this).closest('.Grid__Cell').addClass('active');
                contrastGussetBtn = $(this).attr('data-code') + '.jpg';
                contrastGussetQuery = '&p.tn=' + contrastGussetBtn + '&p.tr=True';
                GussetFabriclist = picarioxpo + pfsZoomGussets + shirtWidth + contrastGussetQuery;
                $('.customise-editor[data-custom="gusset-btn"] .customise-left .gusset-btn2').removeClass('hide').attr('src', GussetFabriclist);

            });

            $(".icons .icon").click(function() {
                $('.customise-editor:visible .render-img-box .render img').removeClass('added');
                var notinclud = $(this).attr('data-alt');
                if (notinclud == 'Soft' || notinclud == 'Stiff' || notinclud == 'Bandhgala' || notinclud == 'No Pocket' || notinclud == 'Short Sleeves' || notinclud == 'No Piping' || notinclud == 'No Contrast' || notinclud == 'No Elbow Patch' || notinclud == 'No Gusset') {
                    return false;
                } else {
                    $(this).find('.loader-icon').show();
                    $(this).addClass('loadimg');
                    loaderImagesiconbtn();
                }
            });
          refreshMainshirt();
        }

    if(fabricdd == 1){
    $.ajax({
        url: baseUrlBsc + "/api/v1/extraContrastFabrics",
        async: true,
        type: 'GET',
        contentType: "application/json",
        dataType: "json",
        headers: requestToken,
        success: function(data) {

            var twillTapesObjs = data['twillTapes'];
            var suedesObjs = data['suedes'];

            var twillTapesHTML = '';
            var suedesHTML = '';

            $.each(twillTapesObjs, function(index, twillTapesObj) {
                twillTapesHTML += '<div class="Grid__Cell fab-detail"><div class="icon" data-code="' + twillTapesObj['code'] + '" data-alt="' + twillTapesObj['name'] + '">';
                twillTapesHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + twillTapesObj['imageUrl'] + '"></div>';
                twillTapesHTML += '</div></div>';
            });

            $.each(suedesObjs, function(index, suedesObj) {
                suedesHTML += '<div class="Grid__Cell fab-detail"><div class="icon" data-code="' + suedesObj['code'] + '" data-alt="' + suedesObj['name'] + '">';
                suedesHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + suedesObj['imageUrl'] + '"></div>';
                suedesHTML += '</div></div>';
            });

            $('[data-sublist="collar-twill-tape-fabriclist"] #all-fabrics9 .icons.Grid').html(twillTapesHTML);
            $('[data-sublist="placket-twill-tape-fabriclist"] #all-fabrics3 .icons.Grid').html(twillTapesHTML);
            $('[data-sublist="elbow-patch-suede-fabriclist"] #all-fabrics6 .icons.Grid').html(suedesHTML);
            $('[data-sublist="gusset-suede-fabriclist"] #all-fabrics8 .icons.Grid').html(suedesHTML);

            fabricBoxes();
        },
        error: function(err) {}
    });

    $.ajax({
        // url: baseUrlBsc + "/api/v1/fabrics?usedForContrast=true&status=IN_STOCK&allResults=true",
        // async: true,
        // type: 'GET',
        // contentType: "application/json",
        // dataType: "json",
        // headers: requestToken,
        // url: baseUrlBsc + "/fabric/v2/list?pageNo=1&perPage=100000",
        url: baseUrlBsc + "/fabric/v2/getConstrastOrPipingFabrics",
        async: true,
        type: 'POST',
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          "attributeName": "Contrast Fabric",
        }),
        headers: requestToken,
        success: function(data) {
            var fabricContrastHTML = '';
            var stripesContrastHTML = '';
            var solidsContrastHTML = '';
            var printsContrastHTML = '';
            var checksContrastHTML = '';

            var fabricObjs = data.content;

            $.each(fabricObjs, function(index, fabricObj) {

                console.log(fabricObjs,"fabricObjs");
                
                var imgObjs = fabricObj['productImages'];
                var compositionObj = fabricObj['composition'];

                var newimgObjs = fabricObj['image'];
                var newcompositionObj = fabricObj['composition'];

                // if (fabricObj['usedForContrast']) {
                if (newimgObjs) {
                    fabricContrastHTML += '<div class="Grid__Cell fab-detail" data-filter="' + fabricObj['pattern'] + '"><div class="icon" data-code="' + fabricObj['code'] + '" data-desc="' + fabricObj['description'] + '" data-alt="' + fabricObj['name'] + '">';
                    fabricContrastHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                    fabricContrastHTML += '</div></div>';

                    if (fabricObj['pattern'] == 'Stripes') {
                        stripesContrastHTML += '<div class="Grid__Cell fab-detail" data-filter="' + fabricObj['pattern'] + '"><div class="icon" data-code="' + fabricObj['code'] + '" data-desc="' + fabricObj['description'] + '" data-alt="' + fabricObj['name'] + '">';
                        stripesContrastHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        stripesContrastHTML += '</div></div>';
                    } else if (fabricObj['pattern'] == 'Solids') {
                        solidsContrastHTML += '<div class="Grid__Cell fab-detail" data-filter="' + fabricObj['pattern'] + '"><div class="icon" data-code="' + fabricObj['code'] + '" data-desc="' + fabricObj['description'] + '" data-alt="' + fabricObj['name'] + '">';
                        solidsContrastHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        solidsContrastHTML += '</div></div>';
                    } else if (fabricObj['pattern'] == 'Prints') {
                        printsContrastHTML += '<div class="Grid__Cell fab-detail" data-filter="' + fabricObj['pattern'] + '"><div class="icon" data-code="' + fabricObj['code'] + '" data-desc="' + fabricObj['description'] + '" data-alt="' + fabricObj['name'] + '">';
                        printsContrastHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        printsContrastHTML += '</div></div>';
                    } else if (fabricObj['pattern'] == 'Checks') {
                        checksContrastHTML += '<div class="Grid__Cell fab-detail" data-filter="' + fabricObj['pattern'] + '"><div class="icon" data-code="' + fabricObj['code'] + '" data-desc="' + fabricObj['description'] + '" data-alt="' + fabricObj['name'] + '">';
                        checksContrastHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        checksContrastHTML += '</div></div>';
                    }
                }

            });

            $('[data-sublist="collar-contrast-fabriclist"] #all-fabrics .icons.Grid,[data-sublist="placket-fabriclist"] #all-fabrics2 .icons.Grid,[data-sublist="contrast-cuff-fabriclist"] #all-fabrics4 .icons.Grid,[data-sublist="elbow-patch-fabriclist"] #all-fabrics5 .icons.Grid,[data-sublist="gusset-fabriclist"] #all-fabrics7 .icons.Grid').html(fabricContrastHTML);
            $('[data-sublist="collar-contrast-fabriclist"] #stripes .icons.Grid,[data-sublist="placket-fabriclist"] #stripes2 .icons.Grid,[data-sublist="contrast-cuff-fabriclist"] #stripes4 .icons.Grid,[data-sublist="elbow-patch-fabriclist"] #stripes5 .icons.Grid,[data-sublist="gusset-fabriclist"] #stripes7 .icons.Grid').html(stripesContrastHTML);
            $('[data-sublist="collar-contrast-fabriclist"] #solids .icons.Grid,[data-sublist="placket-fabriclist"] #solids2 .icons.Grid,[data-sublist="contrast-cuff-fabriclist"] #solids4 .icons.Grid,[data-sublist="elbow-patch-fabriclist"] #solids5 .icons.Grid,[data-sublist="gusset-fabriclist"] #solids7 .icons.Grid').html(solidsContrastHTML);
            $('[data-sublist="collar-contrast-fabriclist"] #prints .icons.Grid,[data-sublist="placket-fabriclist"] #prints2 .icons.Grid,[data-sublist="contrast-cuff-fabriclist"] #prints4 .icons.Grid,[data-sublist="elbow-patch-fabriclist"] #prints5 .icons.Grid,[data-sublist="gusset-fabriclist"] #prints7 .icons.Grid').html(printsContrastHTML);
            $('[data-sublist="collar-contrast-fabriclist"] #checks .icons.Grid,[data-sublist="placket-fabriclist"] #checks2 .icons.Grid,[data-sublist="contrast-cuff-fabriclist"] #checks4 .icons.Grid,[data-sublist="elbow-patch-fabriclist"] #checks5 .icons.Grid,[data-sublist="gusset-fabriclist"] #checks7 .icons.Grid').html(checksContrastHTML);


            fabricBoxes();

        },
        error: function(err) {}
    });

    $.ajax({
        // url: baseUrlBsc + "/api/v1/fabrics?usedForPiping=true&status=IN_STOCK&allResults=true",
        // async: true,
        // type: 'GET',
        // contentType: "application/json",
        // dataType: "json",
        // headers: requestToken,
        // url: baseUrlBsc + "/fabric/v2/list?pageNo=1&perPage=100000",
        url: baseUrlBsc + "/fabric/v2/getConstrastOrPipingFabrics",
        async: true,
        type: 'POST',
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
            "attributeName": "Fabric Piping",
        }),
        headers: requestToken,
        success: function(data) {
            var fabricPipingHTML = '';
            var stripesPipingHTML = '';
            var solidsPipingHTML = '';
            var printsPipingHTML = '';
            var checksPipingHTML = '';

            var pipingObjs = data.content;

            $.each(pipingObjs, function(index, pipingObj) {
                var imgObjs = pipingObj['productImages'];

                var newimgObjs = pipingObj['image'];
                // console.log(pipingObj['usedForPiping'],"pipingObj['usedForPiping']");
                
                var compositionObj = pipingObj['composition'];
                var newcompositionObj = pipingObj['name'];


                // if (pipingObj['usedForPiping']) {
                if (newimgObjs) {
                    fabricPipingHTML += '<div class="Grid__Cell fab-detail" data-filter="' + pipingObj['pattern'] + '"><div class="icon" data-code="' + pipingObj['code'] + '" data-desc="' + pipingObj['description'] + '" data-alt="' + pipingObj['name'] + '">';
                    fabricPipingHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                    fabricPipingHTML += '</div></div>';

                    if (pipingObj['pattern'] == 'Stripes') {
                        stripesPipingHTML += '<div class="Grid__Cell fab-detail" data-filter="' + pipingObj['pattern'] + '"><div class="icon" data-code="' + pipingObj['code'] + '" data-desc="' + pipingObj['description'] + '" data-alt="' + pipingObj['name'] + '">';
                        stripesPipingHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        stripesPipingHTML += '</div></div>';
                    } else if (pipingObj['pattern'] == 'Solids') {
                        solidsPipingHTML += '<div class="Grid__Cell fab-detail" data-filter="' + pipingObj['pattern'] + '"><div class="icon" data-code="' + pipingObj['code'] + '" data-desc="' + pipingObj['description'] + '" data-alt="' + pipingObj['name'] + '">';
                        solidsPipingHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        solidsPipingHTML += '</div></div>';
                    } else if (pipingObj['pattern'] == 'Prints') {
                        printsPipingHTML += '<div class="Grid__Cell fab-detail" data-filter="' + pipingObj['pattern'] + '"><div class="icon" data-code="' + pipingObj['code'] + '" data-desc="' + pipingObj['description'] + '" data-alt="' + pipingObj['name'] + '">';
                        printsPipingHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        printsPipingHTML += '</div></div>';
                    } else if (pipingObj['pattern'] == 'Checks') {
                        checksPipingHTML += '<div class="Grid__Cell fab-detail" data-filter="' + pipingObj['pattern'] + '"><div class="icon" data-code="' + pipingObj['code'] + '" data-desc="' + pipingObj['description'] + '" data-alt="' + pipingObj['name'] + '">';
                        checksPipingHTML += '<div class="Image_AspectRatio"><img class="img-responsive fab-swatch" src="' + newimgObjs + '"></div><div class="label-box"><span class="title">' + newcompositionObj + '</span></div>';
                        checksPipingHTML += '</div></div>';
                    }
                }
            });

            $('[data-sublist="collar-piping-fabriclist"] #all-fabrics1 .icons.Grid').html(fabricPipingHTML);
            $('[data-sublist="collar-piping-fabriclist"] #stripes1 .icons.Grid').html(stripesPipingHTML);
            $('[data-sublist="collar-piping-fabriclist"] #solids1 .icons.Grid').html(solidsPipingHTML);
            $('[data-sublist="collar-piping-fabriclist"] #prints1 .icons.Grid').html(printsPipingHTML);
            $('[data-sublist="collar-piping-fabriclist"] #checks1 .icons.Grid').html(checksPipingHTML);

            fabricBoxes();
        },
        error: function(err) {}
    });
    fabricdd++;
  }
    
})
 $('[data-tag="personalise"]').click(function(){

   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn1').attr('src',picarioxpo+'bsc-zoom-collar-bottom.pfs?1=1&width=500&p.tn='+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,'+designCode+'.jpg,,,,&p.tr=True&p.c=,,,,,,&p.trt=,,,,,90,90,90&p.text=,,,,,,,,'+monogramText+'&p.tpy=,,,,,90,90,90&p.text.color=,,,,,,,,'+personaliseColor+'&p.text.font=,,,,,,,,'+fontStyle+'&p.text.size=,,,,,,,,250&p.text.px=,,,,,,,,0.5&p.text.py=,,,,,,,,0.5&p.text.align=,,,,,,,,1" style="z-index: 1;');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn2').attr('src',picarioxpo+pfsZoomFileCollar+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True,True,True,True,True');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn3').attr('src',picarioxpo+pfsZoomFileButton+'?1=1&width=500&p.tn='+btncolor+'.jpg&p.c=,'+btnthreadcolor+',ffffff&p.tr=True,True');
   $('.customise-editor[data-custom="personalise-collar-btn"] .customise-left .collar-btn4').attr('src',picarioxpo+pfsZoomCollarPlacket+'?1=1&width=500&p.tn='+designCode+'.jpg,'+btncolor+'.jpg&p.c=,,'+btnthreadcolor+',ffffff&p.tr=True');

    var loadImgMono = document.querySelectorAll("img.lazyimg_monogram");  
    loadImgMono.forEach(function(img) {
      img.src = img.dataset.imgsrc;
      img.classList.remove('lazyimg_monogram');            
    });
   })
 }); ////ru - Above -- $('.customise-close')
 
/* scroll to size div after login*/

if(window.location.href.indexOf('cpid=1') > 1 && $('.template-product').length > 0 && !document.body.classList.contains("product-quickview")){
$('html, body').animate({
       scrollTop: $(".ProductForm").offset().top
   }, 3000);
}
// window.addEventListener("hashchange", function(e) {
//   console.log('haschange')
//    $('.common-btn.cancle').click();
// })


// back btn click event -- COLL / PDP page
function backButtonClickEvent(){
  $(document).on("click",".Header__Wrapper .back-btn-a",function(e){
    e.preventDefault();
    history.back();
  });
}
backButtonClickEvent();

}// manageCustomize -- end
if(document.body.classList.contains("template-product")){
  manageCustomize();
}